/* ================================================================
   REVOTION Systemkonfigurator — UI/State-Schicht (Vanilla JS, IIFE)
   ----------------------------------------------------------------
   Rechnet NICHTS selbst: alle Ableitungen kommen aus
   window.RevotionEngine (assets/konfigurator-engine.js).
   Katalog: window.REVOTION_CATALOG (rendert die Liquid-Section aus
   den Metaobjects). Strings: window.RV_KONFIG_I18N (Theme-Locales).
   Settings: window.RV_KONFIG_SETTINGS (Section-Schema).
   Design: 1:1-Port des Prototyps Systemkonfigurator.dc.html.
   ================================================================ */
(function () {
  'use strict';

  function boot() {
    var root = document.getElementById('rv-konfigurator');
    if (!root) return;
    var tries = 0;
    (function waitDeps() {
      if (window.RevotionEngine && window.REVOTION_CATALOG) return init(root);
      if (++tries > 200) return;
      setTimeout(waitDeps, 40);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  function init(root) {
    var E = window.RevotionEngine;
    var CAT = window.REVOTION_CATALOG || { products: {}, items: [] };
    var I = window.RV_KONFIG_I18N || {};
    // Shopifys t-Filter HTML-escaped Übersetzungen (außer *_html-Keys) —
    // einmal dekodieren, sonst escaped esc() beim Rendern doppelt (&amp;).
    (function () {
      var ta = document.createElement('textarea');
      Object.keys(I).forEach(function (k) {
        if (typeof I[k] === 'string' && I[k].indexOf('&') !== -1) {
          ta.innerHTML = I[k];
          I[k] = ta.value;
        }
      });
    })();
    /* Der Rechenkern schreibt eigene Notizen in die Belegzeilen („5 Kanäle / Modul",
       „Derzeit ausverkauft" …). Die übersetzten `eng_*`-Schlüssel dorthin durchreichen;
       ohne sie bleibt der Kern bei seiner deutschen Vorgabe. */
    if (E.setTexts) E.setTexts(I);
    var SET = window.RV_KONFIG_SETTINGS || {};
    var AB = (SET.assetsBase || 'https://downloads.revotion.io/konfigurator').replace(/\/$/, '');
    /* ── A/B-Test Beratungs-Karte (Jasper 16.10.2026) ──
       Die Hälfte der Besucher („card") bekommt bei erkanntem Zögern eine kleine Karte mit
       Link zur Terminbuchung, die andere Hälfte („control") nicht — dort wird nur gemessen,
       dass das Zögern erkannt wurde. Aus im Embed (Partnerseiten), bei Automatisierung
       (QA/Playwright) und über den Schalter im Theme-Editor. Test: ?rvk_assist=card|control|off */
    var ASSIST = (function () {
      try {
        if (SET.assistAb === false) return null;
        if (document.documentElement.classList.contains('rvk-embed')) return null;
        var q = (location.search.match(/[?&]rvk_assist=(card|control|off)\b/) || [])[1];
        if (q) return q === 'off' ? null : q;
        if (navigator.webdriver) return null;
        var v = null;
        try { v = localStorage.getItem('rvk_ab_assist'); } catch (e) {}
        if (v !== 'card' && v !== 'control') {
          v = Math.random() < 0.5 ? 'card' : 'control';
          try { localStorage.setItem('rvk_ab_assist', v); } catch (e) {}
        }
        return v;
      } catch (e) { return null; }
    })();
    var assistS = null;   // Zustand der Zögern-Erkennung (assistSetup)
    var MAP_URL = SET.mapUrl || 'https://haendler-map-revotion.revotion.workers.dev';
    var TRACKING_URL = SET.trackingUrl || '';
    var ROOT_URL = (SET.rootUrl || '/').replace(/\/$/, '') + '/';
    var CART_URL = SET.cartUrl || '/cart';
    /* Beträge folgen der Seitensprache: auf /en schrieb der Konfigurator bisher
       „5.354 €", der Warenkorb desselben Shops aber „€5,354" (Befund Live-Test). */
    var MONEY_LOCALE = SET.moneyLocale || SET.locale || 'de-DE';
    /* Beträge bleiben deutsch formatiert (der Shop rechnet in Euro), einfache Zahlen
       wie „6,5 Werkstattstunden" folgen dagegen der Seitensprache: 6.5 h im
       Englischen, 6,5 h im Deutschen, Französischen und Spanischen. */
    var NUM_LOCALE = SET.locale || 'de-DE';
    function nf1(n) {
      try { return Number(n).toLocaleString(NUM_LOCALE, { maximumFractionDigits: 1 }); }
      catch (e) { return String(n); }
    }
    var STORAGE_KEY = 'revotion_config_v2';
    /* Config-Code-API (speichern/wiederherstellen) — dieselbe Worker-Basis wie das
       Tracking, deshalb aus trackingUrl abgeleitet (…/api/konfigurator/event →
       …/api/konfigurator). Ein eigenes Setting überschreibt das bei Bedarf. */
    var CONFIG_API = (function () {
      var explicit = String(SET.configApiUrl || '').replace(/\/+$/, '');
      if (explicit) return explicit;
      var m = /^(.*)\/event$/.exec(String(SET.trackingUrl || ''));
      return m ? m[1] : '';
    })();
    /* Konfigurations-Code: NEU „R-XXXXX" (5 Zeichen, seit 09/2026), ALT „RVT-XXXX-XXXX"
       bleibt gültig — Kunden und Angebote tragen die alten Codes weiter. Alphabet ohne
       0/O/1/I/L (vorlesbar, tippfehlerarm). Der Code ist nur ein SCHLÜSSEL. */
    var CODE_RE = /^R-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{5}$/;
    var CODE_RE_LEGACY = /^RVT-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}$/;
    var CODE_KEY = 'revotion_config_code_v1';   // localStorage: Code + Stand dieser Konfiguration
    function isCode(s) { return CODE_RE.test(s) || CODE_RE_LEGACY.test(s); }
    /* Tippfehler-tolerant wie im Worker: Groß/klein, Leerzeichen, fehlender Bindestrich. */
    function normalizeCode(raw) {
      var v = String(raw == null ? '' : raw).toUpperCase().replace(/[\s_.]+/g, '');
      if (!v) return '';
      if (isCode(v)) return v;
      var bare = v.replace(/-/g, '');
      if (/^RVT[23456789A-Z]{8}$/.test(bare)) { var c1 = 'RVT-' + bare.slice(3, 7) + '-' + bare.slice(7); return CODE_RE_LEGACY.test(c1) ? c1 : ''; }
      if (/^R[23456789A-Z]{5}$/.test(bare)) { var c2 = 'R-' + bare.slice(1); return CODE_RE.test(c2) ? c2 : ''; }
      // Eingefügter Text („Code R-JBFKW", „Ihr Zeichen: RVT-…")? → ersten Code herausziehen.
      // (Kein Lookbehind — ältere Safari-Versionen kennen es nicht.)
      var m = /(?:^|[^23456789A-Z])(RVT-?[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}-?[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}|R-?[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{5})(?![23456789A-Z])/.exec(String(raw == null ? '' : raw).toUpperCase());
      if (m) {
        var f = m[1].replace(/-/g, '');
        var c3 = f.indexOf('RVT') === 0 ? 'RVT-' + f.slice(3, 7) + '-' + f.slice(7) : 'R-' + f.slice(1);
        return isCode(c3) ? c3 : '';
      }
      return '';
    }

    if (!CAT.products || !CAT.products.brain || !CAT.products.brain_lite) {
      var main = document.getElementById('rvk-main');
      if (main) main.insertAdjacentHTML('afterbegin',
        '<div style="background:var(--color-bg-deep);border-radius:24px;padding:26px;color:var(--color-muted);font-size:14px;">' +
        esc(I.catalog_missing || 'Der Konfigurator-Katalog ist noch nicht eingerichtet (Metaobjects konfigurator_produkt / konfigurator_item).') + '</div>');
      return;
    }

    /* ── Icon-Gruppen (1:1 aus dem Prototyp-Katalog, Labels via Locales) ── */
    var ICON_GROUPS = [
      { key: 'geraete', label: 'Geräte', icons: ['X_Device_12V', 'X_Device_230V', 'X_Device_24V', 'X_Device_AirConditioning-1', 'X_Device_AirConditioning-2', 'X_Device_Battery', 'X_Device_Fan', 'X_Device_Heater', 'X_Device_Horn', 'X_Device_MiniBar', 'X_Device_Music', 'X_Device_Router', 'X_Device_Shower', 'X_Device_Tap', 'X_Device_Tap-2', 'X_Device_USBC', 'X_Device_WaterPump', 'X_Device_WiperWash', 'X_Device_Wipers'] },
      { key: 'licht', label: 'Licht', icons: ['X_Light_Ambient', 'X_Light_Cabinet', 'X_Light_DeskLamp', 'X_Light_Dinette', 'X_Light_Empty', 'X_Light_InsideCabinet', 'X_Light_Spot', 'X_Light_Sunshade', 'X_Light_Toilet', 'C_Light_Bottom', 'C_Light_Garage', 'C_Light_Inside', 'C_Light_Roofbed', 'M_Light_Anchor', 'M_Light_Deck', 'M_Light_Front', 'M_Light_Position', 'M_Light_Underwater'] },
      { key: 'temperatur', label: 'Temperatur', icons: ['X_Temp_Battery', 'X_Temp_E-Engine', 'X_Temp_Engine', 'X_Temp_Gear', 'X_Temp_MiniBar', 'X_Temp_Oil', 'X_Temp_Outside', 'X_Temp_Water', 'C_Temp_Axle', 'C_Temp_Inside', 'M_Temp_Inside'] },
      { key: 'energie', label: 'Energie', icons: ['X_Energy_ACPower', 'X_Energy_ElectricRange', 'X_Energy_Flash', 'X_Energy_Voltage'] },
      { key: 'bewegung', label: 'Bewegung', icons: ['X_TwoWay_Bed', 'X_TwoWay_BedAlt', 'X_TwoWay_Lock', 'X_TwoWay_Vent', 'C_TwoWay_RoofBed', 'C_Device_SunShade', 'X_Toggle_Lock', 'X_Toggle_Timer'] },
      { key: 'wasser', label: 'Wasser & Tank', icons: ['X_Utility_Fuel', 'X_Utility_Gas', 'X_Utility_Gauge', 'X_Utility_Height'] },
      { key: 'marine', label: 'Marine', icons: ['M_Device_Anchor', 'M_Device_BilgePump', 'M_Device_DepthSensor'] },
      { key: 'status', label: 'Status & Sonstiges', icons: ['X_Utility_Backup', 'X_Utility_Connection', 'X_Utility_Heart', 'X_Utility_Map', 'X_Utility_Notification', 'X_Utility_OffGrid', 'X_Utility_Trash', 'X_Utility_UnknownIcon', 'C_General_Camper'] }
    ];

    /* ── Helpers ── */
    function t(key, vars) {
      var s = I[key];
      if (s == null || s === '' || s === ('sections.konfigurator.' + key) || /^Translation missing/i.test(String(s))) s = key;
      if (vars) Object.keys(vars).forEach(function (k) { s = s.split('[' + k + ']').join(String(vars[k])); });
      return s;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function el(id) { return document.getElementById(id); }
    /* „1 items" las sich falsch — bei genau einer Position die Einzahl nehmen. */
    function itemCountText(n) {
      return n === 1 ? t('bar_item', { count: n }) : t('bar_items', { count: n });
    }
    function euro(cents) {
      var v = (cents || 0) / 100;
      var frac = Math.abs(v % 1) > 0.0001 ? 2 : 0;
      return v.toLocaleString(MONEY_LOCALE, { minimumFractionDigits: frac, maximumFractionDigits: 2 }) + ' €';
    }
    /* Kampagnen-Preis: Streichpreis + effektiver Preis. Ohne Rabatt (kein
       listCents oder nicht höher) kommt genau das raus, was vorher dastand. */
    function priceHtml(effCents, listCents) {
      if (listCents == null || listCents <= effCents) return esc(euro(effCents));
      return '<s class="rvk-price-was">' + esc(euro(listCents)) + '</s> ' +
             '<span class="rvk-price-now">' + esc(euro(effCents)) + '</span>';
    }
    function uiIcon(n) { return AB + '/icons/' + n; }
    function appIcon(n) {
      if (!n) return '';
      n = String(n);
      if (/^https?:\/\//.test(n)) return n;
      if (!/\.(svg|png|webp)$/i.test(n)) n += '.svg';
      if (n.indexOf('devices/') === 0 || n.indexOf('partner-logos/') === 0 || n.indexOf('hardware/') === 0) return AB + '/' + n;
      return AB + '/app-icons/' + n;
    }
    function logoUrl(n) {
      if (!n) return '';
      if (/^https?:\/\//.test(n)) return n;
      if (n.indexOf('/') >= 0) return AB + '/' + n;
      return AB + '/partner-logos/' + n;
    }
    function lotUrl(n) { return AB + '/lotties/levels/' + n; }
    /* Widget-Vorschauen (Jasper, 13.10.2026): Bei der Messart der Batterie zeigen wir die
       App-Widgets statt der NODE-Hardware — welches Modul im Hintergrund läuft (Battery
       oder High Current, beim Wechselrichter beide), entscheidet die Engine. Gerendert aus
       der echten App-Vorschau, je Sprache, auf R2 unter widget-previews/v1/. */
    function widgetPreview(name) {
      var lang = String(SET.locale || 'de').slice(0, 2).toLowerCase();
      if (['de', 'en', 'fr', 'es'].indexOf(lang) < 0) lang = 'en';
      return AB + '/widget-previews/v2/' + name + '-' + lang + '.png';
    }
    /* Icon-Tag mit Flat-Fallback für App-DS-Icons in Unterordnern (battery/, twoway/, …) */
    function iconTag(name, styleStr, flatFallback) {
      var src = appIcon(name);
      /* Fallback-Kette: Unterordner-Pfade (devices/…) liegen auf R2 evtl. nicht vor.
         Reihenfolge: Flat-Basename → suffix-bereinigter Basename (…_0.svg → ….svg,
         z. B. C_Device_SunShade_0 → C_Device_SunShade) → generischer Ersatz. */
      var chain = [];
      if (String(name).indexOf('/') >= 0) {
        var base = String(name).split('/').pop();
        chain.push(appIcon(base));
        var stripped = base.replace(/_\d+(\.\w+)$/, '$1');
        if (stripped !== base) chain.push(appIcon(stripped));
      }
      if (flatFallback) chain.push(appIcon(flatFallback));
      chain = chain.filter(function (u) { return u && u !== src; });
      var fb = chain.length ? (' data-fb="' + esc(chain.join('|')) + '"') : '';
      return '<img src="' + esc(src) + '"' + fb + ' alt="" style="' + (styleStr || '') + '">';
    }
    function lineImg(src) {
      if (!src) return '';
      if (/^(https?:)?\/\//.test(src)) return src;
      return appIcon(src);
    }
    function extra(item) { return (item && item.extra) || {}; }
    /* Zubehör-Produktbild (echtes Webshop-Bild mit Hintergrund → has-bg), sonst App-Icon */
    function accImgTag(key, styleStr, fallbackIcon) {
      var p = CAT.products[key];
      if (p && p.img) return '<img class="rvk-prod has-bg" src="' + esc(p.img) + '" alt="" style="' + (styleStr || '') + '">';
      return '<img src="' + appIcon(fallbackIcon || 'X_Utility_UnknownIcon') + '" alt="" style="width:30px;height:30px;opacity:.5;">';
    }

    /* ── Produktbild-Priorität (zentrale Fallback-Kette) ──
       1. {{assets_base}}/products/<engine-key>.png  (freigestellte Weclapp-PNGs, R2)
       2. {{assets_base}}/hardware/…                 (Prototyp-Renderings, BRAIN + NODEs)
       3. Shopify featured_image                      (oft MIT Hintergrund → .has-bg)
       onerror-Fallback läuft über data-fb + Capture-Listener unten. */
    var HW_MAP = {
      brain: 'brain.png', brain_lite: 'brain-lite.png', connect: 'node-connect.png',
      switch_single: 'node-switch.png', switch_multi: 'node-switch-multi.png',
      ambient: 'node-ambient.png', ambient_mw: 'node-ambient-multi-white.png',
      level: 'node-level.png', temp: 'node-temp.png', twoway: 'node-twoway.png',
      battery: 'node-battery.png', battery_hc: 'node-battery-high-current.png'
    };
    function productImgSources(key, extraLast) {
      var srcs = [AB + '/products/' + key + '.png'];
      if (HW_MAP[key]) srcs.push(AB + '/hardware/' + HW_MAP[key]);
      var p = CAT.products[key];
      if (p && p.img) srcs.push('!hasbg:' + p.img);
      if (extraLast) srcs.push(extraLast);
      return srcs;
    }
    function productImgTag(key, styleStr, extraLast) {
      var srcs = productImgSources(key, extraLast);
      var first = srcs.shift();
      return '<img class="rvk-prod" src="' + esc(first) + '" data-fb="' + esc(srcs.join('|')) + '" alt="" style="' + (styleStr || '') + '">';
    }
    function setProductImg(imgEl, key) {
      if (!imgEl) return;
      var srcs = productImgSources(key);
      imgEl.classList.remove('has-bg');
      imgEl.classList.add('rvk-prod');
      imgEl.setAttribute('data-fb', srcs.slice(1).join('|'));
      imgEl.src = srcs[0];
    }

    /* ── State ── */
    var state = E.initialState();
    var ui = { barOpen: false, mobilePreview: false, expanded: false, adding: null, draftIcon: 'X_Device_Fan', info: null, liteWarn: false, copied: false, codeCopied: false,
      codeMsg: null, codeLoad: null, codeLoadDraft: '', codeFlash: null, codeRemote: null,
      instAnim: null, instPartner: null, instHow: false };
    var custCounter = 0;
    var prevMulti = null, prevMW = null, prevNodes = null, prevBrain = null, prevFridge = null, prevWkeys = null;
    var started = false;
    var partnerViewTracked = false;
    var mapFrame = null, mapFrameCode = null;
    var live = [], lotties = [], anims = [], lid = 0;

    function saveState() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    function loadState() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        var d = JSON.parse(raw);
        var base = E.initialState();
        Object.keys(base).forEach(function (k) {
          if (d[k] !== undefined) state[k] = d[k];
        });
        state.custom = Object.assign({ schalter: [], lichter: [], tank: [], temp: [], bewegung: [] }, d.custom || {});
        state.led = Object.assign({ rgbw: 0, white: 0, kww: 0 }, d.led || {});
        var ids = [];
        Object.keys(state.custom).forEach(function (c) { (state.custom[c] || []).forEach(function (x) { ids.push(x.id); }); });
        ids.forEach(function (id) { var m = /_(\d+)$/.exec(id); if (m) custCounter = Math.max(custCounter, parseInt(m[1], 10)); });
        return Object.keys(state.sel).length > 0 || state.brainMode !== 'lite' || state.panel != null;
      } catch (e) { return false; }
    }

    /* ══ Konfigurations-Code ═══════════════════════════════════════════════
       Wie beim Automobil-Konfigurator: der Kunde sichert seinen Stand unter
       einem kurzen Code und holt ihn später zurück; der Vertrieb zieht
       denselben Code im CRM und macht daraus ein Angebot.

       SICHERHEIT: Der Code ist nur ein SCHLÜSSEL. Die Konfiguration kommt aus
       dem eigenen Worker, NIE aus der URL — und wird vor dem Übernehmen gegen
       den Katalog geprüft (sanitizeState). Damit bleibt die Regel „Config nur
       aus vertrauenswürdiger Quelle" gewahrt, auch wenn jemand einen Code rät. */
    var savedCode = null;      // Code dieser Konfiguration (für Update statt Neuanlage)
    var savedCodeHash = null;  // E.code(state) beim Speichern → erkennt spätere Änderungen
    var savedCodeExpires = null; // ISO — Ablauf (6 Monate nach letzter Nutzung, Worker verlängert)
    var savedCodeAt = null;      // ISO — letzter gespeicherter Stand
    var codeBusy = false;
    /* Code + Stand überleben das Neuladen der Seite (localStorage). Vorher lebte der Code
       nur im Speicher der Seite → nach Tab-Schließen erzeugte jedes Speichern einen NEUEN
       Code, der alte blieb auf dem alten Stand (Jasper, 07.09.2026: „veraltete Codes im CRM"). */
    function saveCodeMeta() {
      try {
        if (!savedCode) { localStorage.removeItem(CODE_KEY); return; }
        localStorage.setItem(CODE_KEY, JSON.stringify({ code: savedCode, hash: savedCodeHash, expiresAt: savedCodeExpires, updatedAt: savedCodeAt }));
      } catch (e) {}
    }
    function loadCodeMeta() {
      try {
        var d = JSON.parse(localStorage.getItem(CODE_KEY) || 'null');
        if (!d || !isCode(String(d.code || ''))) return;
        if (d.expiresAt && isFinite(Date.parse(d.expiresAt)) && Date.parse(d.expiresAt) < Date.now()) { localStorage.removeItem(CODE_KEY); return; }
        savedCode = String(d.code);
        savedCodeHash = d.hash ? String(d.hash) : null;
        savedCodeExpires = d.expiresAt || null;
        savedCodeAt = d.updatedAt || null;
      } catch (e) {}
    }
    function clearCodeMeta() { savedCode = null; savedCodeHash = null; savedCodeExpires = null; savedCodeAt = null; saveCodeMeta(); }
    function codeStale() { return !!(savedCode && savedCodeHash && savedCodeHash !== E.code(state)); }
    function hasSelection() {
      return Object.keys(state.sel || {}).length > 0 || state.brainMode !== 'lite' || state.panel != null || state.install != null ||
        !!(state.led && (state.led.rgbw || state.led.white || state.led.kww)) || Object.keys(state.ov || {}).length > 0;
    }
    function fmtDateTime(isoStr) {
      try {
        var d = new Date(isoStr);
        if (!isFinite(d.getTime())) return '';
        return d.toLocaleString(MONEY_LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
      } catch (e) { return ''; }
    }
    function fmtDate(isoStr) {
      try {
        var d = new Date(isoStr);
        if (!isFinite(d.getTime())) return '';
        return d.toLocaleDateString(MONEY_LOCALE, { day: '2-digit', month: '2-digit', year: 'numeric' });
      } catch (e) { return ''; }
    }

    /* variantId → SKU (Weclapp-Artikelnummer). Einmal über den ganzen Katalog,
       statt die SKU durch jede der ~20 Zeilen-Erzeugungen zu fädeln. */
    var SKU_BY_VARIANT = (function () {
      var m = {};
      function walk(p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) { if (v && v.id != null) m[String(v.id)] = v.sku || null; });
      }
      Object.keys(CAT.products || {}).forEach(function (k) { walk(CAT.products[k]); });
      (CAT.items || []).forEach(function (it) { walk(it && it.produkt); });
      return m;
    })();

    function itemById(id) {
      var list = CAT.items || [];
      for (var i = 0; i < list.length; i++) if (list[i] && list[i].id === id) return list[i];
      return null;
    }

    /* Fremde Konfiguration → sicherer State. Unbekannte IDs fliegen raus,
       Mengen werden auf max_anzahl geklemmt, Enums gegen Whitelist geprüft. */
    function sanitizeState(raw) {
      var out = E.initialState();
      if (!raw || typeof raw !== 'object') return out;
      var oneOf = function (v, allowed, dflt) { return allowed.indexOf(v) >= 0 ? v : dflt; };
      var int = function (v, lo, hi) {
        var n = parseInt(v, 10);
        if (!isFinite(n)) return lo;
        return Math.max(lo, Math.min(hi, n));
      };

      out.brainMode = oneOf(raw.brainMode, ['lite', 'full', 'own'], 'lite');
      out.voltage = oneOf(raw.voltage, ['12v', '24v'], '12v');
      out.batBms = oneOf(raw.batBms, ['yes', 'no'], null);
      out.batMode = oneOf(raw.batMode, ['hc', 'battery'], null);
      out.thitronikProfinder = oneOf(raw.thitronikProfinder, ['yes', 'no'], null);
      out.panel = oneOf(raw.panel, ['4', '8', 'tablet'], null);
      out.install = oneOf(raw.install, ['self', 'partner'], null);
      out.forceSingleSwitch = raw.forceSingleSwitch === true;
      out.boosterAmp = int(raw.boosterAmp, 0, 200);
      out.tempSensorOv = raw.tempSensorOv == null ? null : int(raw.tempSensorOv, 0, 99);

      // Eigene Verbraucher: Label/Icon sind Freitext → hart begrenzen (esc() beim Rendern).
      // ZUERST, weil ihre IDs (cust_…) gleich darunter in der Auswahl zugelassen werden
      // müssen — sie stehen in keinem Katalog. Vorher flogen sie aus `sel` und ein per
      // Code geladener Ausbau verlor alle selbst angelegten Geräte (weniger Kanäle →
      // weniger NODE-Module → fehlende Positionen nach dem Aktualisieren).
      var customIds = {};
      var cats = ['schalter', 'lichter', 'tank', 'temp', 'bewegung'];
      cats.forEach(function (c) {
        var arr = (raw.custom && Array.isArray(raw.custom[c])) ? raw.custom[c] : [];
        out.custom[c] = arr.slice(0, 30).map(function (x) {
          if (!x || typeof x !== 'object') return null;
          return {
            id: String(x.id || '').slice(0, 60),
            label: String(x.label || '').slice(0, 80),
            icon: String(x.icon || 'X_Device_Fan').slice(0, 80)
          };
        }).filter(function (x) { return x && x.id && /^cust_(schalter|lichter|tank|temp|bewegung)_\d+$/.test(x.id); });
        out.custom[c].forEach(function (x) { customIds[x.id] = true; });
      });

      // Auswahl: nur Items, die es wirklich gibt (Katalog ODER eigener Verbraucher) —
      // Menge gegen max_anzahl. Kein max_anzahl = Umschalter (46 der 53 Items:
      // Integrationen, BMS, Sensoren) → Obergrenze 1. Ein großzügiger Fallback würde
      // hier z. B. 99 Autoterm-Bundles durchlassen. Eigene Verbraucher: immer 1.
      if (raw.sel && typeof raw.sel === 'object') {
        Object.keys(raw.sel).forEach(function (id) {
          var it = itemById(id);
          var max = 1;
          if (it) {
            max = parseInt(it.max_anzahl, 10);
            if (!isFinite(max) || max < 1) max = 1;
          } else if (!customIds[id]) return;
          var q = int(raw.sel[id], 0, max);
          if (q > 0) out.sel[id] = q;
        });
      }
      // BMS-Batterie nur, wenn sie im Katalog steht
      if (raw.bmsBat && itemById(raw.bmsBat)) out.bmsBat = raw.bmsBat;

      // Node-Overrides: nur Zahlen, gedeckelt (30 = weit über jedem realen Ausbau)
      if (raw.ov && typeof raw.ov === 'object') {
        Object.keys(raw.ov).slice(0, 40).forEach(function (k) {
          var q = int(raw.ov[k], 0, 30);
          if (q > 0) out.ov[String(k).slice(0, 60)] = q;
        });
      }
      if (raw.tankCfg && typeof raw.tankCfg === 'object') {
        Object.keys(raw.tankCfg).slice(0, 40).forEach(function (k) {
          var v = raw.tankCfg[k];
          if (!v || typeof v !== 'object') return;
          out.tankCfg[String(k).slice(0, 60)] = {
            step: int(v.step, 0, 99),
            gasType: String(v.gasType || '').slice(0, 30)
          };
        });
      }
      if (raw.led && typeof raw.led === 'object') {
        out.led = { rgbw: int(raw.led.rgbw, 0, 99), white: int(raw.led.white, 0, 99), kww: int(raw.led.kww, 0, 99) };
      }
      if (raw.sensorOff && typeof raw.sensorOff === 'object') {
        Object.keys(raw.sensorOff).slice(0, 60).forEach(function (k) {
          if (raw.sensorOff[k]) out.sensorOff[String(k).slice(0, 60)] = true;
        });
      }
      return out;
    }

    /* Positions-Snapshot fürs Angebot. Preise in CENT — genau die Zahlen, die
       der Kunde gesehen hat (Katalog und Kampagnen ändern sich später). */
    function configQuote(lines) {
      var out = [];
      (lines.lines || []).forEach(function (l, i) {
        out.push({
          pos: i + 1,
          key: l.key,
          title: l.name,
          note: l.note || null,
          qty: l.qty,
          unit: l.unit,
          total: l.total,
          variantId: l.variantId || null,
          sku: l.variantId ? (SKU_BY_VARIANT[String(l.variantId)] || null) : null,
          included: String(l.key).indexOf('integ0:') === 0 || !!l.free,   // 0-€-Hinweiszeile / eigenes Tablet → keine Angebotsposition
          onRequest: !!l.onRequest,
          preorder: !!l.preorder
        });
      });
      return {
        lines: out,
        total: lines.total,
        listTotal: lines.listTotal,
        savings: lines.savings,
        itemCount: lines.itemCount,
        install: state.install,
        installEstimate: state.install === 'partner' ? (function () {
          var e = installEstimateNow();
          return e ? { from: e.from, to: e.to, hours: e.hours, rate: e.rate, partner: ui.instPartner ? String(ui.instPartner.name || '').slice(0, 80) : null } : null;
        })() : null,
        generatedAt: new Date().toISOString()
      };
    }

    function postJson(url, payload, cb) {
      var done = false;
      var ctrl = null;
      try { ctrl = (typeof AbortController === 'function') ? new AbortController() : null; } catch (e) { ctrl = null; }
      var finish = function (ok, data) { if (!done) { done = true; cb(ok, data); } };
      try {
        var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) };
        if (ctrl) opts.signal = ctrl.signal;
        fetch(url, opts).then(function (r) {
          return r.json().then(function (j) { finish(r.ok && j && j.ok, j ? Object.assign({ status: r.status }, j) : { status: r.status }); })
            .catch(function () { finish(false, { status: r.status }); });
        }).catch(function () { finish(false, null); });
      } catch (e) { finish(false, null); }
      // Nach 15 s abbrechen — eine verspätete Antwort würde serverseitig sonst einen Code
      // anlegen, den der Kunde nie zu sehen bekommt (Waisen-Code, nächster Save = zweiter Code).
      setTimeout(function () { if (!done) { finish(false, null); try { if (ctrl) ctrl.abort(); } catch (e) {} } }, 15000);
    }

    /* Speichern (neuer Code) bzw. Aktualisieren (Code mitschicken = derselbe Code zeigt
       danach auf diesen Stand). asNew = bewusst einen zweiten Code anlegen. cb(ok, code, updated). */
    function saveConfig(cb, asNew) {
      if (!CONFIG_API || codeBusy) { cb(false, { kind: 'busy' }); return; }
      codeBusy = true;
      var lines = E.buildLines(CAT, state);
      var hashAtSend = E.code(state);   // exakt der Stand, der jetzt gesendet wird — nicht der bei Antwort (F1)
      var prevCode = savedCode;
      var payload = {
        session: sessionId(),
        code: (!asNew && savedCode) ? savedCode : undefined,
        format: 'r5',                       // kurzes Format R-XXXXX (Worker kennt beide)
        state: state,
        quote: configQuote(lines),
        total: lines.total,
        listTotal: lines.listTotal,
        itemCount: lines.itemCount,
        nodeCount: E.totalNodes(CAT, state),
        locale: (SET.locale || 'de').slice(0, 5)
      };
      postJson(CONFIG_API + '/save', payload, function (ok, data) {
        codeBusy = false;
        if (ok && data && isCode(String(data.code || ''))) {
          savedCode = String(data.code);
          savedCodeHash = hashAtSend;
          savedCodeExpires = data.expiresAt || null;
          savedCodeAt = data.updatedAt || new Date().toISOString();
          ui.codeRemote = null;             // unser Stand ist jetzt der neueste
          saveCodeMeta();
          track(data.updated ? 'config_updated' : 'config_saved', { code: savedCode, total: lines.total });
          // Der Worker legt bei abgelaufenem/unbekanntem Code einen NEUEN an → dem Kunden sagen,
          // dass sein alter Code nicht mehr gilt (F7).
          cb(true, { code: savedCode, updated: !!data.updated, replaced: !!(prevCode && !asNew && savedCode !== prevCode) });
        } else {
          var kind = (data && (data.error === 'rate limited' || data.status === 429)) ? 'ratelimit' : 'error';
          cb(false, { kind: kind });
        }
      });
    }

    /* Konfiguration zu einem Code holen. cb(ok, data, kind) — kind bei Fehler:
       'format' | 'notfound' | 'expired' | 'error'. */
    function loadByCode(code, cb) {
      code = normalizeCode(code);
      if (!CONFIG_API || !code) { cb(false, null, 'format'); return; }
      if (codeBusy) { cb(false, null, 'busy'); return; }
      codeBusy = true;                  // kein Speichern, während ein Laden läuft (V3)
      var done = false;
      var finish = function (ok, d, kind) { if (!done) { done = true; codeBusy = false; cb(ok, d, kind); } };
      try {
        fetch(CONFIG_API + '/load?code=' + encodeURIComponent(code))
          .then(function (r) {
            return r.json().then(function (j) { return { status: r.status, j: j }; })
              .catch(function () { return { status: r.status, j: null }; });
          })
          .then(function (res) {
            if (done) return;             // Timeout war schneller → Antwort verwerfen, nichts still übernehmen (F6)
            var j = res.j;
            if (!j || !j.ok || !j.state) {
              var err = j && j.error;
              finish(false, j, err === 'expired' ? 'expired' : res.status === 404 ? 'notfound' : res.status === 429 ? 'ratelimit' : 'error');
              return;
            }
            state = sanitizeState(j.state);   // NIE ungeprüft übernehmen
            savedCode = isCode(String(j.code || '')) ? String(j.code) : code;
            savedCodeHash = E.code(state);
            savedCodeExpires = j.expiresAt || null;
            savedCodeAt = j.updatedAt || null;
            ui.codeRemote = null;
            prevMulti = null; prevMW = null;  // keine „Celebration" für eine geladene Konfiguration
            saveCodeMeta();
            saveState();
            track('config_restore', { code: savedCode });
            finish(true, j, null);
          })
          .catch(function () { finish(false, null, 'error'); });
      } catch (e) { finish(false, null, 'error'); }
      setTimeout(function () { finish(false, null, 'error'); }, 15000);
    }

    /* V1 — Wurde der Code inzwischen auf einem anderen Gerät aktualisiert? Leiser Blick auf
       den Server-Stand (peek=1: zählt nicht als Öffnung, verlängert nichts). Nur informieren,
       nie still übernehmen — der Kunde entscheidet (Link „Neuen Stand laden"). */
    function checkRemoteUpdate() {
      if (!CONFIG_API || !savedCode || !savedCodeAt) return;
      var codeAtCheck = savedCode;
      try {
        fetch(CONFIG_API + '/load?code=' + encodeURIComponent(savedCode) + '&peek=1')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (!j || !j.ok || savedCode !== codeAtCheck) return;
            var remote = Date.parse(j.updatedAt || ''), mine = Date.parse(savedCodeAt || '');
            if (isFinite(remote) && isFinite(mine) && remote > mine + 1500) {
              ui.codeRemote = { updatedAt: j.updatedAt };
              renderCodeSlot(); renderBarCode();
            }
          })
          .catch(function () {});
      } catch (e) {}
    }

    /* ── Tracking ── */
    var memSession = null;
    function newUuid() {
      return (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
    }
    function sessionId() {
      try {
        var s = sessionStorage.getItem('rvk_session');
        if (!s) { s = newUuid(); sessionStorage.setItem('rvk_session', s); }
        return s;
      } catch (e) {
        // sessionStorage gesperrt (Safari „alle Cookies blockieren", Kiosk-Setups):
        // UUID im Speicher halten — der Worker verlangt eine UUID, 'anon' hieße 400 (F3).
        if (!memSession) memSession = newUuid();
        return memSession;
      }
    }
    var SESSION = sessionId();
    var changeTimer = null, pendingChange = null;
    /* ── Umfassendes Tracking-Gedächtnis (First-Party, anonym) ──
       STARTED_AT   = Verweildauer-Basis
       journey      = Klickstrom (JEDE Interaktion, in Reihenfolge) — wird gebatcht
                      geflusht (config_progress) + beim Verlassen (config_exit) gesendet
       funnelMax    = weiteste erreichte Sektion (Abbruchpunkt-Analyse)
       convFlags    = erreichte Ziele (Warenkorb/PDF/Partner/Dialoge)
       lastExitSig  = Dedupe für config_exit (Tab-Wechsel schickt sonst Duplikate) */
    var STARTED_AT = Date.now();
    var journey = [];
    var funnelMax = { step: '', idx: -1 };
    var convFlags = { cart: false, pdf: false, partner: false, dialogs: 0 };
    var lastExitSig = '';

    function beacon(payload) {
      if (!TRACKING_URL) return;
      try {
        var body = JSON.stringify(payload);
        // text/plain statt application/json: JSON-Blobs erzwingen bei
        // sendBeacon einen CORS-Preflight, den es nicht gibt → Browser
        // verwirft den Beacon still. Der Hub parst den Body immer als JSON.
        if (navigator.sendBeacon) {
          navigator.sendBeacon(TRACKING_URL, new Blob([body], { type: 'text/plain' }));
        } else if (window.fetch) {
          fetch(TRACKING_URL, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
        }
      } catch (e) {}
    }
    /* Berechnete Kennzahlen der aktuellen Konfiguration — an JEDES Event gehängt,
       damit der Hub „Systemgröße / welche Nodes / welche Integrationen / Einbauart"
       ohne erneuten Engine-Lauf auswerten kann. */
    function configSummary() {
      var out = {};
      try {
        var lines = E.buildLines(CAT, state);
        var c = lines.computed || {};
        out.total = lines.total / 100;
        out.itemCount = lines.itemCount;
        out.nodesTotal = E.totalNodes(CAT, state);
        out.nodes = c.req || {};            // Modul-Bedarf je Typ: { switch_multi, level, temp, twoway, ambient, ... }
        out.brain = state.brainMode;        // 'lite' | 'full' | 'own' (vorhandenes BRAIN)
        out.voltage = state.voltage;        // '12v' | '24v'
        out.panel = state.panel || null;    // null | '4' | '8' | 'tablet'
        out.install = state.install || null;// null | 'self' | 'partner'
        out.integrations = byBereich('integration').filter(function (i) { return on(i.id); }).map(function (i) { return i.id; });
        out.vedirect = E.vedirectCount(CAT, state);   // Victron-Geräte (je 1 Bundle)
        out.selCount = Object.keys(state.sel || {}).length;
        out.dwell = Math.round((Date.now() - STARTED_AT) / 1000);
      } catch (e) {}
      return out;
    }

    function track(event, data) {
      data = data || {};
      try { assistObserve(event, data); } catch (e) {}
      var code = E.code(state);
      var summary = configSummary();
      var total = summary.total != null ? summary.total : 0;
      /* Erreichte Ziele merken (für Abbruch-Analyse im config_exit) */
      if (event === 'config_add_to_cart') convFlags.cart = true;
      else if (event === 'config_pdf') convFlags.pdf = true;
      else if (event === 'config_partner_view') convFlags.partner = true;
      else if (event === 'config_dialog') convFlags.dialogs++;
      /* Weiteste erreichte Sektion (Abbruchpunkt) aus der DOM-Reihenfolge */
      if (event === 'config_section' && data.sektion) {
        try {
          var secs = root.querySelectorAll('.rvk-sec[data-sek]');
          for (var si = 0; si < secs.length; si++) {
            if (secs[si].getAttribute('data-sek') === data.sektion) { if (si > funnelMax.idx) funnelMax = { step: data.sektion, idx: si }; break; }
          }
        } catch (e) {}
      }
      /* GA4/GTM-dataLayer (parallel zum First-Party-Hub) */
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: event, config_code: code, config_total: total, config_nodes: summary.nodesTotal, config_install: summary.install || '', config_panel: summary.panel || '' }, data));
      } catch (e) {}
      /* Klickstrom: JEDE Interaktion in Reihenfolge festhalten (Echtzeit-Rohdaten
         für die Abbruchgrund-Forschung), kompakt: dt=ms seit Start, ev, s=Sektion, i=Item, v=Wert */
      try { journey.push({ dt: Date.now() - STARTED_AT, ev: event, s: data.sektion || data.step || '', i: data.item != null ? data.item : undefined, v: data.value }); } catch (e) {}
      /* Schema des Marketing-Hub-Endpoints (TRACKING-ENDPOINT.md):
         session (UUID) · event (Whitelist) · step · code · total · itemCount · locale · config · meta.
         meta bekommt zusätzlich summary (frei als JSON gespeichert). */
      var payload = {
        session: SESSION,
        event: event,
        step: data.sektion || data.step || funnelMax.step || '',
        code: code,
        total: total,
        itemCount: data.itemCount != null ? data.itemCount : summary.itemCount,
        locale: SET.locale || 'de',
        config: state,
        meta: Object.assign({}, data, { summary: summary }, ASSIST ? { ab: { assist: ASSIST } } : {})
      };
      if (event === 'config_change') {
        pendingChange = payload; /* letzter Stand gewinnt (Snapshot); der Klickstrom oben hält jeden Einzelklick */
        if (!changeTimer) {
          changeTimer = setTimeout(function () {
            changeTimer = null;
            if (pendingChange) { beacon(pendingChange); pendingChange = null; }
          }, 1000);
        }
      } else {
        beacon(payload);
      }
      /* Klickstrom gebatcht flushen, damit bei hartem Verlassen nichts verloren geht
         und journey/Exit-Payload klein bleiben (32-KB-Limit). */
      if (journey.length >= 25) flushJourney();
    }

    /* Klickstrom-Batch als config_progress senden und lokal leeren. */
    function flushJourney() {
      if (!journey.length) return;
      var batch = journey; journey = [];
      var summary = configSummary();
      beacon({
        session: SESSION, event: 'config_progress',
        step: funnelMax.step, code: E.code(state),
        total: summary.total || 0, itemCount: summary.itemCount,
        locale: SET.locale || 'de', config: state,
        meta: { summary: summary, journey: batch, funnelMax: funnelMax, flags: convFlags }
      });
    }

    /* Verlassen/Abbruch: letzten Stand + restlichen Klickstrom + Funnel-Tiefe +
       erreichte Ziele senden. Feuert bei visibilitychange→hidden (mobil-zuverlässig)
       und pagehide; dedupliziert über lastExitSig, damit Tab-Wechsel keine Doppler
       erzeugt. Der Hub nimmt je Session den letzten config_exit als Endzustand. */
    function sendExit() {
      try {
        if (!started) return;
        var summary = configSummary();
        var sig = summary.selCount + ':' + summary.nodesTotal + ':' + (summary.install || '') + ':' + (summary.panel || '') + ':' + journey.length + ':' + convFlags.cart;
        if (sig === lastExitSig) return;
        lastExitSig = sig;
        beacon({
          session: SESSION, event: 'config_exit',
          step: funnelMax.step, code: E.code(state),
          total: summary.total || 0, itemCount: summary.itemCount,
          locale: SET.locale || 'de', config: state,
          meta: { summary: summary, journey: journey.slice(-150), funnelMax: funnelMax, flags: convFlags, dwell: summary.dwell, converted: convFlags.cart }
        });
      } catch (e) {}
    }

    function markStart() {
      if (started) return;
      started = true;
      track('config_start', {});
    }

    /* ── Engine-Zugriffe / Setter ── */
    function qty(id) { return state.sel[id] || 0; }
    function on(id) { return qty(id) > 0; }
    function setSel(id, v, sektion) {
      var sel = Object.assign({}, state.sel);
      if (v <= 0) delete sel[id]; else sel[id] = v;
      state.sel = sel;
      markStart();
      track('config_change', { sektion: sektion || '', item: id, value: v });
      update();
    }
    function toggleDev(id, sektion) { setSel(id, on(id) ? 0 : 1, sektion); }
    function byBereich(b) { return E.byBereich(CAT, b); }
    function itemById(id) {
      var found = null;
      (CAT.items || []).forEach(function (i) { if (i.id === id) found = i; });
      return found;
    }
    function productPrice(key, prefs) {
      var p = CAT.products[key];
      var v = p ? E.pickVariant(p, prefs || []) : null;
      return v ? v.price : 0;
    }
    /* Streichpreis-HTML für ein Katalog-Produkt (Kampagnen-Rabatt aus `disc`).
       Ohne Kampagne identisch zu euro(productPrice(...)). */
    function productPriceHtml(key, prefs) {
      var p = CAT.products[key];
      var list = productPrice(key, prefs);
      var pct = p && p.disc ? p.disc : 0;
      if (!pct || !list) return esc(euro(list));
      return priceHtml(E.discountCents(list, pct), list);
    }
    function bundleVariant(item) {
      if (!item || !item.produkt) return null;
      var x = extra(item);
      return E.pickVariant(item.produkt, x.variante ? [x.variante] : []);
    }

    /* ── Style-Helfer (1:1 aus dem Prototyp) ── */
    function cardStyle(sel) {
      return 'display:flex;align-items:center;gap:14px;min-width:0;border-radius:20px;padding:14px 16px;cursor:pointer;transition:box-shadow .2s var(--ease-out), transform .2s var(--ease-out), background .2s var(--ease-out);' +
        (sel ? 'background:var(--color-text);transform:translateY(-3px);box-shadow:0 24px 48px -16px rgba(8,18,27,.55), 0 10px 22px -12px rgba(8,18,27,.4);'
             : 'background:#fff;box-shadow:var(--shadow-widget);');
    }
    function comboCard(sel) {
      return 'border-radius:20px;padding:14px 16px;transition:box-shadow .2s var(--ease-out), transform .2s var(--ease-out), background .2s var(--ease-out);' +
        (sel ? 'background:var(--color-text);transform:translateY(-3px);box-shadow:0 24px 48px -16px rgba(8,18,27,.55), 0 10px 22px -12px rgba(8,18,27,.4);'
             : 'background:#fff;box-shadow:var(--shadow-widget);');
    }
    function iconWrap() { return 'width:46px;height:46px;flex:none;display:flex;align-items:center;justify-content:center;'; }
    function iconImg(sel) { return sel ? 'filter:brightness(0) invert(1);' : ''; }
    function labelStyle(sel) { return 'font-family:var(--font-heading);font-weight:600;font-size:15px;letter-spacing:-.01em;color:' + (sel ? '#fff' : 'var(--color-text)') + ';'; }
    function subStyle(sel) { return 'font-size:12px;margin-top:1px;color:' + (sel ? 'rgba(255,255,255,.7)' : 'var(--color-muted)') + ';'; }
    function noteStyle(sel) { return 'font-size:11px;font-weight:600;margin-top:6px;color:' + (sel ? 'rgba(255,255,255,.92)' : 'var(--color-cyan-dark)') + ';'; }
    function addStyle(active) { return 'width:34px;height:34px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;transition:all .2s var(--ease-out);background:' + (active ? 'rgba(255,255,255,.18)' : 'var(--color-bg-deep)') + ';'; }
    function addIconHtml(active) {
      return '<img src="' + (active ? uiIcon('check.svg') : uiIcon('add.svg')) + '" alt="" style="' + (active ? 'width:16px;height:16px;filter:brightness(0) invert(1);' : 'width:16px;height:16px;opacity:.5;') + '">';
    }
    function counterDec(sel) { return 'width:28px;height:28px;border-radius:50%;border:none;font-size:16px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;background:' + (sel ? 'rgba(255,255,255,.16)' : 'var(--color-bg-deep)') + ';color:' + (sel ? '#fff' : 'var(--color-text)') + ';'; }
    function counterInc(sel) { return 'width:30px;height:30px;border-radius:50%;border:none;font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;background:' + (sel ? '#fff' : 'var(--color-text)') + ';color:' + (sel ? 'var(--color-text)' : '#fff') + ';'; }
    function countStyle(sel) { return 'font-family:var(--font-heading);font-weight:600;font-size:16px;font-variant-numeric:tabular-nums;min-width:14px;text-align:center;color:' + (sel ? '#fff' : 'var(--color-text)') + ';'; }
    function decMini(en) { return 'width:24px;height:24px;border-radius:50%;border:none;font-size:15px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0;background:var(--color-bg-deep);color:var(--color-text);cursor:' + (en ? 'pointer' : 'not-allowed') + ';opacity:' + (en ? 1 : 0.35) + ';'; }
    function brainCard(sel) {
      return 'background:#fff;border-radius:24px;padding:18px;cursor:pointer;text-align:center;display:flex;flex-direction:column;align-items:center;min-width:0;transition:box-shadow .2s var(--ease-out), transform .2s var(--ease-out);' +
        (sel ? 'outline:2px solid var(--color-text);outline-offset:-2px;transform:translateY(-3px);box-shadow:0 24px 48px -16px rgba(8,18,27,.5), 0 10px 22px -12px rgba(8,18,27,.32);' : 'box-shadow:var(--shadow-widget);');
    }
    function choice(sel) {
      return 'background:#fff;border-radius:22px;padding:20px;cursor:pointer;min-width:0;transition:box-shadow .2s var(--ease-out), transform .2s var(--ease-out);' +
        (sel ? 'outline:2px solid var(--color-text);outline-offset:-2px;transform:translateY(-3px);box-shadow:0 24px 48px -16px rgba(8,18,27,.5), 0 10px 22px -12px rgba(8,18,27,.32);' : 'box-shadow:var(--shadow-widget);');
    }
    function seg(onSel) { return 'flex:1;border:none;border-radius:14px;padding:13px 14px;font-family:var(--font-body);font-weight:600;font-size:13px;cursor:pointer;transition:all .2s var(--ease-out);' + (onSel ? 'background:var(--color-text);color:#fff;' : 'background:#fff;color:var(--color-muted);box-shadow:var(--shadow-widget);'); }
    function pillBtn(onSel) { return 'border:none;border-radius:9999px;padding:10px 16px;font-family:var(--font-body);font-weight:600;font-size:13px;cursor:pointer;transition:all .2s var(--ease-out);' + (onSel ? 'background:var(--color-text);color:#fff;' : 'background:#fff;color:var(--color-muted);box-shadow:var(--shadow-widget);'); }
    function checkBox(onSel) { return 'width:20px;height:20px;border-radius:7px;flex:none;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .15s var(--ease-out);' + (onSel ? 'background:var(--color-cyan);' : 'background:transparent;box-shadow:inset 0 0 0 2px rgba(255,255,255,.4);'); }

    /* ── Karten-HTML ── */
    function noteFor(d, q) {
      if (q <= 0) return '';
      if (d.bereich === 'vedirect') return t('note_vedirect', { count: q });
      if (d.id === 'rgbw') return t('note_ambient', { count: q });
      if (d.id === 'white') return t('note_ambient_mw', { count: Math.ceil(q / 3) });
      if (d.cap === 'level') return t('note_level');
      if (d.cap === 'temp') return t('note_temp');
      if (d.cap === 'switch') return d.max_anzahl ? t('note_channels', { count: q }) : t('note_channel');
      if (d.cap === 'lightswitch') return t('note_channel_light');
      return '';
    }
    function optCard(d, sektion) {
      var q = qty(d.id), sel = q > 0;
      var isCounter = !!d.max_anzahl;
      var note = noteFor(d, q);
      var html = '<div data-act="' + (isCounter ? 'noop' : 'toggle') + '" data-id="' + esc(d.id) + '" data-sektion="' + esc(sektion) + '" style="' + cardStyle(sel) + (isCounter ? 'cursor:default;' : '') + '">';
      // Vollfarb-„Hero"-Icons (z. B. farbige/weiße Lichtzone) NICHT einfärben —
      // sie tragen ihre eigene Farbe/Glow und würden vom Weiß-Tint zerstört.
      var noTint = /X_Light_Color|X_Light_white/i.test(d.icon || '');
      html += '<div style="' + iconWrap() + '"><img src="' + esc(appIcon(d.icon || 'X_Utility_Gauge.svg')) + '" alt="" style="width:42px;height:42px;' + (noTint ? '' : iconImg(sel)) + '"></div>';
      html += '<div style="flex:1;min-width:0;">';
      html += '<div style="' + labelStyle(sel) + '">' + esc(d.label) + '</div>';
      html += '<div style="' + subStyle(sel) + '">' + esc(d.sub || '') + '</div>';
      if (note) html += '<div style="' + noteStyle(sel) + '">' + esc(note) + '</div>';
      html += '</div>';
      if (isCounter) {
        html += '<span style="display:flex;align-items:center;gap:9px;flex:none;">' +
          '<button type="button" data-act="counter-dec" data-id="' + esc(d.id) + '" data-sektion="' + esc(sektion) + '" style="' + counterDec(sel) + '">−</button>' +
          '<span style="' + countStyle(sel) + '">' + q + '</span>' +
          '<button type="button" data-act="counter-inc" data-id="' + esc(d.id) + '" data-max="' + (d.max_anzahl || 99) + '" data-sektion="' + esc(sektion) + '" style="' + counterInc(sel) + '">+</button></span>';
      } else {
        html += '<span style="' + addStyle(sel) + '">' + addIconHtml(sel) + '</span>';
      }
      html += '</div>';
      return html;
    }
    function addFormHtml(cat) {
      if (ui.adding !== cat) {
        return '<button type="button" data-act="add-open" data-cat="' + cat + '" style="margin-top:12px;display:flex;align-items:center;gap:11px;width:100%;background:transparent;border:2px dashed var(--color-line);border-radius:20px;padding:15px 16px;cursor:pointer;color:var(--color-muted);font-family:var(--font-body);font-weight:600;font-size:14px;">' +
          '<span style="width:28px;height:28px;border-radius:50%;background:var(--color-bg-deep);display:flex;align-items:center;justify-content:center;font-size:18px;color:var(--color-text);flex:none;">+</span>' +
          esc(t('custom_add_open_' + cat)) + '</button>';
      }
      var groups = ICON_GROUPS.map(function (g) {
        var label = t('icon_group_' + g.key);
        if (label === 'icon_group_' + g.key) label = g.label;
        var icons = g.icons.map(function (ic) {
          var selIc = ui.draftIcon === ic;
          var st = 'border:none;border-radius:13px;padding:9px;cursor:pointer;display:flex;align-items:center;justify-content:center;aspect-ratio:1;transition:all .15s var(--ease-out);' +
            (selIc ? 'background:var(--color-cyan-soft);outline:2px solid var(--color-cyan);outline-offset:-2px;' : 'background:var(--color-bg-deep);outline:2px solid transparent;');
          return '<button type="button" data-act="icon-pick" data-icon="' + esc(ic) + '" style="' + st + '"><img src="' + appIcon(ic) + '" alt="" style="width:26px;height:26px;"></button>';
        }).join('');
        return '<div style="font-size:10px;letter-spacing:.08em;font-weight:600;text-transform:uppercase;color:var(--color-muted);margin:8px 0 8px;">' + esc(label) + '</div>' +
          '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(44px,1fr));gap:8px;margin-bottom:10px;">' + icons + '</div>';
      }).join('');
      return '<div class="rvk-anim-in" style="margin-top:12px;background:#fff;border-radius:20px;padding:18px;box-shadow:var(--shadow-widget);">' +
        '<div style="font-family:var(--font-heading);font-weight:600;font-size:15px;margin-bottom:12px;">' + esc(t('custom_form_title_' + cat)) + '</div>' +
        '<input id="rvk-custom-label" type="text" placeholder="' + esc(t('custom_placeholder_' + cat)) + '" style="width:100%;border:none;background:var(--color-bg-deep);border-radius:14px;padding:13px 15px;font-family:var(--font-body);font-size:14px;color:var(--color-text);outline:none;margin-bottom:16px;">' +
        '<div style="font-size:11px;letter-spacing:.09em;font-weight:600;text-transform:uppercase;color:var(--color-muted);margin-bottom:10px;">' + esc(t('icon_pick')) + '</div>' +
        '<div style="max-height:240px;overflow-y:auto;">' + groups + '</div>' +
        '<div style="display:flex;gap:10px;margin-top:16px;">' +
        '<button type="button" data-act="add-cancel" style="flex:none;border:none;border-radius:9999px;padding:12px 18px;background:var(--color-bg-deep);color:var(--color-text);font-family:var(--font-body);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('cancel')) + '</button>' +
        '<button type="button" data-act="add-confirm" data-cat="' + cat + '" style="flex:1;border:none;border-radius:9999px;padding:12px;background:var(--color-text);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('add_confirm')) + '</button>' +
        '</div></div>';
    }

    /* ── Sektionen rendern ── */
    function body(name) { return root.querySelector('[data-rvk-body="' + name + '"]'); }

    function rBrain() {
      var mode = state.brainMode;
      var pLite = CAT.products.brain_lite, pFull = CAT.products.brain;
      function pills(list) {
        return '<div style="display:flex;flex-wrap:wrap;gap:6px;justify-content:center;margin-top:9px;">' + list.map(function (p) {
          return '<span style="background:#fff;color:var(--color-text);font-size:11px;font-weight:600;padding:5px 10px;border-radius:9999px;box-shadow:var(--shadow-widget);">' + esc(p) + '</span>';
        }).join('') + '</div>';
      }
      var html = '<div class="rvk-grid-brain">';
      html += '<div data-act="brain-lite" style="' + brainCard(mode === 'lite') + '">' +
        productImgTag('brain_lite', 'width:72px;height:72px;object-fit:contain;margin-bottom:6px;') +
        '<div style="display:flex;align-items:baseline;gap:8px;"><span style="font-family:var(--font-heading);font-weight:600;font-size:17px;">BRAIN® Lite</span><span style="font-family:var(--font-heading);font-weight:600;font-size:15px;color:var(--color-muted);">' + productPriceHtml('brain_lite') + '</span></div>' +
        '<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(8,18,27,.06);color:var(--color-muted);font-size:12px;font-weight:600;padding:6px 13px;border-radius:9999px;margin-top:11px;">' + esc(t('brain_lite_chip')) + '</span>' +
        pills([t('pill_wlan'), t('pill_bt'), t('pill_nodes_10')]) + '</div>';
      html += '<div data-act="brain-full" style="' + brainCard(mode === 'full') + '">' +
        productImgTag('brain', 'width:72px;height:72px;object-fit:contain;margin-bottom:6px;') +
        '<div style="display:flex;align-items:baseline;gap:8px;"><span style="font-family:var(--font-heading);font-weight:600;font-size:17px;">BRAIN®</span><span style="font-family:var(--font-heading);font-weight:600;font-size:15px;color:var(--color-muted);">' + productPriceHtml('brain') + '</span></div>' +
        '<span style="display:inline-flex;align-items:center;gap:6px;background:var(--color-cyan);color:#fff;font-size:12px;font-weight:600;padding:6px 13px;border-radius:9999px;box-shadow:0 4px 16px rgba(48,182,198,.45);margin-top:11px;"><img src="' + appIcon('X_Utility_Map') + '" alt="" style="width:14px;height:14px;filter:brightness(0) invert(1);">' + esc(t('brain_full_chip')) + '</span>' +
        pills([t('pill_lte'), t('pill_level'), t('pill_wlan'), t('pill_bt'), t('pill_nodes_30')]) + '</div>';
      html += '</div>';
      /* „Ich habe schon ein BRAIN" — schmale horizontale Karte unter den beiden
         BRAIN-Karten (Jasper 16.10.2026; vorher nur ein graues Kästchen, das man
         übersah). Umschalter: erneuter Klick → zurück zum BRAIN® Lite. */
      var own = mode === 'own';
      html += '<button type="button" class="rvk-brain-own" data-act="brain-own" aria-pressed="' + (own ? 'true' : 'false') + '" style="' + brainCard(own) +
        'flex-direction:row;align-items:center;gap:14px;width:100%;margin-top:14px;padding:12px 16px;border:none;border-radius:20px;text-align:left;font-family:var(--font-body);color:var(--color-text);' + (own ? 'transform:translateY(-2px);' : '') + '">' +
        productImgTag('brain', 'width:40px;height:40px;object-fit:contain;flex:none;transition:opacity .2s var(--ease-out), filter .2s var(--ease-out);' + (own ? '' : 'opacity:.5;filter:grayscale(1);')) +
        '<span style="display:flex;flex-direction:column;gap:2px;min-width:0;">' +
        '<span style="font-family:var(--font-heading);font-weight:600;font-size:15px;">' + esc(t('brain_own_toggle')) + '</span>' +
        '<span style="font-size:12px;color:var(--color-muted);">' + esc(t('brain_own_active')) + '</span></span>' +
        '<span aria-hidden="true" style="width:22px;height:22px;border-radius:50%;flex:none;margin-left:auto;display:inline-flex;align-items:center;justify-content:center;transition:all .15s var(--ease-out);' +
        (own ? 'background:var(--color-text);' : 'box-shadow:inset 0 0 0 1.5px rgba(8,18,27,.25);') + '">' +
        (own ? '<img src="' + uiIcon('check.svg') + '" alt="" style="width:11px;height:11px;filter:brightness(0) invert(1);">' : '') + '</span>' +
        '</button>';
      body('brain').innerHTML = html;
    }

    function rInteg(computed) {
      var items = byBereich('integration');
      var coveredIds = {};
      computed.integ.covered.forEach(function (i) { coveredIds[i.id] = true; });
      var html = '<div class="rvk-grid-integ">';
      items.forEach(function (ig) {
        var a = on(ig.id);
        var x = extra(ig);
        var v = bundleVariant(ig);
        var price = v ? v.price : 0;
        /* Geräte-Rendering: extra.device > icon (devices/…) > devices/<id>.png (R2),
           Fallback-Kette aufs Bundle-Produktbild (mit Hintergrund → .has-bg) */
        var DEVICE_FALLBACK = {}; /* truma_aventa hat jetzt ein eigenes devices/truma_aventa.png (Klimagerät) — kein Combi-Fallback mehr */
        var imgSrcs = [];
        if (x.device) imgSrcs.push(AB + '/' + x.device);
        if (ig.icon && ig.icon.indexOf('devices/') === 0) imgSrcs.push(AB + '/' + ig.icon);
        imgSrcs.push(AB + '/devices/' + ig.id + '.png');
        if (DEVICE_FALLBACK[ig.id]) imgSrcs.push(AB + '/' + DEVICE_FALLBACK[ig.id]);
        if (ig.produkt && ig.produkt.img) imgSrcs.push('!hasbg:' + ig.produkt.img);
        imgSrcs = imgSrcs.filter(function (s, idx) { return imgSrcs.indexOf(s) === idx; });
        var img = imgSrcs.shift();
        var imgFb = imgSrcs.join('|');
        var logo = x.logo ? logoUrl(x.logo) : '';
        var cStyle = 'position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;padding:22px 16px 18px;border-radius:24px;cursor:pointer;transition:box-shadow .2s var(--ease-out), transform .2s var(--ease-out), background .2s var(--ease-out);' +
          (a ? 'background:var(--color-text);box-shadow:0 22px 48px rgba(8,18,27,.36), 0 6px 14px rgba(8,18,27,.24);' : 'background:#fff;box-shadow:var(--shadow-widget);');
        html += '<div data-act="toggle" data-id="' + esc(ig.id) + '" data-sektion="integrationen" style="' + cStyle + '">';
        if (ig.info_titel || ig.info_text) {
          html += '<button type="button" data-act="item-info" data-id="' + esc(ig.id) + '" style="position:absolute;top:12px;left:12px;width:28px;height:28px;border-radius:50%;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;background:' + (a ? 'rgba(255,255,255,.14)' : 'var(--color-bg-deep)') + ';">' +
            '<img src="' + uiIcon('info.svg') + '" alt="Info" style="width:14px;height:14px;' + (a ? 'filter:brightness(0) invert(1);opacity:.85;' : 'opacity:.6;') + '"></button>';
        }
        html += '<span style="' + addStyle(a) + 'position:absolute;top:12px;right:12px;">' + addIconHtml(a) + '</span>';
        if (img) html += '<img src="' + esc(img) + '" data-fb="' + esc(imgFb) + '" alt="" style="height:96px;max-width:82%;object-fit:contain;margin:14px 0 2px;">';
        if (logo) html += '<img src="' + esc(logo) + '" alt="' + esc(ig.label) + '" style="height:24px;max-width:132px;object-fit:contain;margin-top:12px;' + (a ? 'filter:brightness(0) invert(1);' : '') + '">';
        else html += '<div style="font-family:var(--font-heading);font-weight:600;font-size:16px;margin-top:12px;' + (a ? 'color:#fff;' : '') + '">' + esc(ig.label) + '</div>';
        html += '<div style="font-size:12.5px;font-weight:500;margin-top:6px;' + (a ? 'color:rgba(255,255,255,.6);' : 'color:var(--color-muted);') + '">' + esc(ig.sub || '') + '</div>';
        var note = '';
        if (a && coveredIds[ig.id]) note = t('integ_covered');
        else if (a && price) note = t('integ_bundle_note', { price: euro(price) });
        else if (!a && price) note = euro(price);
        if (note) html += '<div style="font-size:11px;font-weight:600;margin-top:8px;color:' + (a ? 'rgba(255,255,255,.92)' : 'var(--color-cyan-dark)') + ';">' + esc(note) + '</div>';
        html += '</div>';
      });
      html += '</div>';

      /* Kühlschrank-Automatik-Upsell */
      var fridgeSel = items.some(function (i) { return i.cap === 'fridge' && on(i.id); });
      var tfr = itemById('tfridge');
      if (fridgeSel && tfr) {
        var selF = on('tfridge');
        html += '<div style="margin-top:18px;">' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;"><span style="font-size:12px;font-weight:600;color:var(--color-muted);">' + esc(t('fridge_upsell_kicker')) + '</span>' +
          '<button type="button" data-act="info" data-key="fridge_auto" style="width:20px;height:20px;border-radius:50%;border:none;background:#fff;box-shadow:var(--shadow-widget);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;flex:none;"><img src="' + uiIcon('info.svg') + '" alt="Info" style="width:11px;height:11px;opacity:.6;"></button></div>' +
          '<div data-act="toggle" data-id="tfridge" data-sektion="integrationen" style="' + cardStyle(selF) + '">' +
          '<div style="' + iconWrap() + '"><img src="' + appIcon('X_Temp_MiniBar') + '" alt="" style="width:32px;height:32px;' + iconImg(selF) + '"></div>' +
          '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selF) + '">' + esc(t('fridge_upsell_label')) + '</div>' +
          '<div style="' + subStyle(selF) + '">' + esc(t('fridge_upsell_sub')) + '</div>' +
          (selF ? '<div style="' + noteStyle(selF) + '">' + esc(t('note_temp')) + '</div>' : '') + '</div>' +
          '<span style="' + addStyle(selF) + '">' + addIconHtml(selF) + '</span></div></div>';
      }

      /* Thitronik ProFinder-Abfrage (Muster wie BMS-Frage) */
      var thi = itemById('thitronik');
      if (thi && on('thitronik') && extra(thi).profinderQuery) {
        html += '<div style="margin-top:18px;">' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px;"><span style="font-size:14px;font-weight:600;">' + esc(t('thi_profinder_q')) + '</span>' +
          '<button type="button" data-act="info" data-key="thitronik_profinder" style="width:22px;height:22px;border-radius:50%;border:none;background:#fff;box-shadow:var(--shadow-widget);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;flex:none;"><img src="' + uiIcon('info.svg') + '" alt="Info" style="width:12px;height:12px;opacity:.6;"></button></div>' +
          '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
          '<button type="button" data-act="profinder" data-val="yes" style="' + seg(state.thitronikProfinder === 'yes') + '">' + esc(t('thi_profinder_yes')) + '</button>' +
          '<button type="button" data-act="profinder" data-val="no" style="' + seg(state.thitronikProfinder === 'no') + '">' + esc(t('thi_profinder_no')) + '</button></div>' +
          (state.thitronikProfinder === 'yes' ? '<div style="margin-top:10px;font-size:12px;font-weight:600;color:var(--color-cyan-dark);">' + esc(t('thi_profinder_yhint')) + '</div>' : '') +
          '</div>';
      }
      body('integrationen').innerHTML = html;
    }

    function rSchalter(computed) {
      var items = E.schalterAll(CAT, state);
      var html = '<div class="rvk-grid-cards">' + items.map(function (d) { return optCard(d, 'schalter'); }).join('') + '</div>';
      html += addFormHtml('schalter');
      if (computed.switchCh >= 5) {
        html += '<div style="margin-top:14px;display:flex;gap:11px;align-items:flex-start;background:var(--color-cyan-soft);border-radius:16px;padding:13px 15px;">' +
          '<span style="width:20px;height:20px;border-radius:50%;background:var(--color-cyan);color:#fff;font-size:11px;font-weight:700;font-style:italic;display:flex;align-items:center;justify-content:center;flex:none;margin-top:1px;">i</span>' +
          '<span style="font-size:12.5px;line-height:1.5;color:var(--color-cyan-dark);">' + esc(t('schalter_hint', { count: computed.switchCh })) + '</span></div>';
        /* Sonderauswahl: einzelne NODE Switch statt Switch Multi erzwingen */
        html += '<div style="margin-top:14px;">' +
          '<div style="font-size:14px;font-weight:600;margin-bottom:9px;">' + esc(t('force_single_q')) + '</div>' +
          '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
          '<button type="button" data-act="force-single" data-val="multi" style="' + seg(!state.forceSingleSwitch) + '">' + esc(t('force_single_multi')) + '</button>' +
          '<button type="button" data-act="force-single" data-val="single" style="' + seg(state.forceSingleSwitch) + '">' + esc(t('force_single_single')) + '</button></div>' +
          '<div style="margin-top:8px;font-size:12px;color:var(--color-muted);line-height:1.45;">' + esc(t('force_single_sub')) + '</div></div>';
      }
      body('schalter').innerHTML = html;
    }

    function rLichter() {
      var counters = byBereich('licht');
      var html = '<div class="rvk-grid-cards">' + counters.map(function (d) { return optCard(d, 'lichter'); }).join('') + '</div>';

      html += '<div style="margin:24px 0 16px;height:1px;background:var(--color-line);"></div>' +
        '<div style="font-family:var(--font-heading);font-weight:600;font-size:16px;margin-bottom:5px;">' + esc(t('lichter_g2_label')) + '</div>' +
        '<p style="margin:0 0 16px;font-size:13px;color:var(--color-muted);line-height:1.55;max-width:520px;">' + esc(t('lichter_g2_desc')) + '</p>' +
        '<div class="rvk-grid-cards">' + E.lichtSchalterAll(CAT, state).map(function (d) { return optCard(d, 'lichter'); }).join('') + '</div>';
      html += addFormHtml('lichter');

      /* LED-Strip-Upsell */
      var ledP = CAT.products.led_strip;
      if (ledP) {
        /* d[2] = Optionswert der Shopify-Variante (deutsch, nicht uebersetzen),
           d[3] = SKU. Die SKU entscheidet zuerst: der Optionswert wird je Sprache
           uebersetzt, sonst zeigt die Karte den Preis der falschen Variante. */
        var defs = [['rgbw', t('led_rgbw'), 'RGBW', '22001'], ['white', t('led_white'), 'Weiß', '22002'],
                    ['kww', t('led_kww'), 'Kalt-Warm-Weiß', '22003']];
        html += '<div style="margin-top:18px;font-size:12px;font-weight:600;color:var(--color-muted);">' + esc(t('led_kicker')) + '</div><div class="rvk-grid-led">';
        defs.forEach(function (d) {
          var q = state.led[d[0]] || 0;
          var v = E.pickVariantBySku ? E.pickVariantBySku(ledP, d[3], [d[2]]) : E.pickVariant(ledP, [d[2]]);
          html += '<div style="display:flex;align-items:center;gap:12px;background:#fff;border-radius:16px;padding:11px 13px;box-shadow:var(--shadow-widget);">' +
            '<div style="width:40px;height:40px;border-radius:11px;flex:none;overflow:hidden;background:#fff;display:flex;align-items:center;justify-content:center;">' + accImgTag('led_strip', 'width:100%;height:100%;object-fit:cover;', 'X_Light_Ambient') + '</div>' +
            '<div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;font-family:var(--font-heading);">' + esc(d[1]) + '</div><div style="font-size:11px;color:var(--color-muted);">' + esc(t('led_meta', { price: euro(v ? v.price : 0) })) + '</div></div>' +
            '<span style="display:flex;align-items:center;gap:7px;flex:none;">' +
            '<button type="button" data-act="led-dec" data-kind="' + d[0] + '" style="' + decMini(q > 0) + '">−</button>' +
            '<span style="font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;min-width:12px;text-align:center;">' + q + '</span>' +
            '<button type="button" data-act="led-inc" data-kind="' + d[0] + '" style="width:24px;height:24px;border-radius:50%;border:none;background:var(--color-bg-deep);color:var(--color-text);font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">+</button></span></div>';
        });
        html += '</div>';
        var ledN = (state.led.rgbw || 0) + (state.led.white || 0) + (state.led.kww || 0);
        if (ledN > 0) {
          var reqL = E.compute(CAT, state).req || {};
          if (!(reqL.ambient || reqL.ambient_mw)) {
            html += '<div style="margin-top:10px;display:flex;align-items:flex-start;gap:8px;font-size:12px;color:var(--color-muted);line-height:1.5;"><img src="' + uiIcon('info.svg') + '" alt="" style="width:14px;height:14px;opacity:.55;margin-top:2px;flex:none;"><span>' + esc(t('led_needs_ambient')) + '</span></div>';
          }
        }
      }
      body('lichter').innerHTML = html;
    }

    function rTank() {
      var tanks = E.tankAll(CAT, state);
      var html = '<div class="rvk-grid-tank">';
      tanks.forEach(function (tk) {
        var selT = on(tk.id);
        html += '<div style="' + comboCard(selT) + '">';
        html += '<div data-act="toggle" data-id="' + esc(tk.id) + '" data-sektion="tank" style="display:flex;align-items:center;gap:14px;cursor:pointer;">' +
          '<div style="' + iconWrap() + '">' + levelLottieHtml(levelKey(tk), tk.demo_wert != null ? tk.demo_wert : 70, 'width:42px;height:42px;display:block;', true, tk.icon || 'X_Utility_Gauge') + '</div>' +
          '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selT) + '">' + esc(tk.label) + '</div><div style="' + subStyle(selT) + '">' + esc(tk.sub || '') + '</div></div>' +
          '<span style="' + addStyle(selT) + '">' + addIconHtml(selT) + '</span></div>';
        if (selT) {
          var kind = E.tankKind(tk);
          var sOn = E.sensorOn(state, tk.id);
          var step = E.tankStep(state, tk.id);
          var gt = E.gasType(state, tk.id);
          html += '<div style="margin-top:13px;padding-top:13px;border-top:1px solid rgba(255,255,255,.16);">';
          if (kind === 'gas') {
            /* Gas: Standard KEIN Sensor. Wählbar: Livello (wiederbefüllbare Alugas)
               oder SuperSense Scale X (tauschbare 11-kg-Stahlflasche). */
            html += '<div style="display:flex;align-items:center;gap:7px;margin-bottom:10px;"><span style="font-family:var(--font-heading);font-weight:600;font-size:13px;color:#fff;">' + esc(t('gas_sensor_label')) + '</span>' +
              '<button type="button" data-act="info" data-key="tanksensor" style="width:18px;height:18px;border-radius:50%;border:none;background:rgba(255,255,255,.16);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:11px;font-style:italic;cursor:pointer;display:flex;align-items:center;justify-content:center;flex:none;padding:0;">i</button></div>' +
              '<div style="display:flex;gap:8px;flex-wrap:wrap;">' +
              '<button type="button" data-act="gas" data-id="' + esc(tk.id) + '" data-type="none" style="' + pillBtn(gt === 'none') + '">' + esc(t('gas_sensor_none')) + '</button>' +
              '<button type="button" data-act="gas" data-id="' + esc(tk.id) + '" data-type="livello" style="' + pillBtn(gt === 'livello') + '">' + esc(t('gas_sensor_livello')) + '</button>' +
              '<button type="button" data-act="gas" data-id="' + esc(tk.id) + '" data-type="steel" style="' + pillBtn(gt === 'steel') + '">' + esc(t('gas_sensor_steel')) + '</button></div>';
            if (gt === 'livello' || gt === 'steel') {
              var gName = gt === 'steel' ? t('gas_scale_name') : t('gas_livello_name');
              var gNote = gt === 'steel' ? t('gas_scale_note') : t('gas_livello_note');
              var gPrice = gt === 'steel' ? euro(productPrice('scale_x')) : t('on_request');
              html += '<div style="margin-top:12px;display:flex;align-items:center;gap:11px;">' +
                '<span style="flex:1;min-width:0;"><span style="display:block;font-family:var(--font-heading);font-weight:600;font-size:13px;color:#fff;">' + esc(gName) + '</span><span style="display:block;font-size:11px;color:rgba(255,255,255,.6);">' + esc(gNote) + '</span></span>' +
                '<span style="font-family:var(--font-heading);font-weight:600;font-size:14px;color:#fff;white-space:nowrap;">' + esc(gPrice) + '</span></div>';
            }
          } else {
            var sensorName, cartNote, priceLabel;
            if (kind === 'water') {
              var lenTitles = [t('tank_step_0'), t('tank_step_1'), t('tank_step_2')];
              var len = E.VOTRONIC_STEPS[step].len;
              sensorName = t('votronic_name'); cartNote = lenTitles[step]; priceLabel = euro(productPrice('votronic', [len]));
            } else {
              sensorName = t('fuel_name'); cartNote = t('fuel_note'); priceLabel = t('onsite');
            }
            html += '<div style="display:flex;align-items:center;gap:11px;">' +
              '<span data-act="sensor-toggle" data-id="' + esc(tk.id) + '" style="' + checkBox(sOn) + '">' + (sOn ? '<img src="' + uiIcon('check.svg') + '" alt="" style="width:13px;height:13px;filter:brightness(0) invert(1);">' : '') + '</span>' +
              '<span style="flex:1;min-width:0;"><span style="display:block;font-family:var(--font-heading);font-weight:600;font-size:13px;color:#fff;">' + esc(sensorName) + '</span><span style="display:block;font-size:11px;color:rgba(255,255,255,.6);">' + esc(cartNote) + '</span></span>' +
              '<span style="font-family:var(--font-heading);font-weight:600;font-size:14px;color:#fff;white-space:nowrap;">' + esc(priceLabel) + '</span></div>';
            if (sOn && kind === 'water') {
              var stepLabels = [t('tank_step_0'), t('tank_step_1'), t('tank_step_2')];
              html += '<div style="margin-top:14px;">' +
                '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;"><span style="display:flex;align-items:center;gap:7px;font-size:12px;color:rgba(255,255,255,.85);">' + esc(t('tank_height')) +
                '<button type="button" data-act="info" data-key="tanksensor" style="width:18px;height:18px;border-radius:50%;border:none;background:rgba(255,255,255,.16);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:11px;font-style:italic;cursor:pointer;display:flex;align-items:center;justify-content:center;flex:none;padding:0;">i</button></span>' +
                '<span style="font-family:var(--font-heading);font-weight:600;font-size:13px;color:var(--color-cyan);">' + esc(stepLabels[step]) + '</span></div>' +
                '<input type="range" class="rvk-range" data-tank="' + esc(tk.id) + '" min="0" max="2" step="1" value="' + step + '">' +
                '<div style="display:flex;justify-content:space-between;font-size:10px;color:rgba(255,255,255,.55);margin-top:2px;"><span>' + esc(t('tank_step_0')) + '</span><span>' + esc(t('tank_step_1')) + '</span><span>' + esc(t('tank_step_2')) + '</span></div>' +
                '<div style="font-size:12px;color:var(--color-cyan);font-weight:600;margin-top:9px;">' + esc(t('tank_votronic', { len: E.VOTRONIC_STEPS[step].label })) + '</div></div>';
            } else if (sOn && kind === 'fuel') {
              var fq = encodeURIComponent(t('eng_fuel_search', { tank: tk.label }));
              html += '<div style="margin-top:10px;font-size:12px;color:rgba(255,255,255,.7);line-height:1.5;">' + esc(t('fuel_hint')) + '</div>' +
                '<a href="https://www.google.com/search?q=' + fq + '" target="_blank" rel="noopener noreferrer" style="display:inline-flex;align-items:center;gap:6px;margin-top:9px;font-size:12px;font-weight:600;color:var(--color-cyan);text-decoration:none;">' + esc(t('fuel_search_link')) + ' →</a>';
            }
          }
          html += '</div>';
        }
        html += '</div>';
      });
      html += '</div>';
      html += addFormHtml('tank');
      body('tank').innerHTML = html;
      mountLevelLotties(body('tank'), false);
    }

    function rEnergie(computed) {
      var html = '<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px;"><span style="font-size:14px;font-weight:600;">' + esc(t('bms_question')) + '</span>' +
        '<button type="button" data-act="info" data-key="energy_bms" style="width:22px;height:22px;border-radius:50%;border:none;background:#fff;box-shadow:var(--shadow-widget);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;flex:none;"><img src="' + uiIcon('info.svg') + '" alt="Info" style="width:12px;height:12px;opacity:.6;"></button></div>' +
        '<div style="display:flex;gap:10px;flex-wrap:wrap;">' +
        '<button type="button" data-act="bms" data-val="yes" style="' + seg(state.batBms === 'yes') + '">' + esc(t('bms_yes')) + '</button>' +
        '<button type="button" data-act="bms" data-val="no" style="' + seg(state.batBms === 'no') + '">' + esc(t('bms_no')) + '</button></div>';

      if (state.batBms === 'yes') {
        var bmsList = byBereich('bms_batterie');
        html += '<div style="margin-top:18px;"><div style="font-size:14px;font-weight:600;margin-bottom:9px;">' + esc(t('bms_which')) + '</div><div class="rvk-grid-cards">';
        bmsList.forEach(function (b) {
          var selB = state.bmsBat === b.id;
          var other = !!extra(b).other;
          /* Bild-Priorität: freigestelltes Geräte-Rendering (extra.device auf R2) >
             Item-Icon > Shopify-Produktbild > generisches Batterie-Icon.
             Alt-Daten tragen device ohne Ordner ("ecoflow.png") → devices/ voranstellen. */
          var bx = extra(b);
          var bDev = bx.device && String(bx.device).indexOf('/') < 0 ? 'devices/' + bx.device : bx.device;
          var img = bDev ? (AB + '/' + bDev)
            : b.icon ? appIcon(b.icon)
            : (b.produkt && b.produkt.img) || appIcon('X_Device_Battery');
          var note = selB ? (other ? t('bms_note_other_sel') : t('bms_note_selected')) : (other ? t('bms_note_other') : t('bms_note', { bus: extra(b).busLabel || 'CAN' }));
          html += '<div data-act="bms-pick" data-id="' + esc(b.id) + '" style="' + cardStyle(selB) + '">' +
            '<div style="' + iconWrap() + '"><img src="' + esc(img) + '" alt="" style="width:46px;height:46px;object-fit:contain;' + ((bx.device || b.icon) && !other ? '' : iconImg(selB)) + '"></div>' +
            '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selB) + '">' + esc(b.label) + '</div>' +
            '<div style="' + subStyle(selB) + '">' + esc(b.sub || '') + '</div>' +
            '<div style="' + noteStyle(selB) + '">' + esc(note) + '</div></div>' +
            '<span style="' + addStyle(selB) + '">' + addIconHtml(selB) + '</span></div>';
        });
        html += '</div></div>';
      }

      if (state.batBms === 'no') {
        var hcP = euro(productPrice('battery_hc'));
        var batP = euro(productPrice('battery'));
        var modes = [
          { id: 'hc', name: t('bat_hc_name'), sub: t('bat_hc_sub'), note: t('bat_hc_note', { price: hcP }), widgets: ['battery'] },
          { id: 'battery', name: t('bat_ch_name'), sub: t('bat_ch_sub'), note: t('bat_ch_note', { price: batP }), widgets: ['battery', 'energyflow'], plus: true }
        ];
        /* Widgets liegen direkt auf der Karte (Jasper 13.10.2026: keine graue Fläche),
           mit dem gerichteten Schatten der App-Kacheln. Beide 2×2 (quadratisch); bei der
           Kanal-Übersicht sagt ein „+“ dazwischen: Energiefluss kommt DAZU. */
        var wImg = function (name) {
          return '<img class="rvk-wprev" src="' + esc(widgetPreview(name)) + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">';
        };
        var wPlus = '<span class="rvk-wprev-plus" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></span>';
        html += '<div style="margin-top:18px;"><div style="font-size:14px;font-weight:600;margin-bottom:9px;">' + esc(t('measure_question')) + '</div><div class="rvk-grid-cards rvk-grid-batmode">';
        modes.forEach(function (m) {
          var selM = state.batMode === m.id;
          /* Karte hochkant: oben die Widgets, darunter Text + Auswahl. Bewusst kein
             „flex:1" im Text-Container — die Mobil-Regel für .rvk-grid-cards würde ihn
             sonst auf volle Breite zwingen und den Haken aus der Karte schieben. */
          html += '<div data-act="batmode" data-id="' + m.id + '" class="rvk-batmode' + (m.plus ? ' rvk-batmode--plus' : '') + '" style="' + cardStyle(selM) + 'flex-direction:column;align-items:stretch;gap:14px;">' +
            '<div class="rvk-wprev-row">' + m.widgets.map(wImg).join(m.plus ? wPlus : '') + '</div>' +
            '<div style="display:flex;align-items:center;gap:12px;text-align:left;">' +
            '<div style="flex-grow:1;min-width:0;"><div style="' + labelStyle(selM) + '">' + esc(m.name) + '</div>' +
            '<div style="' + subStyle(selM) + '">' + esc(m.sub) + '</div>' +
            '<div style="' + noteStyle(selM) + '">' + esc(m.note) + '</div></div>' +
            '<span style="' + addStyle(selM) + '">' + addIconHtml(selM) + '</span></div></div>';
        });
        html += '</div></div>';

        if (state.batMode === 'battery') {
          var devices = byBereich('energie_geraet');
          html += '<div style="margin-top:16px;"><div style="font-size:14px;font-weight:600;margin-bottom:9px;">' + esc(t('endev_question')) + '</div><div class="rvk-grid-endev">';
          devices.forEach(function (d) {
            var selD = on(d.id);
            var note = (d.id === 'endev_wr' && selD) ? t('endev_wr_note', { price: euro(productPrice('battery_hc')) }) : '';
            html += '<div data-act="toggle" data-id="' + esc(d.id) + '" data-sektion="energie" style="' + cardStyle(selD) + '">' +
              '<div style="' + iconWrap() + '">' + iconTag(d.icon || 'X_Energy_Flash.svg', 'width:32px;height:32px;' + iconImg(selD), 'X_Energy_Flash') + '</div>' +
              '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selD) + '">' + esc(d.label) + '</div>' +
              '<div style="' + subStyle(selD) + '">' + esc(d.sub || '') + '</div>' +
              (note ? '<div style="font-size:11px;font-weight:600;margin-top:6px;color:rgba(255,255,255,.8);">' + esc(note) + '</div>' : '') + '</div>' +
              '<span style="' + addStyle(selD) + '">' + addIconHtml(selD) + '</span></div>';
          });
          html += '</div>';
          var devN = computed.plan.devices.length;
          html += '<div style="font-size:12px;color:var(--color-muted);margin-top:8px;">' +
            esc(devN ? (devN > 1 ? t('flow_hint_channels', { count: devN }) : t('flow_hint_channel')) : t('flow_hint_active')) + '</div>';
          /* Ladebooster-Ladestrom → ab 50 A ergänzt die Engine ein eigenes High Current */
          if (on('endev_booster')) {
            var ba = state.boosterAmp || 0;
            html += '<div style="margin-top:12px;background:#fff;border-radius:16px;padding:13px 15px;box-shadow:var(--shadow-widget);">' +
              '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">' +
              '<span style="flex:1;min-width:0;font-size:13px;font-weight:600;font-family:var(--font-heading);">' + esc(t('booster_amp_q')) + '</span>' +
              '<span style="display:inline-flex;align-items:center;gap:6px;flex:none;"><input type="number" class="rvk-amp" data-amp="1" min="0" max="200" step="5" value="' + ba + '" style="width:66px;padding:8px 10px;border:1px solid var(--color-line);border-radius:10px;font-family:var(--font-heading);font-weight:600;font-size:14px;text-align:right;color:var(--color-text);background:var(--color-bg-deep);"><span style="font-size:13px;font-weight:600;color:var(--color-muted);">A</span></span></div>' +
              (ba >= 50
                ? '<div style="margin-top:9px;font-size:12px;font-weight:600;color:var(--color-cyan-dark);">' + esc(t('booster_amp_hc')) + '</div>'
                : '<div style="margin-top:7px;font-size:11px;color:var(--color-muted);line-height:1.45;">' + esc(t('booster_amp_hint')) + '</div>') +
              '</div>';
          }
          html += '</div>';
        }
      }

      /* ── Victron VE.Direct (27.08.2026, Jasper): Geräte-Oberklassen als Zähler,
         jedes Gerät bucht im Hintergrund 1× VE-Direct-Bundle (Punkt-zu-Punkt).
         Unabhängig von der BMS-Frage — ein SmartShunt ersetzt z. B. die
         NODE-Battery-Messung, ein MPPT kommt oft zusätzlich. ── */
      var vedItems = byBereich('vedirect');
      if (vedItems.length) {
        var vedN = E.vedirectCount(CAT, state);
        html += '<div style="margin:24px 0 16px;height:1px;background:var(--color-line);"></div>' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:9px;"><span style="font-size:14px;font-weight:600;">' + esc(t('ved_question')) + '</span>' +
          '<button type="button" data-act="info" data-key="vedirect" style="width:22px;height:22px;border-radius:50%;border:none;background:#fff;box-shadow:var(--shadow-widget);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;flex:none;"><img src="' + uiIcon('info.svg') + '" alt="Info" style="width:12px;height:12px;opacity:.6;"></button></div>' +
          '<div class="rvk-grid-cards">' + vedItems.map(function (d) { return optCard(d, 'energie'); }).join('') + '</div>';
        if (vedN > 0) {
          var vedP = null;
          vedItems.forEach(function (d) { if (!vedP && d.produkt) vedP = d.produkt; });
          var vedV = vedP ? E.pickVariant(vedP, []) : null;
          html += '<div style="margin-top:10px;font-size:12px;font-weight:600;color:var(--color-cyan-dark);">' +
            esc(t('ved_hint', { count: vedN, price: euro(vedV ? vedV.price : 0) })) + '</div>';
        }
      }

      html += '<div style="margin-top:18px;background:#fff;border-radius:20px;padding:15px 18px;box-shadow:var(--shadow-widget);">' +
        '<div style="font-size:13px;font-weight:600;margin-bottom:3px;">' + esc(t('disclaimer_title')) + '</div>' +
        '<div style="font-size:12px;color:var(--color-muted);line-height:1.55;">' + esc(t('disclaimer_text')) + '</div></div>';
      body('energie').innerHTML = html;
    }

    function rTemp() {
      var items = E.tempAll(CAT, state);
      var html = '<div class="rvk-grid-cards">' + items.map(function (d) { return optCard(d, 'temp'); }).join('') + '</div>';
      html += addFormHtml('temp');
      var cap = E.tempCapCount(CAT, state);
      if (cap > 0) {
        var q = E.tempSensorQty(CAT, state);
        var price = productPrice('temp_sensor', ['3']);
        html += '<div style="margin:24px 0 16px;height:1px;background:var(--color-line);"></div>' +
          '<div style="font-family:var(--font-heading);font-weight:600;font-size:16px;margin-bottom:5px;">' + esc(t('temp_acc_title')) + '</div>' +
          '<p style="margin:0 0 16px;font-size:13px;color:var(--color-muted);line-height:1.55;max-width:520px;">' + esc(t('temp_acc_desc')) + '</p>' +
          '<div style="background:#fff;border-radius:20px;padding:16px;box-shadow:var(--shadow-widget);display:flex;align-items:center;gap:14px;">' +
          '<div style="width:64px;height:64px;border-radius:14px;flex:none;overflow:hidden;background:#fff;display:flex;align-items:center;justify-content:center;">' + accImgTag('temp_sensor', 'width:100%;height:100%;object-fit:cover;', 'X_Temp_Outside') + '</div>' +
          '<div style="flex:1;min-width:0;"><div style="font-family:var(--font-heading);font-weight:600;font-size:15px;">' + esc(t('temp_acc_name')) + '</div><div style="font-size:12px;color:var(--color-muted);margin-top:1px;">' + esc(t('temp_acc_meta', { price: euro(price) })) + '</div></div>' +
          '<span style="display:flex;align-items:center;gap:9px;flex:none;">' +
          '<button type="button" data-act="tempsens-dec" style="' + decMini(q > 0) + '">−</button>' +
          '<span style="font-family:var(--font-heading);font-weight:600;font-size:16px;font-variant-numeric:tabular-nums;min-width:14px;text-align:center;">' + q + '</span>' +
          '<button type="button" data-act="tempsens-inc" style="width:30px;height:30px;border-radius:50%;border:none;background:var(--color-text);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;padding:0;">+</button></span></div>';
      }
      body('temp').innerHTML = html;
    }

    function rBewegung() {
      var items = E.bewegungAll(CAT, state);
      var html = '<div class="rvk-grid-cards">' + items.map(function (d) { return optCard(d, 'bewegung'); }).join('') + '</div>';
      html += addFormHtml('bewegung');
      body('bewegung').innerHTML = html;
    }

    function rPanel() {
      var p = CAT.products.panel;
      if (!p) { body('panel').innerHTML = ''; return; }
      var v4 = E.pickVariant(p, ['4']);
      var v8 = E.pickVariant(p, ['8']);
      var defs = [
        { size: '4', v: v4, label: t('panel_4_label'), sub: t('panel_4_sub') },
        { size: '8', v: v8, label: t('panel_8_label'), sub: t('panel_8_sub') }
      ];
      /* Größenspezifische Produktbilder (4" = Panel Mini, 8" = Panel Maxi) — dieselbe
         Engine-Funktion wie für Leiste, Details und PDF (E.panelImg). Hartkodierte CDN-URLs
         liefen nach einem erneuten Upload ins 404 (Jasper, 08.09.2026). */
      var panelImgFor = function (size, variant) { return E.panelImg(p, size, variant); };
      var html = '<div class="rvk-grid-cards">';
      defs.forEach(function (d) {
        if (!d.v) return;
        var selP = state.panel === d.size;
        var own = panelImgFor(d.size, d.v);
        var pImg = own
          ? '<img class="rvk-prod has-bg" src="' + esc(own) + '" data-fb="' + esc(productImgSources('panel').join('|')) + '" alt="" style="width:46px;height:46px;object-fit:contain;">'
          : productImgTag('panel', 'width:46px;height:46px;object-fit:contain;', appIcon('X_Utility_Backup'));
        html += '<div data-act="panel-pick" data-size="' + d.size + '" style="' + cardStyle(selP) + '">' +
          '<div style="' + iconWrap() + '">' + pImg + '</div>' +
          '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selP) + '">' + esc(d.label) + '</div>' +
          '<div style="' + subStyle(selP) + '">' + esc(d.sub) + '</div>' +
          '<div style="' + noteStyle(selP) + '">' + euro(d.v.price) + '</div></div>' +
          '<span style="' + addStyle(selP) + '">' + addIconHtml(selP) + '</span></div>';
      });
      /* Eigenes Tablet verwenden — kostenlos, bis zu 3 Endgeräte gleichzeitig */
      var selTab = state.panel === 'tablet';
      var tabletSvg = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2.5" width="16" height="19" rx="2.5"></rect><line x1="10" y1="18.5" x2="14" y2="18.5"></line></svg>';
      html += '<div data-act="panel-pick" data-size="tablet" style="' + cardStyle(selTab) + '">' +
        '<div style="' + iconWrap() + 'color:' + (selTab ? '#fff' : 'var(--color-text)') + ';">' + tabletSvg + '</div>' +
        '<div style="flex:1;min-width:0;"><div style="' + labelStyle(selTab) + '">' + esc(t('panel_tablet_label')) + '</div>' +
        '<div style="' + subStyle(selTab) + '">' + esc(t('panel_tablet_sub')) + '</div>' +
        '<div style="' + noteStyle(selTab) + '">' + esc(euro(0)) + '</div></div>' +
        '<span style="' + addStyle(selTab) + '">' + addIconHtml(selTab) + '</span></div>';
      html += '</div>' +
        '<div style="margin-top:12px;display:flex;align-items:flex-start;gap:9px;font-size:12px;color:var(--color-muted);line-height:1.5;"><img src="' + uiIcon('info.svg') + '" alt="" style="width:14px;height:14px;opacity:.55;margin-top:1px;flex:none;"><span>' + esc(t('panel_devices_info')) + '</span></div>' +
        '<div style="margin-top:8px;font-size:12px;color:var(--color-muted);">' + esc(t('panel_note')) + '</div>';
      body('panel').innerHTML = html;
    }

    var einbauHtmlCache = null;
    function rEinbau(lines) {
      var html = '<div class="rvk-grid-choice">' +
        '<div data-act="install-self" style="' + choice(state.install === 'self') + '">' +
        '<div style="font-size:28px;margin-bottom:8px;">🔧</div>' +
        '<div style="font-family:var(--font-heading);font-weight:600;font-size:16px;">' + esc(t('self_label')) + '</div>' +
        '<div style="font-size:13px;color:var(--color-muted);margin-top:5px;line-height:1.5;">' + esc(t('self_sub')) + '</div></div>' +
        '<div data-act="install-partner" style="' + choice(state.install === 'partner') + '">' +
        '<div style="font-size:28px;margin-bottom:8px;">📍</div>' +
        '<div style="font-family:var(--font-heading);font-weight:600;font-size:16px;">' + esc(t('partner_label')) + '</div>' +
        '<div style="font-size:13px;color:var(--color-muted);margin-top:5px;line-height:1.5;">' + esc(t('partner_sub')) + '</div></div></div>';

      if (state.install === 'self') {
        html += '<div class="rvk-anim-in" style="margin-top:16px;background:linear-gradient(150deg,#232e3e,#08121b);border-radius:24px;padding:22px;color:#fff;display:flex;align-items:center;gap:18px;flex-wrap:wrap;">' +
          '<div style="flex:1;min-width:200px;"><div style="font-family:var(--font-heading);font-weight:600;font-size:17px;">' + esc(t('ready_title')) + '</div>' +
          '<div style="font-size:13px;opacity:.78;margin-top:5px;line-height:1.5;">' + esc(lines.cartItems.length ? t('ready_sub', { items: itemCountText(lines.itemCount) }) : t('cart_empty')) + '</div></div>' +
          '<button type="button" data-act="cart" style="background:#fff;color:var(--color-text);border:none;border-radius:9999px;padding:14px 24px;font-family:var(--font-heading);font-weight:600;font-size:15px;cursor:pointer;white-space:nowrap;">' + esc(t('cart_cta', { total: euro(lines.total) })) + '</button></div>';
      }
      if (state.install === 'partner') {
        /* Einbau-Kostenvoranschlag: Inhalt kommt aus renderInstallEstimate() — animiert, wenn
           der Kunde gerade „Einbauen lassen" gewählt hat, sonst still aktualisiert. */
        html += '<div id="rvk-install-slot" class="rvk-inst"></div>' +
          '<div class="rvk-anim-in" style="margin-top:16px;background:#fff;border-radius:24px;padding:6px;box-shadow:var(--shadow-widget);overflow:hidden;"><div id="rvk-map-slot"></div></div>' +
          '<div style="margin-top:14px;background:var(--color-bg-deep);border-radius:24px;padding:22px;">' +
          '<div style="font-family:var(--font-heading);font-weight:600;font-size:17px;margin-bottom:6px;">' + esc(t('handover_title')) + '</div>' +
          '<p style="margin:0 0 16px;font-size:13px;color:var(--color-muted);line-height:1.55;max-width:520px;">' + esc(t('handover_text')) + '</p>' +
          '</div>';
      }
      /* PDF-Export IMMER anbieten (Jasper 29.08.) — nicht nur im Händler-Zweig.
         Daneben der Konfigurations-Code: speichern, später zurückholen, und der
         Vertrieb macht daraus im CRM ein Angebot. */
      var btn = function (act, label, dark) {
        return '<button type="button" data-act="' + act + '" style="border:' + (dark ? 'none' : '1.5px solid var(--color-line,#d9e0e8)') +
          ';border-radius:9999px;padding:13px 22px;background:' + (dark ? 'var(--color-text)' : '#fff') +
          ';color:' + (dark ? '#fff' : 'var(--color-text)') +
          ';font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">' + esc(label) + '</button>';
      };
      html += '<div style="margin-top:14px;display:flex;gap:10px;flex-wrap:wrap;align-items:center;">' +
        btn('pdf', t('pdf_btn'), true) +
        (CONFIG_API ? '<span id="rvk-code-actions" style="display:contents;"></span>' : '') +
        '</div>' +
        (CONFIG_API ? '<div id="rvk-code-slot" style="margin-top:12px;"></div>' : '');
      /* Re-Render nur bei echter Änderung — ein appendChild/innerHTML würde die
         Map-iframe sonst bei JEDEM State-Change neu laden (leere/flackernde Karte). */
      if (einbauHtmlCache === html && el('rvk-map-slot')) return;
      einbauHtmlCache = html;
      body('einbau').innerHTML = html;

      var slot = el('rvk-map-slot');
      if (slot) {
        var code = E.code(state);
        if (!mapFrame || mapFrameCode !== code) {
          mapFrame = document.createElement('iframe');
          mapFrame.title = t('map_title');
          mapFrame.loading = 'lazy';
          mapFrame.style.cssText = 'width:100%;height:380px;border:none;border-radius:20px;display:block;';
          mapFrameCode = code;
          mapFrame.src = MAP_URL + (MAP_URL.indexOf('?') >= 0 ? '&' : '?') + 'config=' + encodeURIComponent(code);
        }
        slot.appendChild(mapFrame);
      }
      renderCodeSlot();
    }

    /* Anzeige des Konfigurations-Codes am Ende (Einbau-Sektion). Wird nach jedem
       Re-Render neu gezeichnet. Zustände: kein Code → „Konfiguration speichern";
       Code + geändert → „Konfiguration aktualisieren" (Akzent) + ehrlicher Hinweis;
       Code + unverändert → „Gespeichert · gültig bis …". */
    var codeSlotCache = { acts: null, slot: null };
    function renderCodeSlot() {
      var slot = el('rvk-code-slot'), acts = el('rvk-code-actions');
      if (!slot || !acts) return;
      var setHtml = function (node, which, html) {
        if (codeSlotCache[which] === html && node.innerHTML !== '' === (html !== '')) return;
        codeSlotCache[which] = html; node.innerHTML = html;
      };
      var stale = codeStale();
      var busy = ui.codeMsg === 'saving';
      var pill = function (act, label, accent) {
        return '<button type="button" data-act="' + act + '"' + (busy ? ' disabled' : '') + ' style="border:1.5px solid ' + (accent ? 'var(--color-cyan,#30b6c6)' : 'var(--color-line,#d9e0e8)') +
          ';border-radius:9999px;padding:13px 22px;background:' + (accent ? 'var(--color-cyan,#30b6c6)' : '#fff') +
          ';color:' + (accent ? '#fff' : 'var(--color-text)') +
          ';font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;' + (busy ? 'opacity:.6;' : '') + '">' + esc(label) + '</button>';
      };
      if (!savedCode) setHtml(acts, 'acts', pill('cfg-save', busy ? t('code_saving') : t('code_save_btn'), false));
      else if (stale || busy) setHtml(acts, 'acts', pill('cfg-save', busy ? t('code_saving') : t('code_update_btn'), true));
      else setHtml(acts, 'acts', '');

      if (!savedCode) { setHtml(slot, 'slot', ui.codeMsg === 'error' ? codeNote(t('code_error')) : ui.codeMsg === 'ratelimit' ? codeNote(t('code_error_ratelimit')) : ''); return; }
      var status;
      if (ui.codeMsg === 'error') status = '<p class="rvk-code-status rvk-code-status--err">' + esc(t('code_error')) + '</p>';
      else if (ui.codeMsg === 'ratelimit') status = '<p class="rvk-code-status rvk-code-status--err">' + esc(t('code_error_ratelimit')) + '</p>';
      else if (ui.codeMsg === 'replaced') status = '<p class="rvk-code-status rvk-code-status--stale">' + esc(t('code_replaced', { code: savedCode })) + '</p>';
      else if (ui.codeMsg === 'updated') status = '<p class="rvk-code-status rvk-code-status--ok">' + esc(t('code_updated')) + '</p>';
      else if (stale) status = '<p class="rvk-code-status rvk-code-status--stale">' + esc(t('code_stale')) + '</p>';
      else status = '<p class="rvk-code-status rvk-code-status--ok">' + esc(savedCodeExpires ? t('code_saved_ok', { date: fmtDate(savedCodeExpires) }) : t('code_saved_ok_nodate')) + '</p>';
      if (ui.codeRemote) {
        status += '<p class="rvk-code-status rvk-code-status--stale">' + esc(t('code_remote_updated', { date: fmtDateTime(ui.codeRemote.updatedAt) })) +
          ' <button type="button" class="rvk-code-inlinelink" data-act="cfg-load-remote"' + (busy ? ' disabled' : '') + '>' + esc(t('code_remote_load')) + '</button></p>';
      }
      var small = 'border:1.5px solid var(--color-line,#d9e0e8);border-radius:9999px;padding:11px 18px;background:#fff;color:var(--color-text);font-family:var(--font-heading);font-weight:600;font-size:13px;cursor:pointer;';
      setHtml(slot, 'slot',
        '<div class="rvk-anim-in" style="background:var(--color-bg-deep);border-radius:20px;padding:18px 20px;">' +
        '<div style="font-family:var(--font-heading);font-weight:600;font-size:15px;margin-bottom:10px;">' + esc(t('code_title')) + '</div>' +
        '<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:center;">' +
        '<code style="font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:20px;font-weight:700;letter-spacing:.06em;background:#fff;border-radius:12px;padding:10px 16px;">' + esc(savedCode) + '</code>' +
        '<button type="button" data-act="cfg-copy" style="' + small + '">' + esc(t(ui.codeCopied === 'code' ? 'code_copied' : 'code_copy')) + '</button>' +
        '<button type="button" data-act="cfg-copy-link" style="' + small + '">' + esc(t(ui.codeCopied === 'link' ? 'code_copied' : 'code_copy_link')) + '</button>' +
        '</div>' +
        status +
        '<p style="margin:12px 0 0;font-size:13px;color:var(--color-muted);line-height:1.55;max-width:560px;">' + esc(t('code_hint')) + '</p>' +
        '<button type="button" class="rvk-code-newlink" data-act="cfg-save-new"' + (busy ? ' disabled' : '') + '>' + esc(t('code_save_new')) + '</button>' +
        '</div>');
    }
    function codeNote(msg) {
      return '<div style="background:var(--color-bg-deep);border-radius:16px;padding:14px 18px;font-size:13px;color:var(--color-muted);">' + esc(msg) + '</div>';
    }

    /* Code-Zeile im aufgeklappten Detail-Panel der Summary-Bar (überall erreichbar). */
    function renderBarCode() {
      var slot = el('rvk-panel-code');
      if (!slot) return;
      if (!savedCode || !CONFIG_API) { slot.innerHTML = ''; return; }
      var stale = codeStale();
      slot.innerHTML = '<span class="rvk-panel-codelbl">' + esc(t('code_active', { code: savedCode })) + '</span> · ' +
        (ui.codeMsg === 'saving' ? '<span>' + esc(t('code_saving')) + '</span>'
          : stale ? '<button type="button" class="rvk-panel-codebtn" data-act="cfg-save">' + esc(t('code_bar_update')) + '</button>'
          : ui.codeRemote ? '<button type="button" class="rvk-panel-codebtn" data-act="cfg-load-remote">' + esc(t('code_remote_short')) + '</button>'
          : '<span>' + esc(t('code_bar_saved')) + '</span>');
    }

    /* Dezentes „Konfiguration laden" oben im Kopf. Rendert nur bei geändertem Zustand neu
       (Signatur), damit Tippen im Feld nicht durch fremde Re-Renders unterbrochen wird. */
    var codeTopSig = null;
    function renderCodeTop() {
      var slot = el('rvk-code-top');
      if (!slot) return;
      if (!CONFIG_API) { slot.innerHTML = ''; return; }
      var mode = ui.codeLoad;
      var err = mode && typeof mode === 'object' ? mode.error : null;
      var open = mode === 'open' || mode === 'busy' || !!err;
      var sig = [open ? (mode === 'busy' ? 'busy' : (err || 'open')) : 'closed', ui.codeFlash || '', savedCode || '', savedCodeExpires || ''].join('|');
      if (sig === codeTopSig && slot.firstChild) return;
      codeTopSig = sig;
      var html;
      if (open) {
        var busy = mode === 'busy';
        html = '<div class="rvk-codetop-form">' +
          '<input id="rvk-code-input" class="rvk-codetop-input" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="14" placeholder="' + esc(t('code_load_placeholder')) + '" value="' + esc(ui.codeLoadDraft || '') + '"' + (busy ? ' disabled' : '') + '>' +
          '<button type="button" class="rvk-codetop-btn" data-act="cfg-load"' + (busy ? ' disabled' : '') + '>' + esc(busy ? t('code_loading') : t('code_load_btn')) + '</button>' +
          '<button type="button" class="rvk-codetop-x" data-act="cfg-load-close" aria-label="' + esc(t('cancel')) + '">×</button>' +
          '</div>' +
          (err ? '<div class="rvk-codetop-msg rvk-codetop-err">' + esc(t(err === 'notfound' ? 'code_load_notfound' : err === 'expired' ? 'code_load_expired' : err === 'format' ? 'code_load_format' : err === 'ratelimit' ? 'code_load_ratelimit' : 'code_load_error')) + '</div>' : '');
      } else if (ui.codeFlash) {
        html = '<div class="rvk-codetop-msg rvk-codetop-ok">' + esc(t('code_loaded', { code: ui.codeFlash })) + '</div>' +
          '<button type="button" class="rvk-codetop-link" data-act="cfg-load-open">' + esc(t('code_load_other')) + '</button>';
      } else if (savedCode) {
        html = '<div class="rvk-codetop-active">' +
          '<span>' + esc(t('code_active', { code: savedCode })) + (savedCodeExpires ? ' · ' + esc(t('code_valid_until', { date: fmtDate(savedCodeExpires) })) : '') + '</span>' +
          '<button type="button" class="rvk-codetop-link" data-act="cfg-load-open">' + esc(t('code_load_other')) + '</button>' +
          '</div>';
      } else {
        html = '<button type="button" class="rvk-codetop-link" data-act="cfg-load-open">' + esc(t('code_load_link')) + '</button>';
      }
      slot.innerHTML = html;
      if (open && mode !== 'busy') {
        var inp = el('rvk-code-input');
        if (inp) { try { inp.focus(); inp.setSelectionRange(inp.value.length, inp.value.length); } catch (e) {} }
      }
    }
    function codeLoadSubmit() {
      if (codeBusy) return;
      var inp = el('rvk-code-input');
      var raw = inp ? inp.value : (ui.codeLoadDraft || '');
      ui.codeLoadDraft = raw;
      var code = normalizeCode(raw);
      if (!code) { ui.codeLoad = { error: 'format' }; codeTopSig = null; renderCodeTop(); return; }
      if (code !== savedCode && hasSelection()) {
        var ok = true;
        try { ok = window.confirm(t('code_load_confirm')); } catch (e) { ok = true; }
        if (!ok) return;
      }
      ui.codeLoad = 'busy'; renderCodeTop();
      loadByCode(code, function (ok2, data, kind) {
        if (!ok2) { ui.codeLoad = { error: kind || 'error' }; codeTopSig = null; renderCodeTop(); return; }
        ui.codeLoad = null; ui.codeLoadDraft = ''; ui.codeMsg = null; ui.codeCopied = false; ui.codeFlash = savedCode;
        ui.adding = null; ui.info = null; ui.liteWarn = false;
        render();
        var flashed = savedCode;
        setTimeout(function () { if (ui.codeFlash === flashed) { ui.codeFlash = null; renderCodeTop(); } }, 7000);
      });
    }


    /* ══ Einbau-Kostenvoranschlag („Was kostet ein Einbau?") ═══════════════════
       Werkstattzeiten je Modul/Funktion liegen im Katalog (einbauzeit_min), der
       Stundensatz kommt vom gewählten Einbaupartner (Händlerkarte → postMessage),
       sonst aus den Partner-Stundensätzen der Karte (Median), sonst aus der
       Section-Einstellung. Angezeigt wird NUR der Von-bis-Rahmen — keine Einzelpreise. */
    var INST = SET.install || {};
    var instRates = null;        // Stundensätze der Partner aus dealers.json (Zahlen)
    var instRatesLoading = false;
    var instTracked = null;      // letzter getrackter Rahmen (from-to), gegen Doppelzählung
    function euroInt(v) {
      try { return Math.round(v).toLocaleString(MONEY_LOCALE) + ' €'; } catch (e) { return Math.round(v) + ' €'; }
    }
    /* Nur wenn der Partner wirklich einen Stundensatz mitgeliefert hat, darf die
       Basiszeile behaupten, mit seinem Satz gerechnet worden zu sein. Ohne Satz
       (dealers.json liefert dann null) gilt weiter der Durchschnitt — die Zeile
       muss das auch sagen (Befund Live-Test 11.09.2026). */
    function instPartnerRateUsed() {
      return !!(ui.instPartner && isFinite(ui.instPartner.rate) && ui.instPartner.rate > 0);
    }
    function instRate() {
      if (instPartnerRateUsed()) return ui.instPartner.rate;
      if (instRates && instRates.length) {
        var a = instRates.slice().sort(function (x, y) { return x - y; });
        var mid = Math.floor(a.length / 2);
        return a.length % 2 ? a[mid] : (a[mid - 1] + a[mid]) / 2;
      }
      var r = parseFloat(INST.rate);
      return isFinite(r) && r > 0 ? r : 150;
    }
    function installEstimateNow() {
      try {
        var factor = parseFloat(INST.factor);
        var est = E.installEstimate(CAT, state, {
          rate: instRate(),
          spread: parseFloat(INST.spread),
          factor: isFinite(factor) && factor > 0 ? factor / 100 : 1
        });
        // Nichts einzubauen (vorhandenes BRAIN, sonst nichts gewählt) → kein Rahmen
        return est && est.minutes > 0 ? est : null;
      } catch (e) { return null; }
    }
    /* Partner-Stundensätze einmal laden (dealers.json der Händlerkarte, Feld `stundensatz`).
       Nur Zahlen zwischen 30 und 300 €/h werden akzeptiert — alles andere ist Datenmüll. */
    function loadInstallRates() {
      if (instRates || instRatesLoading || !INST.ratesUrl) return;
      instRatesLoading = true;
      try {
        fetch(String(INST.ratesUrl), { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var list = (j && (j.dealers || j.items)) || [];
            instRates = list.map(function (d) { return d && parseFloat(d.stundensatz); })
              .filter(function (n) { return isFinite(n) && n >= 30 && n <= 300; });
            instRatesLoading = false;
            renderInstallEstimate(true);
          })
          .catch(function () { instRatesLoading = false; instRates = []; });
      } catch (e) { instRatesLoading = false; instRates = []; }
    }
    /* Von der Händlerkarte (iframe) gewählter Partner: { type:'rv-dealer-selected', name, stundensatz }.
       Nur vom Karten-Origin, alle Werte typgeprüft und gekappt (esc() beim Rendern). */
    (function () {
      var mapOrigin = '';
      try { mapOrigin = new URL(MAP_URL, window.location.href).origin; } catch (e) { mapOrigin = ''; }
      if (!mapOrigin) return;
      window.addEventListener('message', function (ev) {
        if (ev.origin !== mapOrigin) return;
        var d = ev.data;
        if (!d || typeof d !== 'object' || d.type !== 'rv-dealer-selected') return;
        var rate = parseFloat(d.stundensatz);
        var name = String(d.name || '').slice(0, 80);
        if (!name) return;
        ui.instPartner = { name: name, rate: (isFinite(rate) && rate >= 30 && rate <= 300) ? rate : null };
        renderInstallEstimate(true);
        track('config_partner_pick', { hasRate: !!ui.instPartner.rate });
      });
    })();

    var instSteps = ['inst_step_1', 'inst_step_2', 'inst_step_3', 'inst_step_4'];
    var INST_STEP_MS = 520, INST_COUNT_MS = 900;
    function reducedMotion() {
      try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
    }
    /* „ca." vor der Preisspanne steckt im CSS (::before) — den Text einmal als
       CSS-Variable setzen, damit er der Seitensprache folgt. */
    function setApproxPrefix() {
      var v = t('inst_approx');
      if (!v || v === 'inst_approx') return;
      try { document.documentElement.style.setProperty('--rvk-approx', JSON.stringify(v)); } catch (e) {}
    }
    function instResultHtml(e, animate) {
      var basis = instPartnerRateUsed()
        ? t('inst_partner', { name: ui.instPartner.name })
        : t('inst_partner_avg');
      return '<div class="rvk-inst-result' + (animate ? ' rvk-inst-result--in' : '') + '">' +
        '<div class="rvk-inst-label">' + esc(t('inst_label')) + '</div>' +
        '<div class="rvk-inst-range" data-from="' + e.from + '" data-to="' + e.to + '">' +
          esc(t('inst_range', { from: euroInt(animate ? 0 : e.from), to: euroInt(animate ? 0 : e.to) })) + '</div>' +
        '<div class="rvk-inst-meta">' + esc(t('inst_hours', { hours: nf1(e.hours) })) + ' · ' + esc(basis) + '</div>' +
        '<p class="rvk-inst-note">' + esc(t('inst_note')) + '</p>' +
        '<button type="button" class="rvk-inst-how" data-act="inst-how" aria-expanded="' + (ui.instHow ? 'true' : 'false') + '">' + esc(t('inst_how')) + '</button>' +
        (ui.instHow ? '<p class="rvk-inst-howtext rvk-anim-in">' + esc(t('inst_how_text')) + '</p>' : '') +
        '</div>';
    }
    function instCountUp(slot, e) {
      var el2 = slot.querySelector('.rvk-inst-range');
      if (!el2) return;
      var t0 = null;
      var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
      var step = function (ts) {
        if (t0 == null) t0 = ts;
        var k = Math.min(1, (ts - t0) / INST_COUNT_MS);
        var f = ease(k);
        el2.textContent = t('inst_range', { from: euroInt(e.from * f), to: euroInt(e.to * f) });
        if (k < 1 && slot.isConnected) requestAnimationFrame(step);
        else el2.textContent = t('inst_range', { from: euroInt(e.from), to: euroInt(e.to) });
      };
      requestAnimationFrame(step);
    }
    /* quiet = ohne neue Animation (Zahlen still nachführen, z. B. nach Änderung der Auswahl) */
    function renderInstallEstimate(quiet) {
      var slot = el('rvk-install-slot');
      if (!slot) { ui.instAnim = null; return; }
      if (state.install !== 'partner') { slot.innerHTML = ''; return; }
      loadInstallRates();
      setApproxPrefix();
      var e = installEstimateNow();
      if (!e) { slot.innerHTML = ''; return; }
      var key = e.from + '-' + e.to + '|' + (ui.instPartner ? ui.instPartner.name : '') + '|' + (ui.instHow ? 1 : 0);
      var head = '<div class="rvk-inst-head"><div class="rvk-inst-title">' + esc(t('inst_title')) + '</div>';
      // Fertiger Zustand ohne Ladeanzeige: Titel + Ergebnis (Reduced Motion, Wiederaufbau)
      var staticCard = function () {
        return '<div class="rvk-inst-card">' + head + '</div>' +
          '<div class="rvk-inst-resultslot">' + instResultHtml(e, false) + '</div></div>';
      };
      // Die Einbau-Sektion wurde neu aufgebaut (Slot leer), die Berechnung lief aber schon:
      // Karte still wiederherstellen statt ein zweites Mal zu animieren.
      if (ui.instAnim && ui.instAnim.done && !slot.firstChild) {
        slot.innerHTML = staticCard();
        ui.instAnim.key = key;
        return;
      }

      // Erster Aufbau nach dem Klick auf „Einbauen lassen": Spinner, darunter laufen die vier
      // Schritte dezent durch, dann verschwindet die Ladeanzeige und der Rahmen zählt hoch
      // (Jasper, 10.09.2026: horizontal statt Checkliste, danach weg).
      if (!ui.instAnim) {
        var anim = !reducedMotion();
        if (!anim) {
          ui.instAnim = { key: key, done: true, token: Date.now() };
          slot.innerHTML = staticCard();
          trackInstall(e);
          return;
        }
        ui.instAnim = { key: key, done: false, token: Date.now() };
        slot.innerHTML = '<div class="rvk-inst-card rvk-anim-in">' + head + '</div>' +
          '<div class="rvk-inst-loading" role="status" aria-live="polite"><span class="rvk-inst-spinner"></span>' +
          '<span class="rvk-inst-loadtext">' + esc(t(instSteps[0])) + '</span></div>' +
          '<div class="rvk-inst-resultslot"></div></div>';
        var token = ui.instAnim.token;
        var stepIdx = 0;
        var ticker = setInterval(function () {
          if (!ui.instAnim || ui.instAnim.token !== token || !slot.isConnected) { clearInterval(ticker); return; }
          stepIdx += 1;
          var lt = slot.querySelector('.rvk-inst-loadtext');
          if (!lt || stepIdx >= instSteps.length) { clearInterval(ticker); return; }
          lt.classList.add('rvk-inst-loadtext--swap');
          (function (txt) {
            setTimeout(function () { if (lt.isConnected) { lt.textContent = txt; lt.classList.remove('rvk-inst-loadtext--swap'); } }, 160);
          })(t(instSteps[stepIdx]));
        }, INST_STEP_MS);
        setTimeout(function () {
          clearInterval(ticker);
          if (!ui.instAnim || ui.instAnim.token !== token || !slot.isConnected) return;
          var cur = installEstimateNow() || e;
          var loading = slot.querySelector('.rvk-inst-loading');
          if (loading) loading.remove();
          var rs = slot.querySelector('.rvk-inst-resultslot');
          if (rs) { rs.innerHTML = instResultHtml(cur, true); instCountUp(slot, cur); }
          ui.instAnim.done = true; ui.instAnim.key = cur.from + '-' + cur.to + '|' + (ui.instPartner ? ui.instPartner.name : '') + '|' + (ui.instHow ? 1 : 0);
          trackInstall(cur);
        }, instSteps.length * INST_STEP_MS + 150);
        return;
      }
      // Läuft die Animation noch, nicht dazwischenfunken (die Zahl kommt am Ende frisch)
      if (!ui.instAnim.done) return;
      if (ui.instAnim.key === key) return;
      ui.instAnim.key = key;
      var rs2 = slot.querySelector('.rvk-inst-resultslot');
      if (rs2) {
        rs2.innerHTML = instResultHtml(e, !quiet);
        if (!quiet) instCountUp(slot, e);
      }
      trackInstall(e);
    }
    function trackInstall(e) {
      var k = e.from + '-' + e.to;
      if (instTracked === k) return;
      instTracked = k;
      track('config_install_estimate', { from: e.from, to: e.to, hours: e.hours, rate: Math.round(e.rate), partner: !!ui.instPartner });
    }

    /* ── Sticky-Bar ── */
    function lineImgTag(ln) {
      var key = String(ln.key);
      // Vorhandenes BRAIN: abgeblendet — gehört zum System, wird aber nicht verkauft
      if (key === 'brain_own') return productImgTag('brain', 'width:34px;height:34px;object-fit:contain;opacity:.4;filter:grayscale(1);');
      /* Panel 4"/8": das größenspezifische Shopbild aus der Engine (Mini/Maxi). Das feste
         R2-Bild products/panel.png zeigt das 4"-Panel — damit sah ein gewähltes 8"-Panel in
         Leiste und Details wie das kleine aus (Jasper, 13.10.2026). R2 bleibt Rückfall. */
      if (key === 'panel' && (state.panel === '4' || state.panel === '8') && ln.img) {
        return '<img class="rvk-prod has-bg" src="' + esc(ln.img) + '" data-fb="' + esc(productImgSources('panel').join('|')) + '" alt="" style="width:34px;height:34px;object-fit:contain;">';
      }
      if (key === 'brain' || key === 'brain_lite' || key === 'panel' || HW_MAP[key]) {
        return productImgTag(key, 'width:34px;height:34px;object-fit:contain;');
      }
      var src = lineImg(ln.img);
      if (!src) {
        if (key.indexOf('acc:tempsensor') === 0) src = appIcon('X_Temp_Outside');
        else if (key.indexOf('acc:led') === 0) src = appIcon('X_Light_Ambient');
        else src = appIcon('X_Utility_UnknownIcon');
      }
      var hasBg = /^(https?:)?\/\//.test(String(ln.img || '')) && String(ln.img).indexOf(AB) !== 0;
      return '<img src="' + esc(src) + '" alt="" class="' + (hasBg ? 'has-bg' : '') + '" style="width:34px;height:34px;object-fit:contain;">';
    }
    /* PayPal-Ratenzahlung: dezenter „Ratenzahlung – mehr erfahren"-Link unter dem Preis
       öffnet PayPals offizielles Ratenmodal (paypal.MessagesModal) mit dem LIVE-Gesamt-
       betrag — kein PayPal-Branding in der Bar selbst. WICHTIG: lines.total ist in CENT
       (euro() teilt /100) → für PayPal in Euro umrechnen. Das SDK stammt von Shopifys
       PayPal-Integration (echtes Händlerkonto → korrekte Konditionen); lädt async. */
    var PP_INFO_URL = 'https://www.paypal.com/de/webapps/mpp/paypal-ratenzahlung';
    var ppModal = null, ppAmt = 0, ppRendered = false;
    function ppSdk() {                       // eigener Namespace (siehe Section), Fallback window.paypal
      return (window.ppMerch && window.ppMerch.MessagesModal) ? window.ppMerch
           : ((window.paypal && window.paypal.MessagesModal) ? window.paypal : null);
    }
    /* Modal EINMAL ins DOM mounten (render) — ohne render() bleibt show() wirkungslos. */
    function ppEnsureModal() {
      if (ppModal) return true;
      var sdk = ppSdk(); if (!sdk) return false;
      try {
        /* offer:'PAY_LATER_LONG_TERM' → Modal öffnet DIREKT in der Raten-Berechnung
           (ohne den Zwischenschritt „30 Tage / Ratenzahlung"-Auswahl). */
        ppModal = sdk.MessagesModal({ amount: ppAmt || 1, currency: 'EUR', offer: 'PAY_LATER_LONG_TERM', buyerCountry: 'DE' });
        var r = ppModal.render('body');
        if (r && r.then) r.then(function () { ppRendered = true; }, function () { ppRendered = false; });
        else ppRendered = true;
      } catch (e) { ppModal = null; }
      return !!ppModal;
    }
    /* PayPal Ratenzahlung gilt nur von 99 € bis 10.000 € Bestellwert und läuft bei
       0 % eff. Jahreszins über max. 24 Raten → Monatsrate = Betrag / 24. Außerhalb
       der Spanne KEINE Rate ausweisen (wäre schlicht falsch) → Link ausblenden. */
    var PP_MIN = 99, PP_MAX = 10000, PP_RATEN = 24;
    function ppRender(totalCents) {
      var link = el('rvk-bar-pp'); if (!link) return;
      var eur = Math.round(totalCents || 0) / 100;              // Cent → Euro
      if (eur < PP_MIN || eur > PP_MAX) { link.hidden = true; ppAmt = 0; return; }
      ppAmt = Math.round(eur * 100) / 100;
      link.hidden = false;
      /* „– mehr erfahren" als eigener Span: wird mobil per CSS ausgeblendet, sonst
         schiebt der nowrap-Text den CTA-Button aus dem Viewport (QA-Overflow). */
      link.innerHTML = esc(t('pp_rate', { price: euro(totalCents / PP_RATEN) })) +
        '<span class="rvk-pp-more"> ' + esc(t('pp_more')) + '</span>';
      if (ppEnsureModal()) { try { ppModal.updateProps({ amount: ppAmt, offer: 'PAY_LATER_LONG_TERM', buyerCountry: 'DE' }); } catch (e) {} }
    }
    /* Klick: PayPal-Modal öffnen; klappt das nicht (SDK/Konto/Blocker), PayPals
       Ratenzahlungs-Infoseite in neuem Tab öffnen → der Link läuft nie ins Leere. */
    function ppShowModal() {
      if (ppAmt < 1) return;
      var ok = false;
      if (ppEnsureModal()) {
        try { ppModal.updateProps({ amount: ppAmt, offer: 'PAY_LATER_LONG_TERM', buyerCountry: 'DE' }); ppModal.show(); ok = true; } catch (e) { ok = false; }
      }
      if (!ok) { try { window.open(PP_INFO_URL, '_blank', 'noopener'); } catch (e) {} return; }
      // Sicherheitsnetz: erscheint binnen 1,6 s kein Modal-Frame, Infoseite öffnen
      setTimeout(function () {
        var frame = document.querySelector('iframe[name*="paypal_credit_modal"]');
        var visible = frame && frame.offsetParent !== null && frame.getBoundingClientRect().height > 80;
        if (!visible) { try { window.open(PP_INFO_URL, '_blank', 'noopener'); } catch (e) {} }
      }, 1600);
    }

    function renderBar(lines) {
      var full = state.brainMode === 'full';
      var own = state.brainMode === 'own';
      var brainP = CAT.products[full ? 'brain' : 'brain_lite'];
      var thumb = el('rvk-bar-thumb');
      setProductImg(thumb, own || full ? 'brain' : 'brain_lite');
      if (thumb) thumb.style.opacity = own ? '.4' : '';   // vorhandenes BRAIN: abgeblendet, ohne Preis
      el('rvk-bar-brain').textContent = own ? E.tx('eng_brain_own_name') : (brainP.title || (full ? 'BRAIN®' : 'BRAIN® Lite'));
      el('rvk-bar-count').textContent = itemCountText(lines.itemCount);
      el('rvk-bar-total-num').innerHTML = priceHtml(lines.total, lines.listTotal);
      el('rvk-bar-sum').innerHTML = priceHtml(lines.total, lines.listTotal);
      ppRender(lines.total);
      el('rvk-bar-cta').textContent =
        state.install === 'self' ? t('cart_cta', { total: euro(lines.total) })
        : state.install === 'partner' ? t('cta_partner')
        : t('cta_continue');
      el('rvk-bar').setAttribute('data-bar-open', ui.barOpen ? 'true' : 'false');
      el('rvk-bar-panel').setAttribute('data-open', ui.barOpen ? 'true' : 'false');

      var html = '';
      lines.lines.forEach(function (ln) {
        var isCovered = String(ln.key).indexOf('integ0:') === 0 || ln.key === 'brain_own';
        // priceHtml liefert fertiges (escaptes) HTML — daher unten kein esc()
        var price = ln.onRequest ? esc(t('on_request')) : (isCovered ? '—' : priceHtml(ln.total, ln.listTotal));
        html += '<div class="rvk-panel-line">';
        if (ln.indent) html += '<span class="rvk-li-indent"></span>';
        html += '<div class="rvk-li-thumb">' + lineImgTag(ln) + '</div>';
        html += '<div class="rvk-li-main"><div class="rvk-li-name">' + esc(ln.name) + '</div><div class="rvk-li-note">' + esc(ln.note || '') + '</div>' +
          (ln.preorder ? '<div class="rvk-li-preorder">' + esc(ln.preorderNote || t('preorder_note')) + '</div>' : '') + '</div>';
        if (ln.adjustable) {
          var canDec = ln.qty > (ln.minQty || 0);
          html += '<span class="rvk-li-step">' +
            '<button type="button" data-act="line-dec" data-key="' + esc(ln.key) + '" data-req="' + (ln.minQty || 0) + '"' + (canDec ? '' : ' disabled') + '>−</button>' +
            '<span class="rvk-li-count">' + ln.qty + '</span>' +
            '<button type="button" data-act="line-inc" data-key="' + esc(ln.key) + '" data-req="' + (ln.minQty || 0) + '">+</button></span>';
        } else {
          html += '<span class="rvk-li-qty">×' + ln.qty + '</span>';
        }
        html += '<span class="rvk-li-price">' + price + '</span></div>';
      });
      el('rvk-bar-lines').innerHTML = html;
      renderBarCode();
    }

    /* ════════════════════════ PHONE-PREVIEW ════════════════════════ */
    var SPAN = { '1x1': [1, 1], '2x1': [2, 1], '1x2': [1, 2], '2x2': [2, 2] };
    function slotForN(n) { return n <= 2 ? '1x1' : (n === 3 ? '2x1' : '2x2'); }
    function rowsFor(n) { return ({ 4: [2, 2], 5: [3, 2], 6: [3, 3] })[n] || [Math.ceil(n / 2), Math.floor(n / 2)]; }
    function spanStyle(size) { var s = SPAN[size]; return 'grid-column:span ' + s[0] + ';grid-row:span ' + s[1] + ';'; }
    var CHEV_PATH = 'M16.8284 8.29288C16.4379 7.90237 15.8047 7.90237 15.4142 8.29288L13.2929 10.4142C12.9024 10.8047 12.9024 11.4379 13.2929 11.8284L21.3353 19.8708L13.3069 27.8992C12.9164 28.2897 12.9164 28.9229 13.3069 29.3134L15.4283 31.4347C15.8188 31.8253 16.452 31.8253 16.8425 31.4347L27.6971 20.5801C27.869 20.4082 27.965 20.1893 27.9856 19.9647C27.9889 19.93 27.9905 19.8951 27.9902 19.8602C27.988 19.6072 27.8904 19.3548 27.6973 19.1617L16.8284 8.29288Z';

    function capLists() {
      var sw = [];
      E.schalterAll(CAT, state).forEach(function (d) {
        if (on(d.id)) sw.push({ icon: d.w_icon || d.icon, label: d.w_label || d.label, on: true });
      });
      var lsw = [];
      E.lichtSchalterAll(CAT, state).forEach(function (d) {
        if (on(d.id)) lsw.push({ icon: d.w_icon || d.icon, label: d.w_label || d.label, on: true });
      });
      var lv = E.tankAll(CAT, state).filter(function (d) { return on(d.id); }).map(function (d) {
        return { lottie: d.lottie || null, icon: d.w_icon || d.icon, label: d.w_label || d.label, pct: d.demo_wert != null ? d.demo_wert : 70, kind: levelKey(d) };
      });
      var tp = E.tempAll(CAT, state).filter(function (d) { return on(d.id); }).map(function (d) {
        return { icon: d.w_icon || d.icon, label: d.w_label || d.label, value: d.demo_wert != null ? d.demo_wert : 20 };
      });
      var tw = E.bewegungAll(CAT, state).filter(function (d) { return on(d.id); }).map(function (d) {
        var x = extra(d);
        return { icon: x.twIcon || d.icon, label: d.w_label || d.label, twL: x.twL || 'Auf', twR: x.twR || 'Zu' };
      });
      return { sw: sw, lsw: lsw, lv: lv, tp: tp, tw: tw };
    }
    function tankLotKey(file) {
      var f = String(file || '');
      if (f.indexOf('tank-grey') >= 0) return 'grau';
      if (f.indexOf('tank-black') >= 0) return 'braun';
      if (f.indexOf('gas') >= 0) return 'gas';
      if (f.indexOf('fuel') >= 0) return 'fuel';
      return 'frisch';
    }
    /* Tank-Item → LEVEL_LOTTIE-Key (Master-DS). Primär per Item-id, sonst per lottie-Feld.
       frisch→frisch · grau→grau · schwarz→braun · gas→gas · diesel→fuel · Custom→frisch. */
    var LEVEL_KEY_BY_ID = { frisch: 'frisch', grau: 'grau', schwarz: 'braun', gas: 'gas', diesel: 'fuel', bilge: 'bilge' };
    function levelKey(tk) {
      if (tk && LEVEL_KEY_BY_ID[tk.id]) return LEVEL_KEY_BY_ID[tk.id];
      return tankLotKey(tk && tk.lottie);
    }
    /* DS-Fill-Lotties (.lvl-lottie) rendern; CSS-/Icon-Fallback wenn RVLottie/LEVEL_LOTTIE fehlt.
       track=true → Instanzen in anims (Phone-Widget, wird bei Re-Render zerstört). */
    function mountLevelLotties(container, track) {
      if (!container) return;
      var ok = window.RVLottie && window.LEVEL_LOTTIE && window.lottie;
      Array.prototype.forEach.call(container.querySelectorAll('.lvl-lottie'), function (elx) {
        if (elx.getAttribute('data-lot-done')) return;
        if (ok) {
          try {
            var a = window.RVLottie.render(elx);
            if (a) { elx.setAttribute('data-lot-done', '1'); if (track) anims.push(a); return; }
          } catch (e) {}
        }
        elx.setAttribute('data-lot-done', '1');
        var ic = elx.getAttribute('data-fallback-icon') || 'X_Utility_Gauge';
        elx.innerHTML = '<img src="' + esc(appIcon(ic)) + '" alt="" style="width:100%;height:100%;object-fit:contain;opacity:.65;">';
      });
    }
    function levelLottieHtml(key, pct, styleStr, staticFill, fallbackIcon) {
      return '<span class="lvl-lottie" data-lottie="' + esc(key) + '" data-frame="' + Math.round(pct) + '"' +
        (staticFill ? ' data-animate="off"' : '') +
        ' data-fallback-icon="' + esc((fallbackIcon || 'X_Utility_Gauge').replace(/\.svg$/, '')) + '" style="' + (styleStr || '') + '"></span>';
    }

    function wSwitch(caps) {
      var n = caps.length, size = slotForN(n);
      function ch(s) {
        return '<div class="ch"><span class="ch-icon">' + iconTag(s.icon, '', 'X_TwoWay_Vent') + '</span><span class="ch-label">' + esc(s.label) + '</span><span class="toggle" data-state="' + (s.on ? 'on' : 'off') + '"><span class="knob"></span></span></div>';
      }
      var inner;
      if (size === '2x2') { var r = rowsFor(n); inner = '<div class="w-row r1">' + caps.slice(0, r[0]).map(ch).join('') + '</div><div class="w-row r2">' + caps.slice(r[0], r[0] + r[1]).map(ch).join('') + '</div>'; }
      else inner = caps.map(ch).join('');
      var did = regDlg(function () { return buildSwitchDialog(caps, t('dlg_devices')); });
      return '<div class="w-switch" data-dlg="' + did + '" data-size="' + size + '" data-count="' + n + '" style="' + spanStyle(size) + '">' + inner + '</div>';
    }

    function levelVisual(c, id) {
      /* Master-DS-Fill-Lottie (window.LEVEL_LOTTIE), Key = c.kind */
      return '<span class="ch-lottie"><div id="' + id + '" class="lvl-lottie" data-lottie="' + esc(c.kind || 'frisch') + '" data-frame="' + Math.round(c.pct) + '" data-fallback-icon="' + esc(c.icon || 'X_Utility_Gauge') + '"></div></span>';
    }
    function wLevel(caps) {
      var n = caps.length, size = slotForN(n);
      function ch(c) {
        var id = 'rvklt' + (lid++);
        live.push({ kind: 'level', numId: 'num' + id, base: c.pct, cur: c.pct, lvlId: id });
        return '<div class="ch">' + levelVisual(c, id) +
          '<span class="ch-pct"><span class="num" id="num' + id + '">' + c.pct + '</span><span class="unit">%</span></span>' +
          '<span class="ch-label">' + esc(c.label) + '</span></div>';
      }
      var inner;
      if (size === '2x2') { var r = rowsFor(n); inner = '<div class="w-row r1">' + caps.slice(0, r[0]).map(ch).join('') + '</div><div class="w-row r2">' + caps.slice(r[0], r[0] + r[1]).map(ch).join('') + '</div>'; }
      else inner = caps.map(ch).join('');
      var did = regDlg(function () { return buildLevelDialog(caps); });
      return '<div class="w-level" data-dlg="' + did + '" data-size="' + size + '" data-count="' + n + '" style="' + spanStyle(size) + '">' + inner + '</div>';
    }

    function fmtTemp(v) { var x = Math.round(v); return x < 0 ? '−' + Math.abs(x) : '' + x; }
    function wTemp(caps) {
      var n = caps.length, size = slotForN(n);
      function ch(c) {
        var id = 'rvktp' + (lid++);
        live.push({ kind: 'temp', numId: 'num' + id, base: c.value, cur: c.value });
        return '<div class="ch"><span class="ch-icon"><img src="' + esc(appIcon(c.icon)) + '" alt=""></span>' +
          '<span class="ch-val"><span class="num" id="num' + id + '">' + fmtTemp(c.value) + '</span><span class="unit">°C</span></span>' +
          '<span class="ch-label">' + esc(c.label) + '</span></div>';
      }
      var inner;
      if (size === '2x2') { var r = rowsFor(n); inner = '<div class="w-row r1">' + caps.slice(0, r[0]).map(ch).join('') + '</div><div class="w-row r2">' + caps.slice(r[0], r[0] + r[1]).map(ch).join('') + '</div>'; }
      else inner = caps.map(ch).join('');
      var did = regDlg(function () { return buildTempDialog(caps); });
      return '<div class="w-temp" data-dlg="' + did + '" data-size="' + size + '" data-count="' + n + '" style="' + spanStyle(size) + '">' + inner + '</div>';
    }

    function wBattery() {
      var size = '2x1', pct = 51;
      var id = 'rvklt' + (lid++);
      var lt = { id: id, file: lotUrl('battery.json'), pct: pct, kind: 'battery' };
      lotties.push(lt);
      var pctId = 'bp' + id, restId = 'br' + id, voltId = 'bv' + id, wId = 'bw' + id;
      live.push({ kind: 'battery', pctId: pctId, voltId: voltId, wId: wId, restId: restId, base: pct, cur: pct, lot: lt });
      var stats = [
        ['X_Energy_ElectricRange', '2:02 ' + t('unit_h'), t('w_resttime'), restId],
        ['X_Energy_Voltage', '12,5 V', t('w_voltage'), voltId],
        ['X_Energy_Flash', '123,3 W', t('w_total'), wId]
      ];
      var statHtml = stats.map(function (s) {
        return '<div class="stat"><span class="stat-icon"><img src="' + appIcon(s[0]) + '" alt=""></span><span class="stat-body"><span class="stat-val" id="' + s[3] + '">' + s[1] + '</span><span class="stat-lbl">' + esc(s[2]) + '</span></span></div>';
      }).join('');
      var did = regDlg(function () { return buildBatteryDialog(); });
      return '<div class="w-battery" data-dlg="' + did + '" data-size="' + size + '" style="' + spanStyle(size) + '">' +
        '<div class="row-head"><div class="dd" data-open="false"><button class="dd-trigger" type="button"><span class="dd-glyph rvk-lot-inline" style="display:inline-flex;width:26px;height:16px;overflow:hidden;" data-lot-file="' + esc(lotUrl('battery.json')) + '" data-lot-kind="battery" data-lot-pct="' + pct + '"></span><span class="dd-title">' + esc(t('w_battery')) + '</span><span class="dd-chev-wrap"><img class="dd-chev" src="' + uiIcon('chevron-right.svg') + '" alt=""></span></button></div></div>' +
        '<div class="battery-hero"><div class="lottie" id="' + id + '" data-lot-file="' + esc(lt.file) + '" data-lot-kind="battery" data-lot-pct="' + pct + '"></div><div class="pct"><span class="n" id="' + pctId + '">' + pct + '</span>&nbsp;<span class="u">%</span></div></div>' +
        '<div class="stats">' + statHtml + '</div></div>';
    }

    function wLight() {
      var colorN = qty('rgbw'), whiteN = qty('white');
      var zones = [];
      var i, j;
      for (i = 0; i < colorN; i++) zones.push({ key: 'c' + i, type: 'rgbw', label: colorN > 1 ? t('zone_color', { n: i + 1 }) : t('zone_color_single'), icon: 'X_Light_Ambient' });
      for (j = 0; j < whiteN; j++) zones.push({ key: 'w' + j, type: 'white', label: whiteN > 1 ? t('zone_white', { n: j + 1 }) : t('zone_white_single'), icon: 'X_Light_Empty' });
      if (!zones.length) return '';
      function br(val) {
        return '<div class="br-meta"><span class="br-label">' + esc(t('w_brightness')) + '</span><span class="br-val">' + val + ' %</span></div>' +
          '<div class="slider brightness" style="--pct:' + val + '%;"><div class="track-base"></div><div class="track-fill"></div><div class="thumb"></div><input type="range" min="0" max="100" value="' + val + '"></div>';
      }
      function wheel(z) {
        return '<div class="wheel-box"><div class="wheel"><div class="wheel-center"><img src="' + appIcon(z.icon) + '" alt=""></div><div class="wheel-thumb" style="--tx:0px;--ty:-89px;"></div></div></div>' + br(78);
      }
      function glyph(type, icon) { return type === 'rgbw' ? '<span class="dd-wheel-ic"></span>' : '<img src="' + appIcon(icon) + '" style="width:20px;height:20px;" alt="">'; }
      function opt(key, type, icon, label, sel, led) {
        return '<button type="button" class="dd-option" data-zonekey="' + key + '" data-led="' + led + '" data-selected="' + (sel ? 'true' : 'false') + '">' + glyph(type, icon) + '<span>' + esc(label) + '</span></button>';
      }
      /* Standard: sobald es Farbzonen gibt, direkt das Farb-Widget (Wheel) aktiv zeigen */
      var firstColor = null;
      for (var ci = 0; ci < zones.length; ci++) { if (zones[ci].type === 'rgbw') { firstColor = zones[ci]; break; } }
      var defKey = firstColor ? firstColor.key : 'all';
      var defLabel = firstColor ? firstColor.label : t('w_all_lights');
      var menu = opt('all', 'white', 'X_Light_Ambient', t('w_all_lights'), defKey === 'all', '#6EF5FC');
      var bodies = '<div class="zone-body" data-zonekey="all" style="display:' + (defKey === 'all' ? 'flex' : 'none') + ';flex-direction:column;justify-content:center;flex:1;">' + br(72) +
        '<div style="font-size:11px;color:var(--color-muted);text-align:center;margin-top:8px;">' + esc(t('w_zones_shared', { count: zones.length })) + '</div></div>';
      zones.forEach(function (z) {
        var led = z.type === 'white' ? '#ffe3b0' : '#6EF5FC';
        menu += opt(z.key, z.type, z.icon, z.label, z.key === defKey, led);
        bodies += '<div class="zone-body" data-zonekey="' + z.key + '" style="display:' + (z.key === defKey ? 'flex' : 'none') + ';flex-direction:column;justify-content:center;flex:1;">' + (z.type === 'rgbw' ? wheel(z) : br(78)) + '</div>';
      });
      var glyphImg = '<img class="dd-glyph" src="' + appIcon(firstColor ? firstColor.icon : 'X_Light_Ambient') + '" alt=""' + (firstColor ? ' style="display:none;"' : '') + '>';
      var glyphWheel = firstColor ? '<span class="dd-wheel-ic dd-glyph-wheel" style="margin-right:10px;"></span>' : '';
      var head = '<div class="row-head"><div class="dd" data-open="false"><button class="dd-trigger" type="button">' + glyphImg + glyphWheel + '<span class="dd-title">' + esc(defLabel) + '</span><span class="dd-chev-wrap"><img class="dd-chev" src="' + uiIcon('chevron-right.svg') + '" alt=""></span></button><div class="dd-menu" style="max-height:210px;overflow-y:auto;">' + menu + '</div></div><span class="toggle" data-state="on"><span class="knob"></span></span></div>';
      var did = regDlg(function () { return buildLightDialog(zones.map(function (z) { return { icon: z.icon, label: z.label, type: z.type, on: true }; })); });
      return '<div class="w-ambient w-light" data-dlg="' + did + '" data-size="2x2" data-mode="rgbw" data-on="true" style="--led-color:#6EF5FC;' + spanStyle('2x2') + '">' + head + '<div class="row-body">' + bodies + '</div></div>';
    }

    /* ═══════ App-DS-Islands: 1:1-Nachbau des im Prototyp gerenderten
       Markups (Snapshot der React-Inseln), gestylt via konfigurator-appds.css ═══════ */
    var APPDS = SET.appdsAssets || {};
    function appdsIcon(path) {
      if (APPDS[path]) return APPDS[path];
      return appIcon(path);
    }
    function island(slot, inner, dlgId) {
      return '<div class="rvk-ds"' + (dlgId ? ' data-dlg="' + dlgId + '"' : '') + ' style="' + spanStyle(slot) + 'min-width:0;border-radius:48px;overflow:hidden;">' +
        '<div style="width:100%;height:100%"><div class="rv-tile s' + slot + '" style="width:100%;height:100%">' + inner + '</div></div></div>';
    }
    function chevSvg(deg) {
      return '<svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true" style="transform:rotate(' + deg + 'deg);"><path d="' + CHEV_PATH + '"></path></svg>';
    }
    function rvSwitch(onState) {
      return '<span class="rv-switch' + (onState ? ' on' : '') + '" role="switch" aria-checked="' + (onState ? 'true' : 'false') + '" aria-disabled="false"></span>';
    }
    function rvDropdown(label, iconPath) {
      var lead = iconPath
        ? '<span class="dd-lead has-icon"><span class="rv-icon rv-icon--tint" style="width:34px;height:34px;"><img src="' + esc(appdsIcon(iconPath)) + '" alt=""></span></span>'
        : '<span class="dd-lead"></span>';
      return '<div class="rv-dropdown-wrap "><div class="rv-dropdown disabled" role="button" aria-haspopup="listbox" aria-expanded="false">' +
        lead + '<span class="dd-label">' + esc(label) + '</span>' +
        '<span class="dd-chev"><svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true"><path d="' + CHEV_PATH + '"></path></svg></span></div></div>';
    }
    /* ClimateControl-Dial (Truma CP+ / Alde / Eberspächer / FreshJet / Aventa) */
    function dsClimate(o) {
      var head;
      if (o.dd) {
        head = '<div style="position:relative;display:flex;align-items:center;justify-content:center;min-height:44px;">' +
          '<div style="width:60%;max-width:240px;">' + rvDropdown(o.title) + '</div>' +
          '<div style="position:absolute;right:0px;">' + rvSwitch(true) + '</div></div>';
      } else {
        head = '<div style="display:flex;align-items:center;gap:10px;">' +
          '<span style="flex:1 1 0%;min-width:0px;font-size:16px;font-weight:500;color:var(--text-heading);text-align:center;">' + esc(o.title) + '</span>' +
          rvSwitch(true) + '</div>';
      }
      var stage = climStage(climDialInner(o.p, o.temp, o.ist), o.fan, o.initView, { flex: true, big: false });
      var caption = '<div class="cc-caption" style="font-size:13px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:var(--brand);text-align:center;padding:2px 0px;">' + esc(o.caption) + '</div>';
      // Segment-Leiste: segViews (mit Dial↔Fan-Umschaltung) bevorzugt, sonst
      // Legacy-o.tabs. Reine Heizung (Combi/Alde allein) → gar keine Leiste.
      var seg = '';
      if (o.segViews && o.segViews.length) seg = '<div>' + climSegHtml(o.segViews, o.active || 0) + '</div>';
      else if (o.tabs && o.tabs.length) seg = '<div>' + climSegHtml(o.tabs.map(function (tb) { return { label: tb }; }), o.active) + '</div>';
      var did = regDlg(function () { return buildClimateDialog(o); });
      var inner = '<div class="rv-clim-unit" style="display:flex;flex-direction:column;flex:1 1 0%;min-height:0px;gap:' + (o.dd ? 10 : 8) + 'px;">' + stage + caption + seg + '</div>';
      return island('2x2', '<div class="wx-pad" style="gap:' + (o.dd ? 10 : 8) + 'px;">' + head + inner + '</div>', did);
    }
    /* Dometic-Kühlschrank: CoolingLevel-Stufen bzw. Temp-Automatik (tfridge) */
    function dsFridge(auto) {
      var head = '<div style="display:flex;align-items:center;gap:10px;min-height:40px;">' +
        '<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;"><img src="' + esc(appdsIcon('devices/X_Device_MiniBar_0.svg')) + '" alt=""></span>' +
        '<div style="flex:1 1 0%;min-width:0px;text-align:center;font-size:16px;font-weight:500;color:var(--text-heading);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + esc(t('w_fridge_name')) + '</div>' +
        rvSwitch(true) + '</div>';
      var bodyHtml;
      if (auto) {
        bodyHtml = '<div style="flex:1 1 0%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;min-height:0px;">' +
          '<div style="display:flex;flex-direction:row;align-items:center;justify-content:center;gap:16px;touch-action:pan-y;user-select:none;">' +
          '<svg viewBox="11.5 5.85 18 28" style="height:40px;width:auto;flex-shrink:0;color:var(--brand);transform:rotate(180deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg>' +
          '<span style="font-size:48px;font-weight:700;line-height:1;color:var(--text-heading);min-width:81.6px;text-align:center;">5°</span>' +
          '<svg viewBox="11.5 5.85 18 28" style="height:40px;width:auto;flex-shrink:0;color:var(--apored);transform:rotate(0deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg>' +
          '</div>' +
          '<div style="font-size:12px;font-weight:700;letter-spacing:0.05em;color:var(--text-heading);">' + esc(t('w_ist_upper', { temp: 15 })) + '</div></div>';
      } else {
        var bars = '';
        for (var i = 1; i <= 5; i++) bars += '<span class="cl-bar b' + i + (i === 1 ? ' on' : '') + '"><span class="cl-fill"></span></span>';
        bodyHtml = '<div style="flex:1 1 0%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;min-height:0px;">' +
          '<div class="rv-coolinglevel" style="touch-action:pan-y;cursor:pointer;">' + bars + '</div></div>';
      }
      var did = regDlg(function () { return buildFridgeDialog(auto, t('w_fridge_name')); });
      return island('2x1', '<div class="wx-pad" style="gap:4px;">' + head + bodyHtml + '</div>', did);
    }
    /* Thitronik: Status-Kachel + Panik-Kachel */
    function dsThitronikStatus() {
      var did = regDlg(function () { return buildThitronikDialog(); });
      return island('1x1', '<div class="rv-tile-center" style="gap:0px;padding:14px;">' +
        '<div style="display:flex;align-items:center;justify-content:space-around;width:100%;gap:8px;">' +
        '<span class="rv-icon rv-icon--tint" style="width:64px;height:64px;"><img src="' + esc(appdsIcon('utility/X_Utility_Siren_1.svg')) + '" alt=""></span>' +
        rvSwitch(true) + '</div>' +
        '<span class="rv-tile-name" style="margin-top:12px;">' + esc(t('w_alarm_ready')) + '</span></div>', did);
    }
    function dsThitronikPanic() {
      var did = regDlg(function () { return buildThitronikDialog(); });
      return island('1x1', '<div style="height:100%;width:100%;padding:14px;box-sizing:border-box;cursor:pointer;">' +
        '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;width:100%;gap:0px;background:rgb(250,72,86);border-radius:34px;box-shadow:rgba(250,72,86,0.35) 0px 6px 22px;">' +
        '<span style="color:rgb(255,255,255);font-family:var(--font);font-weight:700;font-size:18px;letter-spacing:0.08em;">' + esc(t('w_panic')) + '</span>' +
        '<span style="margin-top:6px;color:rgba(255,255,255,0.85);font-family:var(--font);font-weight:500;font-size:11px;">' + esc(t('w_panic_sub')) + '</span>' +
        '</div></div>', did);
    }
    /* EcoFlow PowerKit: SoC-Lottie + Batteriedaten + Verbraucher 12V/230V */
    function dsEcoflow(title) {
      var pct = 76;
      var id = 'rvklt' + (lid++);
      lotties.push({ id: id, file: lotUrl('battery.json'), pct: pct, kind: 'battery' });
      function consumer(onState, label) {
        return '<div style="display:flex;flex-direction:column;gap:4px;">' +
          '<div style="display:flex;align-items:center;gap:12px;">' +
          '<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;"><img src="' + esc(appdsIcon('battery/X_Energy_Flash_0.svg')) + '" alt=""></span>' +
          rvSwitch(onState) + '</div>' +
          '<span style="font-size:22px;font-weight:700;color:var(--mid-grey);line-height:1;">' + esc(label) + '</span></div>';
      }
      function stat(v, l) {
        return '<div style="text-align:center;"><div style="font-size:18px;font-weight:700;color:var(--text-heading);white-space:nowrap;">' + esc(v) + '</div>' +
          '<div style="font-size:13px;color:var(--text-paragraph);">' + esc(l) + '</div></div>';
      }
      var did = regDlg(function () { return buildEcoflowDialog(efEcoChannels(), title || 'Ecoflow'); });
      return island('2x2', '<div class="wx-pad" style="gap:8px;align-items:center;">' +
        '<div style="width:100%;">' + rvDropdown(title || 'Ecoflow') + '</div>' +
        '<div style="position:relative;width:100%;display:flex;align-items:center;justify-content:center;">' +
        '<div style="width:100%;max-width:220px;height:92px;"><div id="' + id + '" style="width:100%;height:100%;"></div></div>' +
        '<span style="position:absolute;inset:0px;display:flex;align-items:center;justify-content:center;font-size:40px;font-weight:700;color:rgb(255,255,255);letter-spacing:-0.01em;">' + pct + '%</span></div>' +
        '<div style="font-size:15px;color:var(--text-paragraph);">' + esc(t('w_batdata')) + '</div>' +
        '<div style="display:flex;justify-content:space-evenly;width:100%;">' + stat('1 ' + t('unit_d') + ' 4 ' + t('unit_h'), t('w_resttime')) + stat('412 W', t('w_power')) + '</div>' +
        '<div style="font-size:15px;color:var(--text-paragraph);margin-top:2px;">' + esc(t('w_consumers')) + '</div>' +
        '<div style="display:flex;justify-content:space-evenly;width:100%;">' + consumer(true, '12V') + consumer(false, '230V') + '</div>' +
        '</div>', did);
    }
    /* ═══════ NEUE INTEGRATIONEN (DS-Registries 3/4/6/7, Stand 27.08.2026):
       Autoterm · Webasto · Timberline · CAN-BMS-Batterie · Nivellierung (Brain-IMU).
       1:1-Vanilla-Port der Registry-Specs; Demo-Werte = initialModel() der Specs. ═══════ */

    /* Status-Zeile der Heizungs-Widgets (DS StatusLine/TlState) — Klasse cc-caption,
       damit die Segment-Umschaltung (data-cap) den Text austauscht. */
    function hzStatus(txt, color, pulse) {
      return '<div class="cc-caption" style="font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:' + (color || 'var(--brand)') + ';text-align:center;padding:2px 0;' + (pulse ? 'animation:rv-fade-pulse 1.5s ease-in-out infinite;' : '') + '">' + esc(txt) + '</div>';
    }
    /* Kachel-Kopf der Heizungen: Dropdown (Gerätename) + Schalter (DS Tile-Header) */
    function hzTileHead(title, ddHtml) {
      return '<div style="display:flex;align-items:center;gap:10px;">' +
        '<div style="flex:1 1 0%;min-width:0;">' + (ddHtml || rvDropdown(title)) + '</div>' +
        rvSwitch(true) + '</div>';
    }
    /* Dialog-Titelzeile (DS: Name links, fett 18px + Schalter rechts) */
    function hzDlgTitle(title) {
      return '<div style="display:flex;align-items:center;gap:12px;padding:2px 4px 6px;">' +
        '<span style="flex:1 1 0%;min-width:0;font-size:18px;font-weight:600;color:var(--text-heading);text-align:left;">' + esc(title) + '</span>' +
        rvSwitch(true) + '</div>';
    }
    /* CoolingLevel (DS-Komponente, lg-Rampe 21→64 px, Höhen inline interpoliert) */
    function coolBarsHtml(level, max) {
      var bars = '';
      for (var i = 1; i <= max; i++) {
        var h = max === 1 ? 64 : Math.round(21 + 43 * ((i - 1) / (max - 1)));
        bars += '<span class="cl-bar b' + i + (i <= level ? ' on' : '') + '" style="height:' + h + 'px;"><span class="cl-fill"></span></span>';
      }
      return '<div class="rv-coolinglevel" style="touch-action:pan-y;cursor:pointer;">' + bars + '</div>';
    }
    /* Stufen-Slider (DS Slider min–max, ANZEIGEwerte) als statischer rv-slider */
    function stepSliderRow(val, min, max) {
      var pct = Math.round(((val - min) / (max - min)) * 100);
      return '<div style="width:100%;padding:0 12px;box-sizing:border-box;">' + sliderRow(pct, 'on') + '</div>';
    }
    /* Mehr-Ansichten-Stage der neuen Heizungen: cells = [{view, html}], initView
       sichtbar; Umschaltung via Segment-Tabs (data-view) in bindSheetControls. */
    function hzStage(cells, initView, flex) {
      var wrap = flex
        ? 'flex:1 1 0%;display:flex;align-items:center;justify-content:center;min-height:0px;'
        : 'display:flex;justify-content:center;';
      var s = '<div class="rv-clim-stage" style="' + wrap + '">';
      cells.forEach(function (c) {
        s += '<div class="cs-' + c.view + '" style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;' + (c.view === initView ? '' : 'display:none;') + '">' + c.html + '</div>';
      });
      return s + '</div>';
    }

    /* ── AUTOTERM (DS reg.autoterm) — Air 4D · Thermostat/Leistung/Lüften ── */
    var AT = { title: 'Autoterm Air 4D', target: 21, ist: 18, min: 0, max: 30, power: 4, powerMax: 6, fan: 6, fanMax: 10 };
    function atPowerCell(big) {
      return '<div style="display:flex;flex-direction:column;align-items:center;gap:12px;padding:12px 0 4px;width:100%;">' +
        coolBarsHtml(AT.power, AT.powerMax) +
        '<div style="font-size:15px;color:var(--text-paragraph);">' + esc(t('at_power_level')) + ' <span style="font-size:19px;font-weight:600;color:var(--text-heading);">' + AT.power + '</span> / ' + AT.powerMax + '</div></div>';
    }
    function atFanCell(size) {
      return '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;padding:12px 0 4px;width:100%;">' +
        climFanWheel(true, size) +
        '<div style="font-size:15px;color:var(--text-paragraph);">' + esc(t('at_fan_level')) + ' <span style="font-size:19px;font-weight:600;color:var(--text-heading);">' + AT.fan + '</span> / ' + AT.fanMax + '</div>' +
        stepSliderRow(AT.fan, 1, AT.fanMax) + '</div>';
    }
    function atDialCell(big) {
      var p = (AT.target - AT.min) / (AT.max - AT.min);
      return '<div style="display:flex;justify-content:center;padding:0;margin-bottom:-14px;width:100%;">' + climDialInner(p, AT.target, AT.ist, AT.min, AT.max) + '</div>';
    }
    function atSegHtml(active) {
      return climSegHtml([
        { label: t('at_thermostat'), view: 'dial', cap: t('w_heating_running') },
        { label: t('at_leistung'), view: 'cool', cap: t('w_heating_running') },
        { label: t('seg_vent'), view: 'fan', cap: t('w_vent_running') }
      ], active || 0);
    }
    function wAutoterm(ig) {
      var did = regDlg(function () { return buildAutotermDialog(ig); });
      var inner = '<div class="rv-clim-unit" style="display:flex;flex-direction:column;flex:1 1 0%;min-height:0px;gap:8px;">' +
        hzStage([{ view: 'dial', html: atDialCell() }, { view: 'cool', html: atPowerCell() }, { view: 'fan', html: atFanCell(118) }], 'dial', true) +
        hzStatus(t('w_heating_running')) +
        '<div>' + atSegHtml(0) + '</div></div>';
      return island('2x2', '<div class="wx-pad" style="gap:8px;">' + hzTileHead(AT.title) + inner + '</div>', did);
    }
    function buildAutotermDialog(ig) {
      var d = { intern: 24, extern: 12, heatx: 96, volt: '13.4', fw: '9.0.100.23' };
      function drow(label, value) {
        return '<div style="display:flex;align-items:center;gap:12px;padding:6px 10px;">' +
          '<span style="flex:1;font-size:14px;color:var(--text-paragraph);">' + esc(label) + '</span>' +
          '<span style="font-size:14px;font-weight:600;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + value + '</span></div>';
      }
      var chipOff = '<span class="rv-chip muted">' + esc(t('w_off')) + '</span>';
      var durTabs = ['30 min', '40 min', '60 min', t('at_dauerlauf')].map(function (lb, i) {
        var hint = i === 3 ? t('at_dauerlauf_hint') : t('at_runtime_hint', { min: [30, 40, 60][i] });
        return { label: lb, settext: hint };
      });
      var durSeg = '<div class="rv-seg" role="tablist">' + durTabs.map(function (v, i) {
        return '<div role="tab" aria-selected="' + (i === 1) + '" class="' + (i === 1 ? 'active' : '') + '" data-settext-target="at-durhint" data-settext="' + esc(v.settext) + '">' + esc(v.label) + '</div>';
      }).join('') + '</div>';
      var body = '<div class="rv-clim-unit">' +
        hzDlgTitle(AT.title) +
        hzStatus(t('w_heating_running')) +
        '<div style="padding-top:4px;">' + hzStage([{ view: 'dial', html: atDialCell(true) }, { view: 'cool', html: atPowerCell(true) }, { view: 'fan', html: atFanCell(132) }], 'dial', false) + '</div>' +
        '<div style="padding:0 4px;margin-top:18px;">' + atSegHtml(0) + '</div>' +
        '<div data-showview="fan" style="display:none;">' +
          dDiv2() + dLabel(t('at_runtime')) +
          '<div style="padding:0 4px;">' + durSeg + '</div>' +
          '<p id="at-durhint" style="font-size:13px;color:var(--text-paragraph);text-align:center;margin:8px 0 0;">' + esc(t('at_runtime_hint', { min: 40 })) + '</p>' +
        '</div>' +
        '</div>' +
        dDiv2() + dTimerBlock() + dDiv2() +
        '<div data-collapse="at-diag" style="display:flex;align-items:center;gap:12px;padding:8px 10px;cursor:pointer;user-select:none;">' +
          '<span style="flex:1;font-size:16px;font-weight:500;color:var(--text-heading);">' + esc(t('hz_diag')) + '</span>' +
          '<span class="rvk-collapse-chev" style="display:flex;transition:transform .25s;">' + chevSvg(0) + '</span></div>' +
        '<div id="at-diag" style="display:none;">' +
          drow(t('at_d_phase'), '3.0 · ' + esc(t('seg_heat'))) +
          drow(t('at_d_mode'), esc(t('at_thermostat'))) +
          drow(t('at_d_intern'), d.intern + ' °C') +
          drow(t('at_d_extern'), d.extern + ' °C') +
          drow(t('at_d_heatx'), d.heatx + ' °C') +
          drow(t('hz_volt'), d.volt + ' V') +
          drow(t('at_d_lvlecho'), '—') +
          drow(t('at_d_tgtecho'), AT.target + ' °C') +
          drow(t('at_d_rpm'), esc(t('at_d_notreported'))) +
          drow(t('at_d_pump'), esc(t('at_d_notreported'))) +
          drow(t('at_d_panel'), chipOff) +
          drow(t('at_d_lastrun'), esc(t('at_d_noerror'))) +
          drow(t('at_d_fw'), esc(d.fw)) +
        '</div>';
      return {
        title: AT.title,
        logo: '<img src="' + esc(appIcon('X_Logo_Autoterm.svg')) + '" alt="Autoterm" style="height:40px;width:auto;">',
        body: body
      };
    }

    /* ── WEBASTO (DS reg.webasto) — Air Top Evo · Heizen/Lüften · Boost/Eco ── */
    var WB = { title: 'Webasto Air Top Evo', target: 22, ist: 18, min: 5, max: 35, vent: 2, ventMax: 4, volt: '12.3' };
    function wbDialCell() {
      var p = (WB.target - WB.min) / (WB.max - WB.min);
      return '<div style="display:flex;justify-content:center;padding:0;margin-bottom:-14px;width:100%;">' + climDialInner(p, WB.target, WB.ist, WB.min, WB.max) + '</div>';
    }
    function wbFanCell(size, dialog) {
      return '<div style="display:flex;flex-direction:column;align-items:center;gap:6px;padding:' + (dialog ? '10px 0 0' : '6px 0 0') + ';width:100%;">' +
        climFanWheel(true, size) +
        '<div style="font-size:14px;color:var(--text-paragraph);">' + esc(t('wb_fanstage')) + (dialog ? ':' : '') + '</div>' +
        '<div style="font-size:26px;font-weight:700;color:var(--text-heading);line-height:1;">' + WB.vent + '</div>' +
        stepSliderRow(WB.vent, 1, WB.ventMax) + '</div>';
    }
    function wbSegHtml(active) {
      return climSegHtml([
        { label: t('seg_heat'), view: 'dial', cap: t('w_heating_running') },
        { label: t('seg_vent'), view: 'fan', cap: t('w_vent_running') }
      ], active || 0);
    }
    function wWebasto(ig) {
      var did = regDlg(function () { return buildWebastoDialog(ig); });
      /* Webasto-Statusfarben sind INDIVIDUELL (dstate in webasto_tile_widget):
         läuft → var(--link), verfügbar → var(--connection) — NICHT das --brand
         der anderen Heizungen. */
      var inner = '<div class="rv-clim-unit" style="display:flex;flex-direction:column;flex:1 1 0%;min-height:0px;gap:8px;">' +
        hzStage([{ view: 'dial', html: wbDialCell() }, { view: 'fan', html: wbFanCell(110) }], 'dial', true) +
        hzStatus(t('w_heating_running'), 'var(--link)') +
        '<div>' + wbSegHtml(0) + '</div></div>';
      return island('2x2', '<div class="wx-pad" style="gap:8px;">' + hzTileHead(WB.title) + inner + '</div>', did);
    }
    function buildWebastoDialog(ig) {
      var body = '<div class="rv-clim-unit">' +
        hzDlgTitle(WB.title) +
        dLabel(t('dlg_mode')) +
        '<div style="padding:0 4px;">' + wbSegHtml(0) + '</div>' +
        '<div style="padding-top:10px;">' + hzStage([{ view: 'dial', html: wbDialCell() }, { view: 'fan', html: wbFanCell(150, true) }], 'dial', false) + '</div>' +
        hzStatus(t('w_heating_running'), 'var(--link)') +
        '<div data-showview="dial">' +
          dDiv2() + dLabel(t('dlg_energy')) +
          '<div style="padding:0 4px;">' + rvSegHtml([t('wb_energy_normal'), t('wb_energy_eco'), t('wb_energy_boost')], 0) + '</div>' +
        '</div>' +
        '</div>' +
        dDiv2() +
        dcard(dIconSpan('battery/X_Energy_Voltage_0.svg'), t('hz_volt'), {
          control: '<span style="font-size:15px;font-weight:600;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + WB.volt + ' V</span>', flat: true
        }) +
        dDiv2() + dTimerBlock();
      return {
        title: WB.title,
        logo: '<img src="' + esc(appIcon('X_Logo_Webasto.svg')) + '" alt="Webasto" style="height:52px;width:auto;max-width:210px;">',
        body: body
      };
    }

    /* ── TIMBERLINE (DS reg.timberline) — 2.0 · Zonen · Boiler · Brenner/Elektro ── */
    var TL = {
      title: 'Timberline 2.0', min: 5, max: 30, fanPct: 60,
      zones: [{ name: 'Zone 1', target: 22, ist: 20 }, { name: 'Zone 2', target: 20, ist: 19 }]
    };
    function tlDialCell(z) {
      var p = (z.target - TL.min) / (TL.max - TL.min);
      return '<div style="display:flex;justify-content:center;padding:0;margin-bottom:-14px;width:100%;">' + climDialInner(p, z.target, z.ist, TL.min, TL.max) + '</div>';
    }
    function tlFanCell(size) {
      var z = TL.zones[0];
      var pct = Math.round(((TL.fanPct - 10) / 90) * 100);
      return '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;padding:14px 0 4px;width:100%;">' +
        climFanWheel(true, size) +
        '<div style="width:100%;padding:0 12px;box-sizing:border-box;">' + sliderRow(pct, 'on') + '</div>' +
        '<div class="tl-fanlabel" style="font-size:14px;color:var(--text-paragraph);">' + esc(t('tl_fan_ist', { pct: TL.fanPct, temp: z.ist })) + '</div></div>';
    }
    function tlSegHtml(active) {
      return climSegHtml([
        { label: t('seg_heat'), view: 'dial', cap: t('w_heating_running') },
        { label: t('seg_vent'), view: 'fan', cap: t('w_vent_running') }
      ], active || 0);
    }
    /* Zonen-Umschaltung (Kachel-Dropdown + Dialog-Segment): Dial-Werte der
       gewählten Zone einsetzen — Scope ist die jeweilige rv-clim-unit. */
    function tlApplyZone(unitEl, idx) {
      var z = TL.zones[idx] || TL.zones[0];
      var dial = unitEl.querySelector('.rv-climate');
      if (dial) {
        var tEl = dial.querySelector('.cc-temp');
        if (tEl) tEl.innerHTML = z.target + '<span class="unit">°</span>';
        var iEl = dial.querySelector('.cc-ist');
        if (iEl) iEl.textContent = t('w_ist', { temp: z.ist });
        dial.style.setProperty('--p', Math.max(0, Math.min(1, (z.target - TL.min) / (TL.max - TL.min))));
      }
      var fl = unitEl.querySelector('.tl-fanlabel');
      if (fl) fl.textContent = t('tl_fan_ist', { pct: TL.fanPct, temp: z.ist });
    }
    function tlZoneDd() {
      var items = TL.zones.map(function (z, i) {
        return '<div class="dd-item' + (i === 0 ? ' sel' : '') + '" data-tl-zone="' + i + '" role="option">' +
          '<span class="dd-mi-lead"></span><span class="dd-mi-label">' + esc(z.name) + '</span><span class="dd-mi-tail"></span></div>';
      }).join('');
      return '<div class="rv-dropdown-wrap rvk-ddlive">' +
        '<div class="rv-dropdown" role="button" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="dd-lead"></span><span class="dd-label">' + esc(TL.zones[0].name) + '</span>' +
        '<span class="dd-chev"><svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true"><path d="' + CHEV_PATH + '"></path></svg></span></div>' +
        '<div class="rv-dropdown-menu" role="listbox" style="display:none;">' + items + '</div></div>';
    }
    function wTimberline(ig) {
      var did = regDlg(function () { return buildTimberlineDialog(ig); });
      /* Kachel-Lüfterrad exakt 132 px (Dialog 150) — timberline Picker fanSize={132} */
      var inner = '<div class="rv-clim-unit" style="display:flex;flex-direction:column;flex:1 1 0%;min-height:0px;gap:8px;">' +
        hzStage([{ view: 'dial', html: tlDialCell(TL.zones[0]) }, { view: 'fan', html: tlFanCell(132) }], 'dial', true) +
        hzStatus(t('w_heating_running')) +
        '<div>' + tlSegHtml(0) + '</div></div>';
      return island('2x2', '<div class="wx-pad" style="gap:8px;">' + hzTileHead(TL.title, tlZoneDd()) + inner + '</div>', did);
    }
    function buildTimberlineDialog(ig) {
      function drow(label, value) {
        return '<div style="display:flex;align-items:center;gap:12px;padding:6px 10px;">' +
          '<span style="flex:1;font-size:14px;color:var(--text-paragraph);">' + esc(label) + '</span>' +
          '<span style="font-size:14px;font-weight:600;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + value + '</span></div>';
      }
      function chipState(on2) { return '<span class="rv-chip' + (on2 ? '' : ' muted') + '">' + esc(on2 ? t('w_on') : t('w_off')) + '</span>'; }
      var zoneTabs = '<div class="rv-seg" role="tablist">' + TL.zones.map(function (z, i) {
        return '<div role="tab" aria-selected="' + (i === 0) + '" class="' + (i === 0 ? 'active' : '') + '" data-tl-zoneseg="' + i + '">' + esc(z.name) + '</div>';
      }).join('') + '</div>';
      var frostIcon = '<span class="rv-icon" aria-hidden="true" style="width:48px;height:48px;display:block;background:var(--text-heading);-webkit-mask-image:url(' + esc(appIcon('X_Icon_Cold.svg')) + ');mask-image:url(' + esc(appIcon('X_Icon_Cold.svg')) + ');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span>';
      var d = { aussen: 19, tank: 35, fluss: 33, brenner: 36, spannung: '13.4' };
      var body = '<div class="rv-clim-unit">' +
        hzDlgTitle(TL.title) +
        hzStatus(t('w_heating_running')) +
        '<div style="padding-top:4px;">' + hzStage([{ view: 'dial', html: tlDialCell(TL.zones[0]) }, { view: 'fan', html: tlFanCell(150) }], 'dial', false) + '</div>' +
        '<div style="padding:0 4px;margin-top:18px;">' + tlSegHtml(0) + '</div>' +
        dDiv2() + dLabel(t('tl_tempzone')) +
        '<div>' + zoneTabs + '</div>' +
        '</div>' +
        dDiv2() + dLabel(t('tl_boiler_sec')) +
        dcard(dIconSpan('temp/X_Temp_Water_0.svg'), t('dlg_warmwater'), { control: rvSwitch(true), flat: true }) +
        '<div style="padding:8px 4px 0;">' + rvSegHtml([t('tl_brenner'), t('energy_elektro')], 0) + '</div>' +
        dDiv2() +
        dcard(dIconSpan('devices/X_Device_Heater_0.svg'), t('tl_boost'), { control: rvSwitch(false), flat: true }) +
        dDiv2() +
        dcard('<span class="rv-icon rv-icon--raw" style="width:48px;height:48px;">' + dImg('utility/X_Utility_Moon_0.svg') + '</span>', t('dlg_eco_mode'), { control: rvSwitch(false), flat: true }) +
        dDiv2() +
        dcard(frostIcon, t('tl_frost'), { control: rvSwitch(false), flat: true }) +
        dDiv2() + dTimerBlock() + dDiv2() +
        '<div data-collapse="tl-diag" style="display:flex;align-items:center;gap:12px;padding:8px 10px;cursor:pointer;user-select:none;">' +
          '<span style="flex:1;font-size:16px;font-weight:500;color:var(--text-heading);">' + esc(t('hz_diag')) + '</span>' +
          '<span class="rvk-collapse-chev" style="display:flex;transition:transform .25s;">' + chevSvg(0) + '</span></div>' +
        '<div id="tl-diag" style="display:none;">' +
          drow(t('at_d_extern'), d.aussen + ' °C') +
          drow(t('tl_d_tank'), d.tank + ' °C') +
          drow(t('tl_d_fluss'), d.fluss + ' °C') +
          drow(t('tl_d_brenner'), d.brenner + ' °C') +
          TL.zones.map(function (z, i) { return drow(t('tl_d_zone', { n: i + 1 }), z.ist + ' °C'); }).join('') +
          TL.zones.map(function (z, i) { return drow(t('tl_d_fan', { n: i + 1 }), chipState(z.ist < z.target)); }).join('') +
          drow(t('tl_brenner'), chipState(true)) +
          drow(t('energy_elektro'), chipState(false)) +
          drow(t('tl_d_hzpumpe'), chipState(true)) +
          TL.zones.map(function (z, i) { return drow(t('tl_d_pumpe', { n: i + 1 }), chipState(z.ist < z.target)); }).join('') +
          drow(t('stat_voltage'), d.spannung + ' V') +
        '</div>';
      return {
        title: TL.title,
        logo: '<img src="' + esc(appIcon('X_Logo_Timberline.svg')) + '" alt="Timberline" style="height:44px;width:auto;">',
        body: body
      };
    }

    /* ── CAN-BMS-BATTERIE (DS reg.canbms) — Batterie-Kachel + BMS-Card ──
       Marken-Branding je bms_batterie-Item (Logo + CI-Produktfoto); generisches
       Bundle ohne Branding (App-Batterie-Fallback), exakt wie can_battery_branding. */
    var CB = { soc: 76, volt: '13.28', cur: '12.4', watt: 165, tr: 254, temp: 21, soh: 98, cellMin: 3312, cellMax: 3341, ctMin: 19, ctMax: 23, packs: 2, ccl: 200, dcl: 250, cvl: '14.2', chg: '412.7', dchg: '398.2', banks: '2 / 2' };
    var CANBMS_BRANDS = {
      bms_superb: { name: 'Super-B', logo: 'X_Logo_SuperB.svg', device: 'superb.png' },
      bms_supervolt: { name: 'Supervolt', logo: 'X_Logo_SuperVolt.svg', device: 'supervolt.png' },
      bms_bulltron: { name: 'Bulltron', logo: 'X_Logo_Bulltron.svg', device: 'bulltron.png' }
    };
    function cbRestText() {
      return Math.floor(CB.tr / 60) + ' ' + t('unit_h') + ' ' + (CB.tr % 60) + ' ' + t('unit_min');
    }
    function dsCanBms(bmsItem) {
      var brand = CANBMS_BRANDS[bmsItem.id] || null;
      var ddName = brand ? 'CAN-BMS · ' + brand.name : 'CAN-BMS';
      var ddIcon = brand
        ? '<img src="' + esc(AB + '/devices/' + brand.device) + '" alt="" style="width:26px;height:18px;object-fit:contain;">'
        : '<span class="rvk-lot-inline" style="display:inline-flex;width:26px;height:15px;overflow:hidden;" data-lot-file="' + esc(lotUrl('battery.json')) + '" data-lot-kind="battery" data-lot-pct="' + CB.soc + '"></span>';
      var id = 'rvklt' + (lid++);
      lotties.push({ id: id, file: lotUrl('battery.json'), pct: CB.soc, kind: 'battery' });
      function cell(v, l) {
        return '<div style="text-align:center;min-width:0;"><div style="font-size:20px;font-weight:600;color:var(--text);white-space:nowrap;font-variant-numeric:tabular-nums;">' + esc(v) + '</div>' +
          '<div style="font-size:14px;color:var(--text-paragraph);white-space:nowrap;">' + esc(l) + '</div></div>';
      }
      var did = regDlg(function () { return buildCanBmsDialog(bmsItem); });
      var dd = '<div class="rv-dropdown-wrap "><div class="rv-dropdown disabled" role="button" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="dd-lead has-icon">' + ddIcon + '</span><span class="dd-label">' + esc(ddName) + '</span>' +
        '<span class="dd-chev"><svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true"><path d="' + CHEV_PATH + '"></path></svg></span></div></div>';
      var hero = '<div style="position:relative;width:100%;display:flex;align-items:center;justify-content:center;">' +
        '<div style="width:100%;max-width:290px;height:104px;"><div id="' + id + '" style="width:100%;height:100%;"></div></div>' +
        '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:38px;font-weight:700;color:#fff;letter-spacing:-.01em;">' + CB.soc + ' %</span></div>';
      var cells = '<div style="flex:3;display:grid;grid-template-columns:1fr 1fr;justify-items:center;align-items:center;align-content:center;row-gap:14px;column-gap:8px;min-width:0;align-self:stretch;padding:0 12px;">' +
        cell(CB.cur + ' A', t('stat_current')) + cell(cbRestText(), t('w_resttime')) +
        cell(CB.watt + ' W', t('w_total')) + cell(CB.volt + ' V', t('stat_voltage')) + '</div>';
      return island('2x2', '<div class="wx-pad" style="gap:6px;">' +
        '<div>' + dd + '</div>' +
        '<div style="flex:1;display:flex;flex-direction:column;gap:8px;align-items:center;min-height:0;">' +
        '<div style="flex:4;display:flex;align-items:center;justify-content:center;min-width:0;align-self:stretch;">' + hero + '</div>' +
        cells + '</div></div>', did);
    }
    function ecCanBmsBody(bmsItem) {
      var brand = CANBMS_BRANDS[bmsItem.id] || null;
      function vrow(label, value) {
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:0 0 8px;">' +
          '<span style="font-size:15px;color:var(--text-paragraph);">' + esc(label) + '</span>' +
          '<span style="font-size:16px;font-weight:600;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + esc(value) + '</span></div>';
      }
      function irow(label, value, color) {
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:7px 2px;font-size:14.5px;color:' + (color || 'var(--text-paragraph)') + ';">' +
          '<span>' + esc(label) + '</span><span style="color:' + (color || 'var(--text)') + ';font-variant-numeric:tabular-nums;font-weight:600;">' + esc(value) + '</span></div>';
      }
      var logoHtml = brand ? '<img src="' + esc(appIcon(brand.logo)) + '" alt="' + esc(brand.name) + '" style="height:44px;max-width:170px;object-fit:contain;margin-bottom:10px;">' : '';
      var hero = dLottieBattery(CB.soc, 340, 112, 40, CB.soc + ' %');
      var body = '<div class="rv-dcard" style="padding:6px 14px 14px;margin:0 4px 12px;display:flex;flex-direction:column;align-items:center;">' +
        '<div style="text-align:center;font-size:17px;font-weight:500;color:var(--text-heading);padding:12px 0 8px;">CAN-BMS</div>' +
        logoHtml +
        '<div style="align-self:stretch;padding:0 4px;">' + hero + '</div>' +
        '<p style="font-size:15px;color:var(--text-paragraph);margin:18px 0 8px;">' + esc(t('w_batdata')) + '</p>' +
        '<div style="align-self:stretch;padding:0 4px;">' +
          vrow(t('stat_current'), CB.cur + ' A') +
          vrow(t('w_power'), CB.watt + ' W') +
          vrow(t('stat_voltage'), CB.volt + ' V') +
          vrow(t('w_resttime'), CB.tr + ' min') +
        '</div>' +
        dDiv2() +
        '<div style="align-self:stretch;">' +
          irow(t('cb_temp'), CB.temp + ' °C') +
          irow(t('cb_soh'), CB.soh + ' %') +
          irow(t('cb_cellmin'), CB.cellMin + ' mV') +
          irow(t('cb_cellmax'), CB.cellMax + ' mV') +
          irow(t('cb_celltmin'), CB.ctMin + ' °C') +
          irow(t('cb_celltmax'), CB.ctMax + ' °C') +
          irow(t('cb_packs'), String(CB.packs)) +
          irow(t('cb_ccl'), CB.ccl + ' A') +
          irow(t('cb_dcl'), CB.dcl + ' A') +
          irow(t('cb_cvl'), CB.cvl + ' V') +
          irow(t('cb_chg'), CB.chg + ' kWh') +
          irow(t('cb_dchg'), CB.dchg + ' kWh') +
          irow(t('cb_banks'), CB.banks) +
        '</div></div>';
      return body;
    }

    /* ── VICTRON VE.DIRECT (DS reg.vedirect, Registry 5) ──────────────────
       Fünf Geräteklassen, KEINE eigenen Detail-Dialoge: jede Kachel öffnet den
       gemeinsamen Energie-Dialog (EnergyOverviewDialog) mit W⇄A-Umschalter,
       EnergyFlow und einer Victron-Card pro Gerät. Demo-Werte = initialModel
       der Spec (Formeln W = V·A wie ve_direct_tile_components.dart). */
    var VED = {
      bmv: { name: 'SmartShunt 500A', soc: 88, volt: '13.74', cur: '-4.1', w: -56, consAh: '-12.3', aux: '12.90' },
      mppt: { name: 'SmartSolar 100/30', pvVolt: '62.5', pvPwr: 320, volt: '13.90', cur: '23.0', chgW: 320, loadCur: '1.2', loadW: 17, yldTd: '0.85', yldYd: '1.80', yldTot: '412.5', maxpTd: 340, maxpYd: 355 },
      orion: { name: 'Orion XS 12/12-50', volt: '13.80', cur: '26.0', w: 359, inVolt: '13.1', inCur: '29.1', inW: 380 },
      chg: { name: 'Phoenix Smart IP43', volt: '14.20', c1: '8.0', w1: 114, c2: '6.4', w2: 91, c3: '4.0', w3: 57, wSum: 261 },
      inv: { name: 'Phoenix 12/800', dc: '12.70', acVolt: 230, acCur: '1.1', acVA: 260 }
    };
    function vedSel() {
      var m = {};
      try { E.vedirectDevices(CAT, state).forEach(function (e) { m[e.item.id] = e.qty; }); } catch (e2) {}
      return m;
    }

    function vedDd(name) {
      return '<div class="rv-dropdown-wrap "><div class="rv-dropdown disabled" role="button" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="dd-lead"></span><span class="dd-label">' + esc(name) + '</span>' +
        '<span class="dd-chev"><svg viewBox="0 0 40 40" fill="currentColor" aria-hidden="true"><path d="' + CHEV_PATH + '"></path></svg></span></div></div>';
    }
    function vedCell(v, l) {
      return '<div style="display:flex;flex-direction:column;align-items:center;min-width:0;">' +
        '<span style="font-size:20px;font-weight:700;color:var(--text-heading);white-space:nowrap;font-variant-numeric:tabular-nums;">' + esc(v) + '</span>' +
        '<span style="font-size:12.5px;color:var(--text-paragraph);text-align:center;">' + esc(l) + '</span></div>';
    }
    function vedHeroImg(icon, size) {
      return '<img src="' + esc(appdsIcon(icon)) + '" alt="" style="width:' + size + 'px;height:' + size + 'px;object-fit:contain;">';
    }
    /* VeCompactTileBody 2×1: Titel-Dropdown · Werte-Reihe · optionales Bedienelement */
    function vedCompact(did, key, name, cells, controlHtml) {
      var inner = '<div class="wx-pad" style="gap:8px;justify-content:space-evenly;">' +
        '<div>' + vedDd(name) + '</div>' +
        '<div style="display:flex;justify-content:space-evenly;align-items:flex-start;gap:8px;padding:0 8px;">' + cells.map(function (c) { return vedCell(c[0], c[1]); }).join('') + '</div>' +
        (controlHtml ? '<div style="padding:0 12px;">' + controlHtml + '</div>' : '') +
        '</div>';
      return island('2x1', inner, did);
    }
    /* Batterie-Kachel des nicht-DC-BMV (battery_tile über selectForBattery) */
    function wVedBattery(did) {
      var id = 'rvklt' + (lid++);
      lotties.push({ id: id, file: lotUrl('battery.json'), pct: VED.bmv.soc, kind: 'battery' });
      var hero = '<div style="position:relative;width:100%;display:flex;align-items:center;justify-content:center;">' +
        '<div style="width:78%;max-width:190px;height:96px;"><div id="' + id + '" style="width:100%;height:100%;"></div></div>' +
        '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:700;color:#fff;">' + VED.bmv.soc + '%</span></div>';
      var inner = '<div class="wx-pad" style="gap:8px;justify-content:space-evenly;">' +
        '<div>' + vedDd(VED.bmv.name) + '</div>' + hero +
        '<div style="display:flex;justify-content:space-evenly;gap:8px;">' +
        vedCell(VED.bmv.volt + ' V', t('stat_voltage')) + vedCell(VED.bmv.cur + ' A', t('stat_current')) + vedCell(VED.bmv.w + ' W', t('w_power')) +
        '</div></div>';
      return island('2x2', inner, did);
    }
    /* Starterspannungs-Kachel (BMV auxTyp 1) — 1×1 */
    function wVedStarter(did) {
      var id = 'rvklt' + (lid++);
      lotties.push({ id: id, file: lotUrl('battery.json'), pct: VED.bmv.soc, kind: 'battery' });
      var inner = '<div class="wx-pad" style="gap:6px;justify-content:space-evenly;align-items:center;">' +
        '<div style="width:70%;max-width:150px;height:64px;"><div id="' + id + '" style="width:100%;height:100%;"></div></div>' +
        '<span style="font-size:26px;font-weight:700;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + VED.bmv.aux + ' V</span>' +
        '<span style="font-size:13.5px;color:var(--text-paragraph);">' + esc(t('ved_starter')) + '</span></div>';
      return island('1x1', inner, did);
    }
    function wVedMppt(did) {
      return vedCompact(did, 'mppt', VED.mppt.name,
        [[VED.mppt.pvPwr + ' W', t('ved_pv_power')], [VED.mppt.chgW + ' W', t('ved_charge_power')], [VED.mppt.loadW + ' W', t('ved_load_out')]],
        rvSegHtml([t('ved_mode_off'), 'Auto', t('ved_mode_on')], 1));
    }
    function wVedOrion(did) {
      var inner = '<div class="wx-pad" style="gap:8px;justify-content:space-evenly;">' +
        '<div>' + vedDd(VED.orion.name) + '</div>' +
        '<div style="display:flex;align-items:center;justify-content:space-around;gap:12px;padding:0 12px;">' +
        '<span style="font-size:14px;color:var(--text-paragraph);">' + esc(t('ved_charger_lbl')) + '</span>' + rvSwitch(true) + '</div>' +
        '<div style="display:flex;align-items:baseline;justify-content:space-around;padding:0 12px;">' +
        '<span style="font-size:14px;color:var(--text-paragraph);">' + esc(t('ved_charge_power')) + '</span>' +
        '<span style="font-size:16px;font-weight:700;color:var(--text-heading);">' + VED.orion.w + ' W</span></div></div>';
      return island('2x1', inner, did);
    }
    function wVedCharger(did) {
      return vedCompact(did, 'chg', VED.chg.name,
        [[VED.chg.w1 + ' W', 'CH1'], [VED.chg.w2 + ' W', 'CH2'], [VED.chg.w3 + ' W', 'CH3']], null);
    }
    function wVedInverter(did) {
      return vedCompact(did, 'inv', VED.inv.name,
        [[VED.inv.acVA + ' VA', t('ved_ac_out')]],
        rvSegHtml([t('ved_mode_on'), t('ved_mode_off'), 'Eco'], 0));
    }
    /* Gemeinsamer Energie-Dialog (EnergyOverviewDialog): W⇄A + EnergyFlow +
       Sektionen Batterien / Geräte-Batterie mit einer Card je Geräteklasse */
    function ecVeParts() {
      var s = vedSel();
      function card(children) {
        return '<div class="rv-dcard" style="padding:16px 16px 18px;display:flex;flex-direction:column;align-items:center;margin:0 4px 12px;">' + children + '</div>';
      }
      function cname(n) { return '<div style="font-size:16px;font-weight:500;color:var(--text-heading);text-align:center;padding:0 0 14px;">' + esc(n) + '</div>'; }
      function veLogo() { return '<img src="' + esc(appIcon('X_Logo_Victron.svg')) + '" alt="Victron Energy" style="height:40px;max-width:160px;object-fit:contain;">'; }
      function cardHead(hero) {
        return '<div style="display:flex;flex-direction:column;align-items:center;gap:14px;padding:2px 0 8px;">' + veLogo() + vedHeroImg(hero, 72) + '</div>';
      }
      function heroBadge(value, label, active) {
        var c = active ? 'var(--success)' : 'var(--mid-grey)';
        return '<div style="display:inline-flex;align-items:center;gap:8px;padding:7px 16px;border-radius:999px;background:linear-gradient(135deg, color-mix(in srgb, ' + c + ' 14%, transparent), color-mix(in srgb, ' + c + ' 4%, transparent));">' +
          '<span aria-hidden="true" style="width:18px;height:18px;display:block;background:' + c + ';-webkit-mask-image:url(' + esc(appdsIcon('battery/X_Energy_Flash_0.svg')) + ');mask-image:url(' + esc(appdsIcon('battery/X_Energy_Flash_0.svg')) + ');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span>' +
          '<span style="font-size:15px;font-weight:700;color:' + c + ';font-variant-numeric:tabular-nums;">' + esc(value) + '</span>' +
          '<span style="font-size:12.5px;color:' + c + ';">' + esc(label) + '</span></div>';
      }
      function vrow(label, value) {
        return '<div style="display:flex;align-items:baseline;gap:16px;padding:6px 0;">' +
          '<span style="flex:1;font-size:14px;color:var(--text-paragraph);">' + esc(label) + '</span>' +
          '<span style="font-size:14.5px;font-weight:600;color:var(--text-heading);font-variant-numeric:tabular-nums;">' + esc(value) + '</span></div>';
      }
      function cardDiv() { return '<div style="height:2px;border-radius:2px;background:var(--tile-divider);margin:12px 0;"></div>'; }
      var stretch = '<div style="align-self:stretch;">';
      var battery = '', devices = '';
      if (s.ved_shunt) {
        battery += card(
          cname(VED.bmv.name) + veLogo() +
          '<div style="padding:10px 0 2px;align-self:stretch;">' + dLottieBattery(VED.bmv.soc, 200, 84, 28, VED.bmv.soc + '%') + '</div>' +
          '<div style="display:flex;flex-wrap:wrap;justify-content:space-evenly;gap:16px;padding:16px 0 4px;align-self:stretch;">' +
          vedCell(VED.bmv.volt + ' V', t('stat_voltage')) + vedCell(VED.bmv.cur + ' A', t('stat_current')) +
          vedCell(VED.bmv.w + ' W', t('w_power')) + vedCell(VED.bmv.consAh + ' Ah', t('ch_consumption')) + '</div>' +
          cardDiv() +
          '<span style="display:inline-flex;align-items:center;gap:8px;padding:5px 14px;border-radius:16px;border:2px solid var(--brand);font-size:12.5px;font-weight:600;color:var(--brand);">' + esc(t('ch_consumption')) + ' · ' + VED.bmv.w + ' W</span>' +
          '<div style="display:flex;align-items:center;gap:12px;padding:14px 4px 0;align-self:stretch;">' +
          '<span style="flex:1;font-size:14.5px;font-weight:600;color:var(--text-heading);">' + esc(t('ved_relay')) + '</span>' + rvSwitch(false) + '</div>'
        );
      }
      if (s.ved_mppt) {
        devices += card(
          cname(VED.mppt.name) + cardHead('battery/X_Energy_Photovoltaik_1.svg') +
          heroBadge(VED.mppt.pvPwr + ' W', t('ved_pv_power'), true) +
          stretch + cardDiv() +
          vrow(t('ved_pv_volt'), VED.mppt.pvVolt + ' V') + vrow(t('ved_pv_power'), VED.mppt.pvPwr + ' W') + cardDiv() +
          vrow(t('stat_voltage'), VED.mppt.volt + ' V') + vrow(t('stat_current'), VED.mppt.cur + ' A') + vrow(t('ved_charge_power'), VED.mppt.chgW + ' W') + cardDiv() +
          vrow(t('ved_load_cur'), VED.mppt.loadCur + ' A') + vrow(t('ved_load_out'), VED.mppt.loadW + ' W') +
          '<p style="font-size:14px;font-weight:600;color:var(--text-heading);text-align:center;margin:10px 0 8px;">' + esc(t('ved_load_out')) + '</p>' +
          rvSegHtml([t('ved_mode_off'), 'Auto', t('ved_mode_on')], 1) + cardDiv() +
          vrow(t('ved_cs'), t('ved_cs_bulk')) + vrow('Tracker', t('ved_trk_mpp')) + cardDiv() +
          vrow(t('ved_yld_today'), VED.mppt.yldTd + ' kWh') + vrow(t('ved_yld_yday'), VED.mppt.yldYd + ' kWh') + vrow(t('ved_yld_total'), VED.mppt.yldTot + ' kWh') +
          vrow(t('ved_maxp_today'), VED.mppt.maxpTd + ' W') + vrow(t('ved_maxp_yday'), VED.mppt.maxpYd + ' W') +
          '</div>'
        );
      }
      if (s.ved_orion) {
        devices += card(
          cname(VED.orion.name) + cardHead('battery/X_Energy_Alternator_1.svg') +
          heroBadge(VED.orion.w + ' W', t('ved_charge_power'), true) +
          stretch + cardDiv() +
          vrow(t('ved_out'), VED.orion.volt + ' V') + vrow(t('stat_current'), VED.orion.cur + ' A') + vrow(t('ved_charge_power'), VED.orion.w + ' W') + cardDiv() +
          vrow(t('ved_in'), VED.orion.inVolt + ' V') + vrow(t('ved_in_cur'), VED.orion.inCur + ' A') + vrow(t('ved_in_power'), VED.orion.inW + ' W') + cardDiv() +
          '<div style="display:flex;align-items:center;gap:12px;padding:4px 0;">' +
          '<span style="flex:1;font-size:14.5px;font-weight:600;color:var(--text-heading);">' + esc(t('ved_charger_lbl')) + '</span>' + rvSwitch(true) + '</div>' + cardDiv() +
          vrow(t('ved_cs'), t('ved_cs_bulk')) + vrow(t('ved_mode'), t('ved_mode_on')) +
          '</div>'
        );
      }
      if (s.ved_charger) {
        devices += card(
          cname(VED.chg.name) + cardHead('battery/X_Energy_Charging_1.svg') +
          heroBadge(VED.chg.wSum + ' W', t('ved_charge_power'), true) +
          stretch + cardDiv() +
          vrow(t('stat_voltage') + ' CH1', VED.chg.volt + ' V') + vrow(t('stat_current') + ' CH1', VED.chg.c1 + ' A') + vrow(t('ved_charge_power') + ' CH1', VED.chg.w1 + ' W') + cardDiv() +
          vrow(t('stat_voltage') + ' CH2', VED.chg.volt + ' V') + vrow(t('stat_current') + ' CH2', VED.chg.c2 + ' A') + vrow(t('ved_charge_power') + ' CH2', VED.chg.w2 + ' W') + cardDiv() +
          vrow(t('stat_voltage') + ' CH3', VED.chg.volt + ' V') + vrow(t('stat_current') + ' CH3', VED.chg.c3 + ' A') + vrow(t('ved_charge_power') + ' CH3', VED.chg.w3 + ' W') + cardDiv() +
          vrow(t('ved_cs'), t('ved_cs_absorption')) + vrow(t('ved_mode'), t('ved_mode_on')) +
          '</div>'
        );
      }
      if (s.ved_inverter) {
        devices += card(
          cname(VED.inv.name) + cardHead('battery/X_Energy_Flash_0.svg') +
          heroBadge(VED.inv.acVA + ' VA', t('ved_ac_out'), true) +
          stretch + cardDiv() +
          vrow(t('ved_dc_in'), VED.inv.dc + ' V') + cardDiv() +
          vrow(t('ved_ac_out'), VED.inv.acVolt + ' V') + vrow(t('stat_current'), VED.inv.acCur + ' A') + vrow(t('w_power'), VED.inv.acVA + ' VA') + cardDiv() +
          '<div style="display:flex;align-items:center;gap:12px;padding:4px 0;">' +
          '<span style="font-size:14.5px;font-weight:600;color:var(--text-heading);">' + esc(t('ved_mode')) + '</span>' +
          '<div style="flex:1;">' + rvSegHtml([t('ved_mode_on'), t('ved_mode_off'), 'Eco'], 0) + '</div></div>' + cardDiv() +
          vrow(t('ved_cs'), t('ved_cs_invert')) +
          '</div>'
        );
      }
      return { battery: battery, devices: devices };
    }

    /* ── NIVELLIERUNG (DS reg.inclination + InclinationLevel) — Brain-IMU ──
       Nur beim vollen BRAIN (Sensor an Bord, Lite hat ihn nicht). 2x1-„wide"-
       Layout laut Jasper-Vorgabe; Demo-Werte = initialModel (pitch 1.8 / roll 0.8).
       Anzeige-Gain 1.5 (±24° Clamp), Pivot 66 %, Dreistufung 1.5/3°. */
    var INCL = { pitch: 1.8, roll: 0.8 };
    function inclStat(a) { return Math.abs(a) < 1.5 ? 'ok' : Math.abs(a) < 3 ? 'info' : 'error'; }
    function inclGain(d) { return Math.max(-24, Math.min(24, d * 1.5)); }
    /* Messwerte hatten ein fest verdrahtetes Komma — im Englischen stand „1,8°"
       neben „13.74 V". Jetzt entscheidet die Seitensprache. */
    function decSep() { return (1.1).toLocaleString(NUM_LOCALE).indexOf(',') !== -1 ? ',' : '.'; }
    function inclFmt(d) { return Math.abs(d).toFixed(1).replace('.', decSep()); }
    function inclFrame(isRear, deg, idAttr) {
      var img = AB + '/types/' + (isRear ? 'camper-rear.png' : 'camper-side.png');
      return '<div class="inc-frame' + (isRear ? ' rear-frame' : '') + '">' +
        '<div class="inc-ref"></div>' +
        '<div class="inc-tilt"' + (idAttr ? ' id="' + idAttr + '"' : '') + ' style="transform:rotate(' + inclGain(deg) + 'deg);">' +
        '<div class="inc-van' + (isRear ? ' rear' : '') + '"><img src="' + esc(img) + '" alt=""></div>' +
        '<div class="inc-horizon ' + inclStat(deg) + '"></div></div></div>';
    }
    function wInclination() {
      var pid = 'rvkinc' + (lid++);
      live.push({ kind: 'incl', id: pid, basePitch: INCL.pitch, baseRoll: INCL.roll, pitch: INCL.pitch, roll: INCL.roll });
      var worst = Math.max(Math.abs(INCL.pitch), Math.abs(INCL.roll));
      var chip = worst < 1.5 ? ['ok', t('incl_chip_ok')] : worst < 3 ? ['info', t('incl_chip_info')] : ['error', t('incl_chip_err')];
      var sideDir = INCL.pitch >= 0 ? t('incl_dir_rear_high') : t('incl_dir_front_high');
      var rearDir = INCL.roll >= 0 ? t('incl_dir_right_low') : t('incl_dir_left_low');
      function axisCol(isRear, instDeg, angle, dir, sfx) {
        return '<div class="inc-col">' + inclFrame(isRear, instDeg, pid + sfx) +
          '<div class="inc-colrow"><span class="inc-lbl">' + esc(dir) + '</span>' +
          '<span class="inc-num sm ' + inclStat(angle) + '" id="' + pid + sfx + 'n">' + inclFmt(angle) + '<span class="deg">°</span></span></div></div>';
      }
      var did = regDlg(function () { return buildInclinationDialog(); });
      var inner = '<div class="wx-pad" style="padding:14px;">' +
        '<div class="rv-inclination lay-wide">' +
        '<div class="inc-head"><span class="inc-title">' + esc(t('incl_title')) + '</span>' +
        '<span class="inc-badge ' + chip[0] + '" id="' + pid + 'chip">' + esc(chip[1]) + '</span></div>' +
        '<div class="inc-cols">' +
        axisCol(false, -INCL.pitch, INCL.pitch, sideDir, 'p') +
        axisCol(true, INCL.roll, INCL.roll, rearDir, 'r') +
        '</div></div></div>';
      return island('2x1', inner, did);
    }
    function buildInclinationDialog() {
      var worst = Math.max(Math.abs(INCL.pitch), Math.abs(INCL.roll));
      var sev = worst > 5 ? 2 : worst > 2 ? 1 : 0;
      var badge = [[t('incl_chip_ok'), 'var(--success)'], [t('incl_chip_info'), 'var(--excavator)'], [t('incl_chip_err'), 'var(--apored)']][sev];
      function valCol(a) { return Math.abs(a) >= 3 ? 'var(--apored)' : Math.abs(a) >= 1.5 ? 'var(--excavator)' : 'var(--text-heading)'; }
      function angleCard(label, a) {
        return '<div class="rv-dcard" style="display:flex;align-items:center;gap:12px;padding:14px 16px;margin:0 4px 10px;">' +
          '<span style="flex:1;font-size:14.5px;font-weight:600;letter-spacing:.05em;color:var(--text-heading);">' + esc(label) + '</span>' +
          '<span style="font-size:26px;font-weight:600;color:' + valCol(a) + ';font-variant-numeric:tabular-nums;">' + inclFmt(a) + '°</span></div>';
      }
      /* Brain-Positions-Picker: 6 Flächen × 4 Logo-Richtungen (Brain-Rendering rotiert) */
      var SURFACES = [['floor', t('incl_s_floor')], ['ceiling', t('incl_s_ceiling')], ['front', t('incl_s_front')], ['rear', t('incl_s_rear')], ['left', t('incl_s_left')], ['right', t('incl_s_right')]];
      var DIRS = [['fwd', 0], ['right', 90], ['back', 180], ['left', -90]];
      var CONN = {
        floor: { fwd: t('incl_d_hinten'), right: t('incl_d_links'), back: t('incl_d_vorne'), left: t('incl_d_rechts') },
        ceiling: { fwd: t('incl_d_hinten'), right: t('incl_d_links'), back: t('incl_d_vorne'), left: t('incl_d_rechts') },
        front: { fwd: t('incl_d_unten'), right: t('incl_d_links'), back: t('incl_d_oben'), left: t('incl_d_rechts') },
        rear: { fwd: t('incl_d_unten'), right: t('incl_d_links'), back: t('incl_d_oben'), left: t('incl_d_rechts') },
        left: { fwd: t('incl_d_unten'), right: t('incl_d_hinten'), back: t('incl_d_oben'), left: t('incl_d_vorne') },
        right: { fwd: t('incl_d_unten'), right: t('incl_d_vorne'), back: t('incl_d_oben'), left: t('incl_d_hinten') }
      };
      var brainImg = AB + '/types/brain-normal.png';
      var grid = '<div class="rvk-incgrid" style="display:grid;grid-template-columns:auto repeat(4,1fr);gap:6px;align-items:center;padding:0 6px;">';
      SURFACES.forEach(function (srf) {
        grid += '<span style="font-size:12.5px;font-weight:600;color:var(--text);padding-right:6px;">' + esc(srf[1]) + '</span>';
        DIRS.forEach(function (dir) {
          var sel = srf[0] === 'floor' && dir[0] === 'fwd';
          grid += '<span class="rvk-incell" data-srf="' + srf[0] + '" data-dir="' + dir[0] + '" data-name="' + esc(srf[1] + ' · ' + t('incl_conn', { dir: CONN[srf[0]][dir[0]] })) + '" data-desc="' + esc(t('incl_desc_' + srf[0], { dir: CONN[srf[0]][dir[0]] })) + '" data-selected="' + (sel ? 'true' : 'false') + '" style="position:relative;display:flex;align-items:center;justify-content:center;min-height:46px;border-radius:10px;cursor:pointer;border:' + (sel ? '2px solid var(--brand)' : '1px solid var(--light-grey)') + ';">' +
            '<img src="' + esc(brainImg) + '" alt="" style="width:30px;height:30px;object-fit:contain;transform:rotate(' + dir[1] + 'deg);">' +
            '<span class="rvk-incheck" style="position:absolute;right:3px;top:3px;width:12px;height:12px;border-radius:50%;background:var(--brand);color:#fff;font-size:9px;line-height:12px;text-align:center;font-weight:700;' + (sel ? '' : 'display:none;') + '">✓</span></span>';
        });
      });
      grid += '</div>';
      var selName0 = SURFACES[0][1] + ' · ' + t('incl_conn', { dir: CONN.floor.fwd });
      var body =
        angleCard(t('incl_axis_x'), INCL.pitch) +
        angleCard(t('incl_axis_y'), INCL.roll) +
        '<div style="display:flex;justify-content:center;padding:4px 0 2px;">' +
        '<span style="padding:6px 14px;border-radius:48px;font-size:12.5px;font-weight:700;color:' + (sev === 1 ? 'var(--dark-grey)' : '#fff') + ';background:' + badge[1] + ';">' + esc(badge[0]) + '</span></div>' +
        dDiv2() +
        '<p style="font-size:16px;font-weight:600;color:var(--text-heading);margin:2px 6px 2px;">' + esc(t('incl_pos_title')) + '</p>' +
        '<p style="font-size:13.5px;color:var(--text-paragraph);margin:0 6px 12px;">' + esc(t('incl_pos_sub')) + '</p>' +
        grid +
        '<div class="rv-dcard" style="padding:12px 16px;margin:14px 4px 0;">' +
          '<div style="font-size:11.5px;font-weight:700;letter-spacing:.08em;color:var(--mid-grey);">' + esc(t('incl_selected')) + '</div>' +
          '<div style="display:flex;align-items:center;gap:10px;margin-top:3px;">' +
          '<span id="rvk-incname" style="flex:1;font-size:15px;font-weight:600;color:var(--text-heading);">' + esc(selName0) + '</span>' +
          '<span style="color:var(--brand);font-weight:700;">✓</span></div>' +
          '<div id="rvk-incdesc" style="font-size:12.5px;color:var(--text-paragraph);margin-top:3px;">' + esc(t('incl_desc_floor', { dir: CONN.floor.fwd })) + '</div>' +
        '</div>' +
        dDiv2() +
        '<div style="padding:0 6px;">' +
          '<div id="rvk-incstat" style="display:flex;align-items:flex-start;gap:8px;">' +
            '<span style="color:var(--success);font-weight:700;flex-shrink:0;">✓</span>' +
            '<span style="font-size:13.5px;color:var(--text);">' + esc(t('incl_cal_ok')) + '</span></div>' +
          '<div style="margin-top:12px;"><span id="rvk-incstart" role="button" style="display:block;text-align:center;padding:12px 16px;border-radius:24px;font-size:14.5px;font-weight:600;cursor:pointer;background:var(--brand);color:#fff;">' + esc(t('incl_cal_start')) + '</span></div>' +
          '<div style="font-size:12.5px;color:var(--text-paragraph);margin-top:5px;">' + esc(t('incl_cal_hint')) + '</div>' +
          '<div style="margin-top:10px;"><span id="rvk-incclear" role="button" style="display:block;text-align:center;padding:12px 16px;border-radius:24px;font-size:14.5px;font-weight:600;cursor:pointer;background:transparent;color:var(--apored);border:2px solid var(--apored);box-sizing:border-box;">' + esc(t('incl_cal_clear')) + '</span></div>' +
        '</div>';
      return {
        title: t('incl_title'),
        body: body,
        onMount: function (ov) { bindInclinationDialog(ov); }
      };
    }
    /* Interaktivität des Nivellierungs-Dialogs: Positions-Picker + Kalibrier-Simulation */
    function bindInclinationDialog(ov) {
      var calibrated = true, running = false;
      function setStatus(html) { var s2 = ov.querySelector('#rvk-incstat'); if (s2) s2.innerHTML = html; }
      function okStatus() {
        setStatus('<span style="color:var(--success);font-weight:700;flex-shrink:0;">✓</span><span style="font-size:13.5px;color:var(--text);">' + esc(t('incl_cal_ok')) + '</span>');
      }
      function idleStatus() {
        setStatus('<span style="color:var(--excavator);font-weight:700;flex-shrink:0;">!</span><span style="font-size:13.5px;color:var(--text);">' + esc(t('incl_cal_idle')) + '</span>');
      }
      function refreshClear() {
        var c = ov.querySelector('#rvk-incclear');
        if (c) { c.style.opacity = calibrated && !running ? '1' : '.45'; c.style.cursor = calibrated && !running ? 'pointer' : 'default'; }
      }
      ov.querySelectorAll('.rvk-incell').forEach(function (cellEl) {
        cellEl.addEventListener('click', function (e) {
          e.stopPropagation();
          ov.querySelectorAll('.rvk-incell').forEach(function (o) {
            var selN = o === cellEl;
            o.setAttribute('data-selected', selN ? 'true' : 'false');
            o.style.border = selN ? '2px solid var(--brand)' : '1px solid var(--light-grey)';
            var chk = o.querySelector('.rvk-incheck');
            if (chk) chk.style.display = selN ? '' : 'none';
          });
          var nm = ov.querySelector('#rvk-incname'), ds = ov.querySelector('#rvk-incdesc');
          if (nm) nm.textContent = cellEl.getAttribute('data-name') || '';
          if (ds) ds.textContent = cellEl.getAttribute('data-desc') || '';
          /* Auswahl ≠ konfigurierte Montage → Baseline gilt nicht mehr */
          calibrated = cellEl.getAttribute('data-srf') === 'floor' && cellEl.getAttribute('data-dir') === 'fwd';
          if (!running) { if (calibrated) okStatus(); else idleStatus(); }
          refreshClear();
        });
      });
      var startBtn = ov.querySelector('#rvk-incstart');
      if (startBtn) startBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (running) return;
        running = true;
        startBtn.textContent = t('incl_cal_calibrating');
        startBtn.style.opacity = '.75';
        setStatus('<span aria-hidden="true" class="fj-fan spin" style="width:16px;height:16px;border-radius:50%;border:2.5px solid var(--excavator);border-top-color:transparent;box-sizing:border-box;flex-shrink:0;margin-top:2px;"></span><span style="font-size:13.5px;color:var(--text);">' + esc(t('incl_cal_running')) + '</span>');
        refreshClear();
        setTimeout(function () {
          running = false; calibrated = true;
          startBtn.textContent = t('incl_cal_start');
          startBtn.style.opacity = '1';
          okStatus(); refreshClear();
        }, 4200);
      });
      var clearBtn = ov.querySelector('#rvk-incclear');
      if (clearBtn) clearBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!calibrated || running) return;
        calibrated = false;
        idleStatus(); refreshClear();
      });
    }

    /* TwoWay-Kachel — EIN Widget für ALLE gewählten Bewegung-Caps (DS reg.twoway):
       Dropdown-Picker (aktive/erste Cap) oben, Icon + Name mittig, horizontale
       TwoWayToggle-Wanne unten. Tap öffnet EIN kombiniertes Popup mit allen Caps. */
    function dsTwoWayAll(list) {
      function twtBtn(deg, word) {
        return '<button type="button" class="twt-btn schalter" aria-pressed="false">' +
          '<svg class="twt-chev" viewBox="11.5 5.85 18 28" aria-hidden="true" style="transform:rotate(' + deg + 'deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg>' +
          '<span class="twt-word">' + esc(word) + '</span></button>';
      }
      var dlgCaps = list.map(function (d) {
        return { icon: d.icon || 'twoway/X_TwoWay_Valve.svg', label: d.label, twL: d.twL, twR: d.twR };
      });
      var did = regDlg(function () { return buildTwoWayDialog(dlgCaps); });
      var a = list[0];
      var aIcon = a.icon || 'twoway/X_TwoWay_Valve.svg';
      var inner = '<div class="wx-pad" style="align-items:center;gap:12px;">' +
        '<div style="width:100%;">' + rvDropdown(a.label, aIcon) + '</div>' +
        '<div style="flex:1 1 0%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;min-height:0px;">' +
        '<span class="rv-icon rv-icon--tint" style="width:64px;height:64px;">' + iconTag(aIcon, '', 'X_TwoWay_Valve') + '</span>' +
        '<div style="font-size:17px;color:var(--text-paragraph);">' + esc(a.label) + '</div>' +
        '</div>' +
        '<div style="width:100%;padding:0px 30px;box-sizing:border-box;">' +
        '<div class="rv-twt horizontal tile twt-sq">' + twtBtn(180, a.twL) + twtBtn(0, a.twR) + '</div></div></div>';
      return island('2x2', inner, did);
    }
    /* Ortung (nur volles BRAIN) — DS-Kachel-Stil, kein Prototyp-Pendant */
    function dsLocate() {
      var did = regDlg(function () { return buildLocateDialog(); });
      return island('1x1', '<div class="rv-tile-center" style="gap:0px;padding:14px;">' +
        '<span class="rv-icon rv-icon--tint" style="width:64px;height:64px;"><img src="' + appIcon('X_Utility_Map') + '" alt=""></span>' +
        '<span class="rv-tile-name" style="margin-top:12px;">' + esc(t('w_locate_active')) + '</span>' +
        '<span style="margin-top:4px;font-size:12px;font-weight:600;color:var(--brand);">' + esc(t('w_gps')) + '</span></div>', did);
    }

    /* Energiefluss-Übersicht — Vanilla-Port von EnergyFlow.jsx (variant=tile).
       EIN Diagramm für eigene Energiequellen (endev_*, NODE-Battery-Modus) UND
       die gewählten Victron-VE.Direct-Geräte (Jasper 29.08.2026). Kanal-Routing
       wie DS batteryAllTotals: MPPT → PV (batterieseitige Ladeleistung) ·
       Orion → Generator · Phoenix Charger → Landstrom · Phoenix Inverter →
       WR-Zelle · MPPT-Last + SmartShunt → Verbrauch. Präzise VE-Werte
       verdrängen den generischen Mock desselben Kanals. Das Total trägt der
       SmartShunt (batterie-artig), solange kein NODE-Battery-Basisverbrauch
       mitläuft; sonst zählt die Kanal-Summe (efInner-Default). */
    function energyChannels(unit) {
      var A = unit === 'A';
      var s = vedSel();
      /* NODE-Battery-FAMILIE ('battery' UND 'hc'): beide messen den endev-
         Grundverbrauch (-85 W) — 'hc' hat zwar keine Fluss-KACHEL, aber der
         Batterie-DIALOG trägt denselben Fluss (Regression im QA battery-hc). */
      var batteryMode = false;
      try { var bk = E.batteryPlan(CAT, state).kind; batteryMode = bk === 'battery' || bk === 'hc'; } catch (e) {}
      function qm(w) { return A ? Math.round(w / 12.8 * 10) / 10 : w; }   // endev-Mocks ≈ 12,8 V
      var chs = [];
      if (s.ved_mppt) chs.push({ id: 'pv', label: t('ch_solar'), icon: 'battery/X_Energy_Photovoltaik_0.svg', iconOn: 'battery/X_Energy_Photovoltaik_1.svg', value: A ? 23.0 : VED.mppt.chgW, role: 'solar' });
      else if (on('endev_solar')) chs.push({ id: 'pv', label: t('ch_solar'), icon: 'battery/X_Energy_Photovoltaik_0.svg', iconOn: 'battery/X_Energy_Photovoltaik_1.svg', value: qm(180), role: 'solar' });
      if (s.ved_charger) chs.push({ id: 'mains', label: t('ch_mains'), icon: 'battery/X_Energy_Charging_0.svg', iconOn: 'battery/X_Energy_Charging_1.svg', value: A ? 18.4 : VED.chg.wSum });
      else if (on('endev_land')) chs.push({ id: 'mains', label: t('ch_mains'), icon: 'battery/X_Energy_Charging_0.svg', iconOn: 'battery/X_Energy_Charging_1.svg', value: qm(320) });
      if (s.ved_orion) chs.push({ id: 'gen', label: 'Generator', icon: 'battery/X_Energy_Alternator_0.svg', iconOn: 'battery/X_Energy_Alternator_1.svg', value: A ? 26.0 : VED.orion.w });
      else if (on('endev_booster')) chs.push({ id: 'booster', label: t('ch_booster'), icon: 'battery/X_Energy_Alternator_0.svg', iconOn: 'battery/X_Energy_Alternator_1.svg', value: qm(250) });
      var cons = 0, haveCons = false;
      if (batteryMode) { cons += qm(-85); haveCons = true; }
      if (s.ved_mppt) { cons += A ? -1.2 : -VED.mppt.loadW; haveCons = true; }
      if (s.ved_shunt && !batteryMode) { cons += A ? -4.1 : VED.bmv.w; haveCons = true; }
      var load = [];
      if (haveCons) load.push({ value: A ? Math.round(cons * 10) / 10 : Math.round(cons), label: t('ch_consumption') });
      if (s.ved_inverter) load.push({ value: A ? -20.5 : -VED.inv.acVA, label: t('ch_inverter') });
      else if (on('endev_wr')) load.push({ value: qm(-460), label: t('ch_inverter') });
      if (load.length) chs.push({ id: 'load', load: load });
      var total = null;
      if (s.ved_shunt && !batteryMode) total = A ? -4.1 : VED.bmv.w;
      return { chs: chs, total: total };
    }
    /* EcoFlow-Companion: Seed-Kanäle wie im App-DS (ECO_FLOW_SEED) */
    function efEcoChannels() {
      return [
        { id: 'pv', label: t('ch_solar'), icon: 'battery/X_Energy_Photovoltaik_0.svg', iconOn: 'battery/X_Energy_Photovoltaik_1.svg', value: 0, role: 'solar' },
        { id: 'mains', label: t('ch_mains'), icon: 'battery/X_Energy_Charging_0.svg', iconOn: 'battery/X_Energy_Charging_1.svg', value: 17 },
        { id: 'gen', label: 'Generator', icon: 'battery/X_Energy_Alternator_0.svg', iconOn: 'battery/X_Energy_Alternator_1.svg', value: 0 },
        { id: 'load', load: [{ value: -4, label: t('ch_consumption') }, { value: 0, label: t('ch_inverter') }] }
      ];
    }
    function dsEnergyFlow(chs) {
      chs = chs || [];
      var did = regDlg(function () { return buildEnergyDialog(chs); });
      return island('2x2', '<div class="wx-pad" style="padding:12px;justify-content:center;">' + efInner(chs, 'tile') + '</div>', did);
    }
    function initEnergyFlows(mount) {
      mount.querySelectorAll('.rv-energyflow[data-ef]').forEach(function (flowEl) {
        var chs;
        try { chs = JSON.parse(decodeURIComponent(flowEl.getAttribute('data-ef'))); } catch (e) { return; }
        var efUnit = flowEl.getAttribute('data-efunit') || 'W';
        var stage = flowEl.querySelector('.ef-stage');
        if (!stage) return;
        var efTries = 0;
        (function draw() {
          var w = stage.clientWidth, h = stage.clientHeight;
          if (!w || !h) { if (efTries++ < 40) requestAnimationFrame(draw); return; }
          /* Geometrie exakt wie EnergyFlow.jsx (tile-Variante) */
          var vSize = 116, pad = 14, nodeW = 96, nodeH = 78, vHalf = vSize * 0.32;
          function isSolar(c) { return c.role === 'solar' || /(^|[^a-z])(pv|solar)([^a-z]|$)/i.test(c.id || ''); }
          function isLoad(c) { return !!c.load || /(load|verbrauch)/i.test(c.id || ''); }
          var topCh = null, botCh = null;
          chs.forEach(function (c) { if (!topCh && isSolar(c)) topCh = c; });
          chs.forEach(function (c) { if (!botCh && c !== topCh && isLoad(c)) botCh = c; });
          var sideChs = chs.filter(function (c) { return c !== topCh && c !== botCh; }).slice(0, 2);
          var assigned = [];
          if (chs.length === 1) {
            var c0 = chs[0];
            assigned.push({ slot: isSolar(c0) ? 'top' : isLoad(c0) ? 'bottom' : 'right', ch: c0 });
          } else {
            if (topCh) assigned.push({ slot: 'top', ch: topCh });
            if (sideChs[0]) assigned.push({ slot: 'left', ch: sideChs[0] });
            if (sideChs[1]) assigned.push({ slot: 'right', ch: sideChs[1] });
            if (botCh) assigned.push({ slot: 'bottom', ch: botCh });
          }
          var slots = assigned.map(function (a) { return a.slot; });
          var count = assigned.length;
          var onlySide = count === 1 && (slots[0] === 'left' || slots[0] === 'right');
          var cx = onlySide ? pad + vSize / 2 : w / 2;
          var hasTop = slots.indexOf('top') >= 0, hasBot = slots.indexOf('bottom') >= 0;
          var cy = h / 2 + ((hasTop ? 1 : 0) - (hasBot ? 1 : 0)) * (h * 0.10) / 2;
          var armV = Math.max(14, Math.min(cy - vHalf - nodeH - 6, h - cy - vHalf - nodeH - 6));
          var armH = count === 1 ? Math.max(40, w - pad * 2 - vSize - nodeW) : Math.max(14, w / 2 - vSize / 2 - nodeW - pad);
          function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
          var endpoints = {
            top: [cx, clamp(cy - vHalf - armV, nodeH, h)],
            bottom: [cx, clamp(cy + vHalf + armV, 0, h - nodeH)],
            left: [clamp(cx - vSize / 2 - armH, nodeW, w), cy],
            right: [clamp(cx + vSize / 2 + armH, 0, w - nodeW), cy]
          };
          var anchors = { top: [-0.5, -1], bottom: [-0.5, 0], left: [-1, -0.5], right: [0, -0.5] };
          function chVal(ch) { return ch.load ? ch.load.reduce(function (s, c) { return s + (c.value || 0); }, 0) : (ch.value || 0); }
          function flowColor(v) { return v > 0 ? 'var(--success)' : v < 0 ? 'var(--cold)' : 'var(--light-grey)'; }
          var linesSvg = assigned.map(function (a) {
            var ep = endpoints[a.slot];
            var v = chVal(a.ch);
            var g = '<g><line class="ef-rail" x1="' + cx + '" y1="' + cy + '" x2="' + ep[0] + '" y2="' + ep[1] + '" style="stroke:' + flowColor(v) + ';opacity:' + (v === 0 ? 0.45 : 0.22) + ';"></line>';
            if (v !== 0) g += '<line class="ef-dash ' + (v > 0 ? 'flow-in' : 'flow-out') + '" x1="' + cx + '" y1="' + cy + '" x2="' + ep[0] + '" y2="' + ep[1] + '" style="stroke:' + flowColor(v) + ';"></line>';
            return g + '</g>';
          }).join('');
          function nodeHtml(ch) {
            if (ch.load) {
              return '<div class="ef-node ef-load">' + ch.load.map(function (cell) {
                return '<div class="ef-cell"><span class="ef-v">' + cell.value + ' ' + esc(efUnit) + '</span>' + (cell.label ? '<span class="ef-l">' + esc(cell.label) + '</span>' : '') + '</div>';
              }).join('') + '</div>';
            }
            var v = ch.value || 0;
            var iconName = v > 0 && ch.iconOn ? ch.iconOn : ch.icon;
            return '<div class="ef-node">' +
              (v !== 0 ? '<span class="ef-v">' + v + ' ' + esc(efUnit) + '</span>' : '') +
              '<img class="ef-ic" src="' + esc(appdsIcon(iconName)) + '" alt="">' +
              (v !== 0 && ch.label ? '<span class="ef-l">' + esc(ch.label) + '</span>' : '') + '</div>';
          }
          var nodes = assigned.map(function (a) {
            var ep = endpoints[a.slot], an = anchors[a.slot];
            return '<div class="ef-slot s-' + a.slot + '" style="left:' + ep[0] + 'px;top:' + ep[1] + 'px;transform:translate(' + (an[0] * 100) + '%, ' + (an[1] * 100) + '%);z-index:2;">' + nodeHtml(a.ch) + '</div>';
          }).join('');
          stage.innerHTML = '<svg class="ef-lines" width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '" aria-hidden="true">' + linesSvg + '</svg>' +
            '<div class="ef-vehicle" style="left:' + cx + 'px;top:' + cy + 'px;width:' + vSize + 'px;height:' + vSize + 'px;z-index:5;"><span class="ef-glow"></span><img src="' + esc(APPDS.camper || appIcon('C_General_Camper')) + '" alt=""></div>' +
            nodes;
        })();
      });
    }

    var HEATING_TITLES = { truma: 'Truma CP+', alde: 'Alde', eberspaecher: 'Eberspächer' };
    var HEATING_ENERGY = { truma: 'Diesel', alde: 'Gas', eberspaecher: 'Diesel' };
    var KLIMA_TITLES = { freshjet: 'Dometic Freshjet', truma_aventa: 'Truma Aventa' };
    /* Eberspächer Airtronic 3 (DS reg.heater_eberspaecher): eigene Heizen/Lüften-
       Heizung — Segment Heizen·Lüften (Lüften = drehendes Lüfterrad), Statuszeile,
       Energie NUR Eco-Modus. KEIN Kühlen/Boiler/Energiequelle. */
    function eberOpts(ig) {
      var x = extra(ig);
      return {
        dd: true, mode: 'eber',
        title: x.wTitle || HEATING_TITLES[ig.id] || ig.label,
        p: 0.645, temp: 25, ist: 15,
        caption: t('w_heating_running'),
        initView: 'dial',
        fan: { on: true, ist: 15 },
        segViews: [
          { label: t('seg_heat'), view: 'dial', cap: t('w_heating_running') },
          { label: t('seg_vent'), view: 'fan', cap: t('w_vent_running') }
        ],
        active: 0
      };
    }
    /* Alde Compact (DS reg.alde): Warmwasserheizung — Zone-Dial (Soll/Ist),
       Wasserboiler Normal·Boost·Auto, Energie Gas-Schalter + Gas/Elektro +
       Strombegrenzung (Aus·1·2·3 kW). KEIN Diesel, KEIN 900W/1800W (das ist Truma). */
    /* Immer in der Maximalkonfiguration (Jasper, 13.10.2026): Compact 3030 mit ZWEI
       Heizzonen (DS: „Alde has AT MOST 2 zones“) → Zonen-Leiste Zone 1 · Beide · Zone 2
       unter der Statuszeile, wie DS reg.alde. Soll 22 / Ist 21 (Zone 1), Bereich 5–30 °C. */
    function aldeOpts(ig) {
      var x = extra(ig);
      return {
        dd: false, mode: 'alde',
        title: x.wTitle || 'Alde Compact 3030',
        p: 0.68, temp: 22, ist: 21,
        caption: t('w_heating_running'),
        tabs: [t('alde_zone_n', { n: 1 }), t('zone_both'), t('alde_zone_n', { n: 2 })], active: 0
      };
    }
    function heatOpts(ig) {
      var x = extra(ig);
      if (ig.id === 'eberspaecher') return eberOpts(ig);
      if (ig.id === 'alde') return aldeOpts(ig);
      /* Heizung allein: kann nur heizen → gar keine Segment-Leiste (keine Automatik ohne Klima). */
      return { dd: true, mode: 'heat', boiler: ig.id === 'truma' || ig.id === 'alde', energy: x.wEnergy || HEATING_ENERGY[ig.id] || 'Diesel', title: x.wTitle || HEATING_TITLES[ig.id] || ig.label, p: 0.68, temp: 22, ist: null, caption: t('w_heating_running'), tabs: [], active: 0 };
    }
    /* Dometic FreshJet (DS reg.dometic_freshjet): Dachklima — Kühlen·Lüften·Heizen,
       Lüften = drehendes Lüfterrad. Dialog: Modus-Dropdown (5 Modi), Lüfter-Automatik
       + Intensität, Außen-/Innenlicht + Helligkeit, Nacht-Modus. */
    function freshOpts(ig) {
      var x = extra(ig);
      return {
        dd: false, mode: 'freshjet',
        title: x.wTitle || KLIMA_TITLES[ig.id] || ig.label,
        p: 0.5, temp: 23, ist: 29,
        caption: t('w_cooling_running'),
        initView: 'dial',
        fan: { on: true, ist: 29, intensity: true, label: t('fan_medium'), slider: true, val: 33 },
        segViews: [
          { label: t('seg_cool'), view: 'dial', cap: t('w_cooling_running') },
          { label: t('seg_vent'), view: 'fan', cap: t('w_vent_running') },
          { label: t('seg_heat'), view: 'dial', cap: t('w_heating_running') }
        ],
        active: 0
      };
    }
    function coolOpts(ig) {
      var x = extra(ig);
      if (ig.id === 'freshjet') return freshOpts(ig);
      return { dd: false, mode: 'cool', light: ig.id === 'freshjet', title: x.wTitle || KLIMA_TITLES[ig.id] || ig.label, p: 0.5, temp: 23, ist: 29, caption: t('w_cooling_running'), tabs: [t('seg_cool'), t('seg_vent'), t('seg_heat')], active: 0 };
    }
    /* Combi/Alde (Heizen) + Aventa (Kühlen) am selben CI-Bus → EIN Automatik-Widget */
    function combinedOpts(merged) {
      var host = merged.host, climate = merged.climate;
      var hx = extra(host), cx = extra(climate);
      return {
        dd: true, mode: 'combined', host: host.id,
        title: hx.wTitle || HEATING_TITLES[host.id] || host.label,
        hostTitle: hx.wTitle || HEATING_TITLES[host.id] || host.label,
        climateTitle: cx.wTitle || KLIMA_TITLES[climate.id] || climate.label,
        boiler: host.id === 'truma' || host.id === 'alde',
        energy: hx.wEnergy || HEATING_ENERGY[host.id] || 'Diesel',
        p: 0.68, temp: 22, ist: null, caption: t('w_heating_running'),
        tabs: [t('seg_cool'), t('seg_auto'), t('seg_heat')], active: 1
      };
    }
    function integWidgets() {
      var out = [];
      var merged = null;
      try { merged = E.integrationBundles(CAT, state).merged; } catch (e) { merged = null; }
      var skip = {};
      if (merged) {
        skip[merged.host.id] = true;
        skip[merged.climate.id] = true;
        out.push({ h: dsClimate(combinedOpts(merged)), k: 'clim-combined' });
      }
      byBereich('integration').forEach(function (ig) {
        if (!on(ig.id) || skip[ig.id]) return;
        if (ig.cap === 'heating') {
          /* Neue Heizungs-Integrationen haben eigene DS-Widgets (Registry 3/4) —
             alles andere bleibt beim ClimateControl-Standard (Truma/Alde/Eber). */
          if (ig.id === 'autoterm') out.push({ h: wAutoterm(ig), k: 'heat-autoterm' });
          else if (ig.id === 'webasto') out.push({ h: wWebasto(ig), k: 'heat-webasto' });
          else if (ig.id === 'timberline') out.push({ h: wTimberline(ig), k: 'heat-timberline' });
          else out.push({ h: dsClimate(heatOpts(ig)), k: 'clim-heat:' + ig.id });
        } else if (ig.cap === 'klima') {
          out.push({ h: dsClimate(coolOpts(ig)), k: 'clim-cool:' + ig.id });
        } else if (ig.cap === 'fridge') {
          out.push({ h: dsFridge(on('tfridge')), k: 'fridge:' + ig.id });
        } else if (ig.cap === 'alarm') {
          out.push({ h: dsThitronikStatus(), k: 'thi-status' });
          out.push({ h: dsThitronikPanic(), k: 'thi-panic' });
        } else if (ig.cap === 'ecoflow') {
          out.push({ h: dsEcoflow(ig.label), k: 'eco:' + ig.id });
          out.push({ h: dsEnergyFlow(efEcoChannels()), k: 'eco-flow:' + ig.id });
        }
      });
      return out;
    }

    function renderHome() {
      var mount = el('rvk-home');
      if (!mount) return;
      anims.forEach(function (a) { try { a.destroy(); } catch (e) {} });
      anims = []; lotties = []; live = []; lid = 0;
      dlgData = {}; dlgSeq = 0;
      closeSheet();

      var W = [], Wk = [];
      function pushW(h, k) { W.push(h); Wk.push(k); }
      /* Nivellierung: der Lagesensor steckt NUR im vollen BRAIN (nicht im Lite) —
         2x1-Widget als erste Kachel (Jasper, 27.08.2026). Vorhandenes BRAIN zählt als volles. */
      if (E.brainFull(state)) pushW(wInclination(), 'incl');
      integWidgets().forEach(function (o) { pushW(o.h, o.k); });
      var caps = capLists();
      var i;
      for (i = 0; i < caps.sw.length; i += 6) pushW(wSwitch(caps.sw.slice(i, i + 6)), 'sw' + i);
      var lightW = wLight();
      if (lightW) pushW(lightW, 'light');
      for (i = 0; i < caps.lsw.length; i += 6) pushW(wSwitch(caps.lsw.slice(i, i + 6)), 'lsw' + i);
      if (caps.tw.length) pushW(dsTwoWayAll(caps.tw), 'tw');
      for (i = 0; i < caps.lv.length; i += 6) pushW(wLevel(caps.lv.slice(i, i + 6)), 'lv' + i);

      var plan = E.batteryPlan(CAT, state);
      if (plan.kind === 'bms' && plan.bms) {
        /* CAN-BMS-Batterien (Bulltron/SuperVolt/Super B/generisch) → eigenes
           DS-Widget (reg.canbms); EcoFlow behält sein PowerKit-Widget.
           EcoFlow nie doppelt: wenn die zugehörige Integration (extra.integId) oben schon
           ein EcoFlow-Widget gerendert hat, hier NICHT nochmal (1 System / Fahrzeug). */
        var bx = extra(plan.bms);
        if (plan.bms.cap === 'canbms') pushW(dsCanBms(plan.bms), 'canbms:' + plan.bms.id);
        else if (!(bx.integId && on(bx.integId))) pushW(dsEcoflow(plan.bms.label), 'eco-bms');
      } else if (plan.kind === 'hc' || plan.kind === 'battery') {
        pushW(wBattery(), 'battery');
      }
      /* Victron VE.Direct: Kacheln je gewählter Geräteklasse; ALLE öffnen den
         gemeinsamen Energie-Dialog (DS EnergyOverviewDialog). */
      var vedS = vedSel();
      var anyVed = !!(vedS.ved_shunt || vedS.ved_mppt || vedS.ved_orion || vedS.ved_charger || vedS.ved_inverter);
      var vedDid = null;
      if (anyVed) {
        vedDid = regDlg(function () { return buildVeDialog(); });
        if (vedS.ved_shunt) { pushW(wVedBattery(vedDid), 'ved-batt'); pushW(wVedStarter(vedDid), 'ved-starter'); }
        if (vedS.ved_mppt) pushW(wVedMppt(vedDid), 'ved-mppt');
        if (vedS.ved_orion) pushW(wVedOrion(vedDid), 'ved-orion');
        if (vedS.ved_charger) pushW(wVedCharger(vedDid), 'ved-chg');
        if (vedS.ved_inverter) pushW(wVedInverter(vedDid), 'ved-inv');
      }
      /* EIN Energie-Fluss-Widget für alles (Jasper 29.08.): eigene Energiequellen
         UND VE.Direct-Geräte als Knoten. Bei VE-Auswahl öffnet es den reichen
         VE-Dialog (Cards je Gerät), sonst den klassischen Fluss-Dialog. */
      if (plan.kind === 'battery' || anyVed) {
        var mFlow = energyChannels('W');
        var flowDid = anyVed ? vedDid : regDlg(function () { return buildEnergyDialog(energyChannels('W').chs); });
        pushW(island('2x2', '<div class="wx-pad" style="padding:12px;justify-content:center;">' + efInner(mFlow.chs, 'tile', 'W', mFlow.total == null ? undefined : mFlow.total) + '</div>', flowDid), 'flow');
      }
      for (i = 0; i < caps.tp.length; i += 6) pushW(wTemp(caps.tp.slice(i, i + 6)), 'tp' + i);
      /* Ortung/GPS-Kachel vorerst DEAKTIVIERT — das Widget gibt es in der App so noch
         nicht (Jasper 22.07.2026: „fügen wir später hinzu"). Zum Reaktivieren die
         Zeile wieder einkommentieren; dsLocate() bleibt dafür erhalten. */
      // if (state.brainMode === 'full' && W.length) pushW(dsLocate(), 'locate');

      /* App-Header-Status */
      var full = E.brainFull(state);
      el('rvk-app-status').textContent = full ? t('status_remote') : t('status_local');
      el('rvk-app-status-icon').src = uiIcon(full ? 'wifi.svg' : 'bluetooth.svg');

      if (!W.length) {
        mount.innerHTML = '<div class="rvk-empty"><div class="rvk-empty-title">' + esc(t('phone_empty_title')) + '</div><div class="rvk-empty-text">' + esc(t('phone_empty_text')) + '</div></div>';
        prevWkeys = [];
        return;
      }
      mount.innerHTML = '<div class="rvk-grid">' + W.join('') + '</div>';

      mountLotties(mount);
      mount.querySelectorAll('.rvk-lot-inline:not([data-lot-done])').forEach(loadLottieInto);
      mountLevelLotties(mount, true);
      bindPhoneControls(mount);
      initEnergyFlows(mount);

      /* Autofocus: neu erschienenes (oder gemorphtes) Widget sanft anfahren + einmal pulsen.
         Bei reiner Entfernung passiert nichts. Erster Render (prevWkeys==null) still. */
      if (prevWkeys) {
        var added = [];
        Wk.forEach(function (k, idx) { if (prevWkeys.indexOf(k) < 0) added.push(idx); });
        if (added.length) {
          var children = mount.querySelectorAll('.rvk-grid > *');
          var node = children[added[0]];
          if (node) focusWidget(node);
        }
      }
      prevWkeys = Wk;
    }

    /* Sanftes Anfahren + Puls (Desktop: nur Feed scrollt; Mobile-Peek: Puls am Phone) */
    function focusWidget(node) {
      var mobilePeek = false;
      try { mobilePeek = window.matchMedia('(max-width:1023px)').matches && !ui.mobilePreview; } catch (e) {}
      if (mobilePeek) {
        var ph = el('rvk-phone');
        if (ph) { ph.classList.remove('rvk-peek-pulse'); void ph.offsetWidth; ph.classList.add('rvk-peek-pulse'); setTimeout(function () { ph.classList.remove('rvk-peek-pulse'); }, 1100); }
        return;
      }
      var feed = node.closest('.rvk-feed');
      if (feed) {
        /* WICHTIG: das (erste) Widget NIE per Auto-Scroll unter die App-Headerleiste
           schieben. Der Feed hat padding-top = Header-Höhe (reservierter Platz unter dem
           Header). Regel — alle Device-Größen:
             • Passt das fokussierte Widget komplett in die erste Ansicht → scrollTop = 0
               (Content startet unter dem Header, erstes Widget behält seinen Abstand).
             • Liegt es UNTER dem Fold → so weit scrollen, dass seine Oberkante unter dem
               Header sitzt (dann dürfen frühere Widgets unter den Header scrollen — genau
               der „genug Widgets → Durchschieben"-Fall).
           Per rAF verzögert, weil renderHome() VOR applyPanelFrame()/sizePanelGrid() läuft:
           würde die Geometrie sofort gelesen, stünde das Panel-padding-top (32px) noch nicht
           (CSS-Default 112px des .rvk-feed) → falsches Ziel → Widget landete unter dem Header. */
        requestAnimationFrame(function () {
          try {
            var fr = feed.getBoundingClientRect(), nr = node.getBoundingClientRect();
            var padTop = parseFloat(getComputedStyle(feed).paddingTop) || 0;
            var margin = 10;
            var restTop = (nr.top - fr.top) + feed.scrollTop;   // Oberkante relativ zum Content-Anfang (scroll-unabhängig)
            var restBot = restTop + nr.height;
            var target = (restBot <= feed.clientHeight - margin) ? 0 : (restTop - padTop);
            target = Math.max(0, target);
            if (feed.scrollTo) feed.scrollTo({ top: target, behavior: 'smooth' });
            else feed.scrollTop = target;
          } catch (e) {}
        });
      }
      node.classList.remove('rvk-focus-pulse'); void node.offsetWidth;
      node.classList.add('rvk-focus-pulse');
      setTimeout(function () { node.classList.remove('rvk-focus-pulse'); }, 1100);
    }

    /* Lottie mit CSS-Fallback */
    /* Lottie in einen einzelnen Container laden (für Dialoge), sonst CSS-Fallback.
       Liest data-lot-file / data-lot-pct / data-lot-kind. */
    function loadLottieInto(c) {
      if (!c || c.getAttribute('data-lot-done')) return;
      c.setAttribute('data-lot-done', '1');
      var file = c.getAttribute('data-lot-file');
      var pct = parseFloat(c.getAttribute('data-lot-pct')) || 70;
      var kind = c.getAttribute('data-lot-kind') || 'frisch';
      function fb() { c.innerHTML = '<span class="rvk-fill' + (kind === 'battery' ? ' rvk-fill--battery' : '') + '" data-kind="' + esc(kind) + '" style="--pct:' + pct + '%;"><span class="rvk-fill-bar"></span></span>'; }
      if (!window.lottie || !file) { fb(); return; }
      fetch(file).then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); }).then(function (j) {
        var a = window.lottie.loadAnimation({ container: c, renderer: 'svg', loop: false, autoplay: false, animationData: j });
        anims.push(a);
        var tot = (j.op - j.ip) || 100;
        a.addEventListener('DOMLoaded', function () { a.goToAndStop(Math.max(0, Math.min(tot - 1, (pct / 100) * (tot - 1))), true); });
      }).catch(fb);
    }
    function mountLotties(mount) {
      lotties.forEach(function (L) {
        var c = document.getElementById(L.id);
        if (!c) return;
        function fallback() {
          var isBattery = L.kind === 'battery';
          c.innerHTML = '<span class="rvk-fill' + (isBattery ? ' rvk-fill--battery' : '') + '" data-kind="' + esc(L.kind) + '" style="--pct:' + L.pct + '%;"><span class="rvk-fill-bar"></span></span>';
          if (isBattery) {
            var pctEl = c.parentNode ? c.parentNode.querySelector('.pct') : null;
            if (pctEl) pctEl.classList.add('on-fallback');
          }
          L.fallback = c.querySelector('.rvk-fill');
        }
        if (!window.lottie) { fallback(); return; }
        fetch(L.file).then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); }).then(function (j) {
          var a = window.lottie.loadAnimation({ container: c, renderer: 'svg', loop: false, autoplay: false, animationData: j });
          anims.push(a);
          var tot = (j.op - j.ip) || 100;
          L.anim = a; L.tot = tot;
          a.addEventListener('DOMLoaded', function () {
            a.goToAndStop(Math.max(0, Math.min(tot - 1, (L.pct / 100) * (tot - 1))), true);
          });
        }).catch(fallback);
      });
    }

    function bindPhoneControls(mount) {
      mount.querySelectorAll('.toggle').forEach(function (tg) {
        tg.addEventListener('click', function (e) {
          e.stopPropagation();
          tg.dataset.state = tg.dataset.state === 'on' ? 'off' : 'on';
        });
      });
      mount.querySelectorAll('.slider input[type=range]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var sl = inp.closest('.slider');
          if (sl) sl.style.setProperty('--pct', inp.value + '%');
          var scope = inp.closest('.zone-body') || inp.closest('.row-body');
          if (scope && sl && sl.classList.contains('brightness')) {
            var v = scope.querySelector('.br-val');
            if (v) v.textContent = inp.value + ' %';
          }
        });
        inp.addEventListener('click', function (e) { e.stopPropagation(); });
      });
      mount.querySelectorAll('.dd-trigger').forEach(function (tr) {
        tr.addEventListener('click', function (e) {
          e.stopPropagation();
          var dd = tr.closest('.dd');
          if (!dd) return;
          var open = dd.getAttribute('data-open') === 'true';
          mount.querySelectorAll('.dd[data-open="true"]').forEach(function (d) { if (d !== dd) d.setAttribute('data-open', 'false'); });
          dd.setAttribute('data-open', open ? 'false' : 'true');
        });
      });
      /* App-DS-Dropdown MIT Menü (rvk-ddlive, z. B. Timberline-Zonenwahl):
         Trigger klappt das Menü auf/zu, Item-Wahl setzt Label + Zonen-Werte. */
      mount.querySelectorAll('.rvk-ddlive .rv-dropdown').forEach(function (tr) {
        tr.addEventListener('click', function (e) {
          e.stopPropagation();
          var wrap = tr.closest('.rvk-ddlive');
          var menu = wrap && wrap.querySelector('.rv-dropdown-menu');
          if (!menu) return;
          var openNow = menu.style.display === 'none';
          mount.querySelectorAll('.rvk-ddlive .rv-dropdown-menu').forEach(function (m2) { m2.style.display = 'none'; });
          mount.querySelectorAll('.rvk-ddlive .rv-dropdown').forEach(function (t2) { t2.classList.remove('open'); });
          menu.style.display = openNow ? '' : 'none';
          tr.classList.toggle('open', openNow);
        });
      });
      mount.querySelectorAll('.rvk-ddlive .dd-item').forEach(function (it) {
        it.addEventListener('click', function (e) {
          e.stopPropagation();
          var wrap = it.closest('.rvk-ddlive');
          if (!wrap) return;
          wrap.querySelectorAll('.dd-item').forEach(function (o) { o.classList.toggle('sel', o === it); });
          var lb = wrap.querySelector('.dd-label');
          var lab = it.querySelector('.dd-mi-label');
          if (lb && lab) lb.textContent = lab.textContent;
          var menu = wrap.querySelector('.rv-dropdown-menu');
          if (menu) menu.style.display = 'none';
          var trg = wrap.querySelector('.rv-dropdown');
          if (trg) trg.classList.remove('open');
          var zi = it.getAttribute('data-tl-zone');
          if (zi != null) {
            var unit = wrap.closest('.rvk-ds');
            if (unit) tlApplyZone(unit, parseInt(zi, 10) || 0);
          }
        });
      });
      mount.querySelectorAll('.w-light .dd-option').forEach(function (op) {
        op.addEventListener('click', function (e) {
          e.stopPropagation();
          var w = op.closest('.w-light');
          var key = op.getAttribute('data-zonekey');
          w.querySelectorAll('.dd-option').forEach(function (o) { o.setAttribute('data-selected', o === op ? 'true' : 'false'); });
          w.querySelectorAll('.zone-body').forEach(function (b) { b.style.display = b.getAttribute('data-zonekey') === key ? 'flex' : 'none'; });
          var tr = w.querySelector('.dd-trigger');
          var txt = op.querySelector('span:last-child');
          var isWheel = !!op.querySelector('.dd-wheel-ic');
          if (tr) {
            var g = tr.querySelector('.dd-glyph');
            var tw = tr.querySelector('.dd-glyph-wheel');
            if (isWheel) {
              if (g) g.style.display = 'none';
              if (!tw && g) {
                tw = document.createElement('span');
                tw.className = 'dd-wheel-ic dd-glyph-wheel';
                tw.style.marginRight = '10px';
                g.parentNode.insertBefore(tw, g.nextSibling);
              }
              if (tw) tw.style.display = 'block';
            } else {
              if (tw) tw.style.display = 'none';
              if (g) { var oimg = op.querySelector('img'); if (oimg) g.src = oimg.src; g.style.display = ''; }
            }
            var tt = tr.querySelector('.dd-title');
            if (tt && txt) tt.textContent = txt.textContent;
          }
          var led = op.getAttribute('data-led');
          if (led) w.style.setProperty('--led-color', led);
          var dd = op.closest('.dd');
          if (dd) dd.setAttribute('data-open', 'false');
        });
      });
    }

    /* Live-Simulation: Werte driften alle 2,2 s leicht */
    function tick() {
      live.forEach(function (e2) {
        if (e2.kind === 'level') {
          e2.cur += (Math.random() - 0.5) * 0.7;
          e2.cur = Math.max(e2.base - 7, Math.min(e2.base + 5, e2.cur));
          var num = document.getElementById(e2.numId);
          if (num) num.textContent = Math.round(e2.cur);
          if (e2.lvlId) {
            var lvEl = document.getElementById(e2.lvlId);
            if (lvEl) {
              if (window.RVLottie && lvEl.__rvLottie) { try { window.RVLottie.set(lvEl, e2.cur, true); } catch (x) {} }
              else { var fill = lvEl.querySelector('.rvk-fill'); if (fill) fill.style.setProperty('--pct', Math.round(e2.cur) + '%'); }
            }
          }
        } else if (e2.kind === 'temp') {
          e2.cur += (Math.random() - 0.5) * 0.4;
          e2.cur = Math.max(e2.base - 1.6, Math.min(e2.base + 1.6, e2.cur));
          var n2 = document.getElementById(e2.numId);
          if (n2) n2.textContent = fmtTemp(e2.cur);
        } else if (e2.kind === 'battery') {
          e2.cur += (Math.random() - 0.5) * 0.9;
          e2.cur = Math.max(e2.base - 14, Math.min(Math.min(98, e2.base + 9), e2.cur));
          var volt = (12.0 + (e2.cur / 100) * 0.9);
          var watt = 70 + Math.random() * 110;
          var hrs = Math.max(0.4, (e2.cur / 100) * 4.2);
          var pn = document.getElementById(e2.pctId); if (pn) pn.textContent = Math.round(e2.cur);
          var vn = document.getElementById(e2.voltId); if (vn) vn.textContent = volt.toFixed(1).replace('.', decSep()) + ' V';
          var wn = document.getElementById(e2.wId); if (wn) wn.textContent = watt.toFixed(1).replace('.', decSep()) + ' W';
          var rn = document.getElementById(e2.restId); if (rn) rn.textContent = Math.floor(hrs) + ':' + String(Math.round((hrs % 1) * 60)).padStart(2, '0') + ' ' + t('unit_h');
          var L2 = e2.lot;
          if (L2) {
            if (L2.anim && L2.tot) { try { L2.anim.goToAndStop(Math.max(0, Math.min(L2.tot - 1, (e2.cur / 100) * (L2.tot - 1))), true); } catch (x) {} }
            else if (L2.fallback) { L2.fallback.style.setProperty('--pct', Math.round(e2.cur) + '%'); }
          }
        } else if (e2.kind === 'incl') {
          /* Nivellierung: minimales Zittern um die Basiswerte (±0,15°) — Zahl,
             Kipp-Rotation und Farbstufe laufen mit (Gain 1.5, Stufen 1.5°/3°). */
          e2.pitch = Math.max(e2.basePitch - 0.15, Math.min(e2.basePitch + 0.15, e2.pitch + (Math.random() - 0.5) * 0.08));
          e2.roll = Math.max(e2.baseRoll - 0.15, Math.min(e2.baseRoll + 0.15, e2.roll + (Math.random() - 0.5) * 0.08));
          [['p', -e2.pitch, e2.pitch], ['r', e2.roll, e2.roll]].forEach(function (ax) {
            var tilt = document.getElementById(e2.id + ax[0]);
            if (tilt) tilt.style.transform = 'rotate(' + inclGain(ax[1]) + 'deg)';
            var num = document.getElementById(e2.id + ax[0] + 'n');
            if (num) {
              num.innerHTML = inclFmt(ax[2]) + '<span class="deg">°</span>';
              num.className = 'inc-num sm ' + inclStat(ax[2]);
            }
            if (tilt) {
              var hz = tilt.querySelector('.inc-horizon');
              if (hz) hz.className = 'inc-horizon ' + inclStat(ax[1]);
            }
          });
        } else if (e2.kind === 'flow') {
          e2.cur += (Math.random() - 0.5) * e2.base * 0.12;
          e2.cur = Math.max(e2.base * 0.7, Math.min(e2.base * 1.25, e2.cur));
          var fn = document.getElementById(e2.numId);
          if (fn) fn.textContent = (e2.sign < 0 ? '−' : '+') + Math.round(e2.cur) + ' W';
        }
      });
      var ecoPct = document.getElementById('rvk-eco-pct');
      if (ecoPct) ecoPct.textContent = String(Math.max(40, Math.min(98, Math.round(76 + (Math.random() - 0.5) * 6))));
      var ecoIn = document.getElementById('rvk-eco-in');
      if (ecoIn) ecoIn.textContent = '+' + Math.round(380 + Math.random() * 70) + ' W';
      var ecoOut = document.getElementById('rvk-eco-out');
      if (ecoOut) ecoOut.textContent = '−' + Math.round(160 + Math.random() * 70) + ' W';
    }
    setInterval(tick, 2200);

    /* ════════════════════════ DS-BOTTOM-SHEET-DIALOGE ════════════════════════
       Jedes Phone-Widget ist antippbar und öffnet seinen App-DS-Dialog als
       Vanilla-Overlay (Sheet/DialogCard-Muster). Markup + CSS 1:1 aus dem
       Design-System (konfigurator-appds.css enthält bereits alle rv-sheet-/
       rv-dcard-Styles inkl. Pointer-Events-Fix für geschlossene Overlays). */
    var CLOSE_X_SVG = '<svg viewBox="0 0 40 40" width="32" height="32" fill="currentColor" aria-hidden="true"><rect x="11.5146" y="7.27197" width="30" height="6" rx="1" transform="rotate(45 11.5146 7.27197)"></rect><rect x="32.728" y="11.5146" width="30" height="6" rx="1" transform="rotate(135 32.728 11.5146)"></rect></svg>';
    var CIRCLE_ARROW_SVG = '<svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"></path><rect x="10" y="5" width="3" height="10" rx="1"></rect><rect x="17" y="12" width="3" height="7" rx="1" transform="rotate(90 17 12)"></rect></svg>';

    /* Dialog-Registry: pro Render neu befüllt, Tile trägt data-dlg="dlgN" */
    var dlgData = {}, dlgSeq = 0;
    function regDlg(fn) { var idd = 'dlg' + (dlgSeq++); dlgData[idd] = fn; return idd; }

    /* Dialog-Icon (App-DS-Pfad) mit Flat-Fallback wie die Kacheln */
    function dImg(path, style) {
      if (!path) return '';
      var src = appdsIcon(path);
      var fb = '';
      /* Unterordner-Pfade (devices/…, general/…) liegen auf R2 nicht immer vor —
         Flat-App-Icon des Basenamens als onerror-Fallback anhängen (app-icons/… ist
         der vollständige Icon-Satz). Greift z. B. bei devices/X_Device_230V_0.svg. */
      if (String(path).indexOf('/') >= 0) {
        /* Kette wie iconTag: Flat-Basename → suffix-bereinigt (…_0.svg → ….svg,
           z. B. X_Device_Heater_0 → X_Device_Heater — R2-Flat-Satz hat oft nur die
           Variante ohne Zustands-Suffix). */
        var base2 = String(path).split('/').pop();
        var chain2 = [appIcon(base2)];
        var stripped2 = base2.replace(/_\d+(\.\w+)$/, '$1');
        if (stripped2 !== base2) chain2.push(appIcon(stripped2));
        chain2 = chain2.filter(function (u) { return u && u !== src; });
        if (chain2.length) fb = ' data-fb="' + esc(chain2.join('|')) + '"';
      }
      return '<img src="' + esc(src) + '"' + fb + ' alt="" style="' + (style || '') + '">';
    }
    function dIconSpan(path, size) {
      return '<span class="rv-icon rv-icon--tint" style="width:' + (size || 48) + 'px;height:' + (size || 48) + 'px;">' + dImg(path) + '</span>';
    }
    function dDiv2() { return '<div style="height:2px;flex-shrink:0;border-radius:2px;background:var(--tile-divider);margin:12px 6px 10px;"></div>'; }
    function dDiv1(m) { return '<div style="height:1px;flex-shrink:0;background:var(--tile-divider, rgba(57,95,118,0.16));margin:' + (m || '18px 0px') + ';"></div>'; }
    function dLabel(txt) { return '<p style="font-size:14px;color:var(--text-paragraph);text-align:center;margin:0 0 6px;">' + esc(txt) + '</p>'; }
    /* Batterie-Hero für DIALOGE: die ORIGINALE Batterie-Lottie (battery.json von R2)
       mit %-Overlay — nicht mehr der CSS-Farbverlauf (der bleibt nur als Fallback,
       wenn lottie/JSON fehlen). Mounting via loadLottieInto in onMount des Sheets. */
    function dLottieBattery(pct, maxW, h, fontSize, label) {
      return '<div style="position:relative;width:100%;display:flex;align-items:center;justify-content:center;">' +
        '<div style="width:100%;max-width:' + maxW + 'px;height:' + h + 'px;" data-lot-file="' + esc(lotUrl('battery.json')) + '" data-lot-kind="battery" data-lot-pct="' + pct + '"></div>' +
        '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:' + fontSize + 'px;font-weight:700;color:#fff;letter-spacing:-.01em;">' + esc(label) + '</span></div>';
    }
    function mountDialogLotties(ov) {
      ov.querySelectorAll('[data-lot-file]:not([data-lot-done])').forEach(loadLottieInto);
    }
    function rvSegHtml(tabs, activeIdx) {
      return '<div class="rv-seg" role="tablist">' + tabs.map(function (tb, i) {
        var a = i === activeIdx;
        return '<div role="tab" aria-selected="' + a + '" class="' + (a ? 'active' : '') + '">' + esc(tb) + '</div>';
      }).join('') + '</div>';
    }
    function segRow(tabs, activeIdx) { return '<div style="padding:0 4px;">' + rvSegHtml(tabs, activeIdx) + '</div>'; }
    function sliderRow(pct, cls) {
      return '<div style="padding:0 4px 4px;"><div class="rv-slider ' + (cls || 'off') + '" role="slider" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100"><div class="fill" style="width:' + pct + '%;"></div><div class="thumb" style="left:' + pct + '%;"></div></div></div>';
    }
    function ddRow(label, iconPath) {
      var lead = iconPath
        ? '<span class="dd-lead has-icon">' + dIconSpan(iconPath, 30) + '</span>'
        : '<span class="dd-lead"></span>';
      return '<div style="padding:0 4px;"><div class="rv-dropdown-wrap "><div class="rv-dropdown" role="button" aria-haspopup="listbox" aria-expanded="false">' +
        lead + '<span class="dd-label">' + esc(label) + '</span>' +
        '<span class="dd-chev">' + chevSvg(90) + '</span></div></div></div>';
    }
    /* generische DialogCard-Zeile (opts.body = Inhalt INNERHALB der weißen Card,
       unter der Kopfzeile — DS-DialogCard-`children`, z. B. die TwoWay-Wanne) */
    function dcard(iconHtml, name, opts) {
      opts = opts || {};
      var val = opts.value != null ? '<div class="rv-dcard-value">' + opts.value + '</div>' : '';
      var sub = opts.sub != null ? '<div class="rv-dcard-sub" style="justify-content:center;margin-top:2px;">' + opts.sub + '</div>' : '';
      var ctrl = opts.control || '';
      var footer = opts.footer ? '<div class="rv-dcard-sub">' + opts.footer + '</div>' : '';
      var bodyInner = opts.body || '';
      var nameBlock = '<div style="flex:1 1 0%;text-align:center;overflow:hidden;"><div class="rv-dcard-name">' + esc(name) + '</div>' + sub + '</div>';
      return '<div class="rv-dcard ' + (opts.flat ? 'flat' : '') + '"><div class="rv-dcard-row">' + (iconHtml || '') + nameBlock + val + ctrl + '</div>' + footer + bodyInner + '</div>';
    }
    /* Timer-Block (App-DS): Kopf + 3-Spalten-Rad */
    function dTimerBlock() {
      function col(items, selIdx) {
        var s = '<div class="tw-col"><div style="height:45px;"></div>';
        items.forEach(function (it, i) { s += '<div class="tw-item' + (i === selIdx ? ' sel' : '') + '">' + esc(it) + '</div>'; });
        return s + '<div style="height:45px;"></div></div>';
      }
      var hours = [], mins = [], i;
      for (i = 0; i < 24; i++) hours.push(i + ' ' + t('timer_hours_unit'));
      for (i = 0; i < 60; i++) mins.push(i + ' ' + t('timer_min_unit'));
      return '<div><div class="tm-head">' +
        '<span class="rv-icon rv-icon--tint" style="width:38px;height:38px;filter:brightness(0);">' + dImg('utility/X_Utility_Timer_0.svg') + '</span>' +
        '<div class="tm-head-mid"><div class="tm-head-title">' + esc(t('w_timer')) + '</div><div class="tm-head-time">00:20</div></div>' +
        '<button class="tm-start" type="button">START</button></div>' +
        '<div class="rv-timerpick">' + col([t('timer_off_in'), t('timer_on_in')], 0) + '<span class="tw-div"></span>' +
        col(hours, 0) + '<span class="tw-div"></span>' + col(mins, 20) + '</div></div>';
    }
    /* Klima-Dialogkopf + großer Dial */
    function climateHead(title, caption, onState) {
      return '<div style="padding:2px 4px 4px;"><div style="display:flex;align-items:center;gap:12px;">' +
        '<span style="flex:1 1 0%;min-width:0;font-size:17px;font-weight:500;color:var(--text-heading);text-align:left;">' + esc(title) + '</span>' +
        rvSwitch(onState !== false) + '</div>' +
        (caption ? '<div class="cc-caption" style="font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--brand);text-align:center;padding:2px 0;">' + esc(caption) + '</div>' : '') +
        '</div>';
    }
    /* Nackter Dial (.rv-climate) — geteilt von Kachel, Dialog und Stage.
       min/max optional: Regelbereich des Geräts (Autoterm 0–30, Webasto 5–35,
       Timberline 5–30) — die Pfeil-Handler lesen data-min/-max; ohne Angabe
       gilt das Truma-Fenster 15–30 (Bestand). */
    function climDialInner(p, temp, ist, min, max) {
      var rangeAttrs = (min != null && max != null) ? ' data-min="' + min + '" data-max="' + max + '"' : '';
      return '<div class="rv-climate fluid interactive"' + rangeAttrs + ' style="--p:' + p + ';">' +
        '<div class="cc-glow"></div><div class="cc-ring"></div>' +
        '<span class="cc-rot cc-thumbrot" style="--a:calc(var(--cc-start) + var(--cc-sweep) * var(--p));"><span class="cc-thumb"></span></span>' +
        '<div class="cc-center"><span class="cc-arrow up">' + chevSvg(-90) + '</span>' +
        '<div class="cc-temp">' + temp + '<span class="unit">°</span></div>' +
        (ist != null ? '<div class="cc-ist">' + esc(t('w_ist', { temp: ist })) + '</div>' : '') +
        '<span class="cc-arrow down">' + chevSvg(90) + '</span></div></div>';
    }
    function climateDial(p, temp, ist) {
      return '<div style="display:flex;justify-content:center;padding:0;margin-bottom:-22px;">' + climDialInner(p, temp, ist) + '</div>';
    }
    /* Fan-Rad (Lüften-Ansicht wie DS EbFan/AvFan/FanView) — dreht bei on, grau statisch bei off */
    function climFanWheel(on, size) {
      return '<span class="fj-fan' + (on ? ' spin' : ' off') + '" style="width:' + size + 'px;height:' + size + 'px;">' +
        '<span class="rv-icon rv-icon--tint" style="width:100%;height:100%;display:block;">' + dImg('devices/X_Device_Fan_0.svg') + '</span></span>';
    }
    /* Lüften-Block: Rad + optional Intensitäts-Label/Slider + optional Ist-Temperatur.
       fan = { on, size, ist, intensity, label, slider, val } */
    function climFanBlock(fan, big) {
      var size = fan.size || (big ? 150 : 132);
      var s = '<div style="display:flex;flex-direction:column;align-items:center;gap:' + (big ? 10 : 8) + 'px;width:100%;padding:' + (big ? '14px 0 4px' : '0') + ';">' + climFanWheel(fan.on !== false, size);
      if (fan.intensity) {
        s += '<div style="font-size:14px;color:var(--text-paragraph);margin-top:6px;">' + esc(t('dlg_fan_intensity')) + '</div>' +
          '<div style="font-size:18px;font-weight:600;color:var(--text-heading);">' + esc(fan.label || t('fan_medium')) + '</div>';
        if (fan.slider) s += '<div style="width:86%;">' + sliderRow(fan.val != null ? fan.val : 33, 'on') + '</div>';
      }
      if (fan.ist != null) s += '<div style="font-size:14px;color:var(--text-paragraph);margin-top:' + (fan.intensity ? 2 : 12) + 'px;">' + esc(t('w_ist_temp', { temp: fan.ist })) + '</div>';
      return s + '</div>';
    }
    /* Segment-Leiste; Tabs tragen data-view (dial|fan) + data-cap (Status-Text) →
       bindSheetControls schaltet im Popup Dial↔Fan um und aktualisiert die Statuszeile. */
    function climSegHtml(views, activeIdx) {
      return '<div class="rv-seg" role="tablist">' + views.map(function (v, i) {
        var a = i === activeIdx;
        return '<div role="tab" aria-selected="' + a + '" class="' + (a ? 'active' : '') + '"' +
          (v.view ? ' data-view="' + esc(v.view) + '"' : '') +
          (v.cap != null ? ' data-cap="' + esc(v.cap) + '"' : '') + '>' + esc(v.label) + '</div>';
      }).join('') + '</div>';
    }
    /* Climate-Stage: hält Dial + (optional) Fan; sichtbar je nach initView.
       flex=true → Kachel (füllt den mittleren Bereich); sonst Dialog (zentriert). */
    function climStage(dialHtml, fan, initView, opts) {
      opts = opts || {};
      var isFan = initView === 'fan';
      var wrap = opts.flex
        ? 'flex:1 1 0%;display:flex;align-items:center;justify-content:center;min-height:0px;'
        : 'display:flex;justify-content:center;';
      var cell = 'width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;';
      var s = '<div class="rv-clim-stage" style="' + wrap + '">' +
        '<div class="cs-dial" style="' + cell + (opts.dialStyle || '') + (isFan ? 'display:none;' : '') + '">' + dialHtml + '</div>';
      if (fan) s += '<div class="cs-fan" style="' + cell + (isFan ? '' : 'display:none;') + '">' + climFanBlock(fan, opts.big) + '</div>';
      return s + '</div>';
    }
    /* Energiefluss-Markup (tile|dialog) — gemeinsam für Kachel + Dialog.
       unit 'W' (Default) oder 'A' (VE.Direct-Dialog, W⇄A-Umschalter); total
       optional vorgegeben (VE: das batterie-artige Gerät trägt das Total,
       NICHT die Kanal-Summe — sonst doppelt gezählt). */
    function efInner(chs, variant, unit, totalOverride) {
      unit = unit || 'W';
      var net = totalOverride != null ? totalOverride
        : chs.reduce(function (s, c) { return s + (c.load ? c.load.reduce(function (a, x) { return a + x.value; }, 0) : (c.value || 0)); }, 0);
      var accent = net > 0 ? 'var(--success)' : net < 0 ? 'var(--cold)' : 'var(--mid-grey)';
      var badgeCls = net < 0 ? 'neg' : net > 0 ? 'pos' : 'idle';
      return '<div class="rv-energyflow ' + variant + '" data-ef="' + encodeURIComponent(JSON.stringify(chs)) + '" data-efunit="' + esc(unit) + '">' +
        '<div class="ef-badge ' + badgeCls + '" style="--accent:' + accent + ';">' +
        '<img class="ef-flash" src="' + esc(appdsIcon('battery/X_Energy_Flash_0.svg')) + '" alt="">' +
        '<span class="ef-total">' + net + ' ' + esc(unit) + '</span><span class="ef-total-lbl">' + esc(t('w_total_consumption')) + '</span></div>' +
        '<div class="ef-stage"></div></div>';
    }

    /* ── Dialog-Builder (liefern {title, action, body, onMount}) ── */
    function buildSwitchDialog(caps, title) {
      var timerAction = '<span class="rv-icon rv-icon--tint" style="width:40px;height:40px;filter:brightness(0);">' + dImg('utility/X_Utility_Timer_0.svg') + '</span>';
      var body = caps.map(function (c) {
        var sub = c.on
          ? '<span style="color:var(--text-paragraph);">15,0 W&nbsp;&nbsp; 12,5 V&nbsp;&nbsp; 1,2 A</span>'
          : '<span style="color:var(--text-paragraph);">0,0 W&nbsp;&nbsp; 12,5 V&nbsp;&nbsp; 0,0 A</span>';
        return '<div class="rv-sortable">' + dcard(
          '<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;">' + iconTag(c.icon, '', 'X_TwoWay_Vent') + '</span>',
          c.label,
          { sub: sub, control: rvSwitch(!!c.on), footer: CIRCLE_ARROW_SVG + ' ' + esc(t('dlg_timer_set')) }
        ) + '</div>';
      }).join('');
      return { title: title || t('dlg_devices'), action: timerAction, body: body };
    }
    function buildTempDialog(caps) {
      var body = caps.map(function (c) {
        return dcard(
          '<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;">' + iconTag(c.icon, '', 'X_Temp_Inside_0') + '</span>',
          c.label, { value: '<span>' + fmtTemp(c.value) + '&nbsp;°C</span>' }
        );
      }).join('');
      return { title: t('dlg_temperature'), body: body };
    }
    function buildLevelDialog(caps) {
      var body = caps.map(function (c) {
        var vis = '<span class="rv-icon" style="width:58px;height:46px;display:flex;align-items:center;justify-content:center;flex:none;">' +
          levelLottieHtml(c.kind || 'frisch', c.pct, 'width:58px;height:44px;display:block;', false, c.icon || 'X_Level_Fresh_0') + '</span>';
        return dcard(vis, c.label, { value: '<span>' + Math.round(c.pct) + '&nbsp;%</span>' });
      }).join('');
      return {
        title: t('dlg_levels'), body: body,
        onMount: function (ov) { mountLevelLotties(ov, false); }
      };
    }
    /* EIN Popup für ALLE gewählten Bewegung-Caps: je Cap eine weiße DialogCard
       (untereinander gestapelt) mit der horizontalen TwoWay-Wanne INNERHALB der
       Card (DS reg.twoway.Dialog: twShown(model).map → DialogCard > TwoWayToggle). */
    function buildTwoWayDialog(caps) {
      var body = caps.map(function (c) {
        var twt = '<div style="padding:12px 16px 2px;"><div class="rv-twt horizontal dialog">' +
          '<button type="button" class="twt-btn schalter" aria-pressed="false"><svg class="twt-chev" viewBox="11.5 5.85 18 28" aria-hidden="true" style="transform:rotate(180deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg><span class="twt-word">' + esc(c.twL) + '</span></button>' +
          '<button type="button" class="twt-btn schalter" aria-pressed="false"><svg class="twt-chev" viewBox="11.5 5.85 18 28" aria-hidden="true" style="transform:rotate(0deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg><span class="twt-word">' + esc(c.twR) + '</span></button>' +
          '</div></div>';
        return dcard('<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;">' + iconTag(c.icon, '', 'X_TwoWay_Valve') + '</span>', c.label, { body: twt });
      }).join('');
      return { title: t('dlg_twoway'), body: body };
    }
    function buildThitronikDialog() {
      var body =
        dcard(dIconSpan('utility/X_Utility_Siren_1.svg'), t('th_alarm'), { control: rvSwitch(true) }) +
        dcard(dIconSpan('utility/X_Utility_Lock_1.svg'), t('th_doors'), { control: rvSwitch(true) }) +
        dDiv1('16px 0px') +
        '<p style="font-size:14px;color:var(--text-paragraph);text-align:center;margin:4px 0 8px;">' + esc(t('th_last_alarm', { door: t('th_driver_door') })) + '</p>' +
        dcard(dIconSpan('general/X_Icon_WindowOpen.svg'), t('th_driver_door'), { value: '<span style="color:var(--apored);font-size:12px;font-weight:600;letter-spacing:.05em;">' + esc(t('th_open')) + '</span>' }) +
        dcard(dIconSpan('general/X_Icon_Check_0.svg'), t('th_pass_door'), { value: '<span style="color:var(--light-grey);font-size:12px;font-weight:600;letter-spacing:.05em;">' + esc(t('th_closed')) + '</span>' }) +
        dcard(dIconSpan('general/X_Icon_Check_0.svg'), t('th_roof_window'), { value: '<span style="color:var(--light-grey);font-size:12px;font-weight:600;letter-spacing:.05em;">' + esc(t('th_closed')) + '</span>' });
      return { title: t('dlg_thitronik'), body: body };
    }
    function buildFridgeDialog(auto, title) {
      var stepper = '<div style="display:flex;flex-direction:column;align-items:center;gap:6px;padding:14px 0 2px;">' +
        '<div style="display:flex;flex-direction:row;align-items:center;justify-content:center;gap:16px;">' +
        '<svg viewBox="11.5 5.85 18 28" role="button" aria-label="' + esc(t('a11y_cooler')) + '" style="height:30px;width:auto;flex-shrink:0;cursor:pointer;color:var(--brand);transform:rotate(180deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg>' +
        '<span style="font-size:38px;font-weight:700;line-height:1;color:var(--text-heading);min-width:64.6px;text-align:center;">5°</span>' +
        '<svg viewBox="11.5 5.85 18 28" role="button" aria-label="' + esc(t('a11y_warmer')) + '" style="height:30px;width:auto;flex-shrink:0;cursor:pointer;color:var(--apored);transform:rotate(0deg);"><path d="' + CHEV_PATH + '" fill="currentColor"></path></svg>' +
        '</div><div style="font-size:14px;font-weight:700;letter-spacing:.05em;color:var(--text-heading);">' + esc(t('w_ist_upper', { temp: 15 })) + '</div></div>';
      var body =
        dcard(dIconSpan('devices/X_Device_MiniBar_0.svg'), t('w_fridge_name'), { control: rvSwitch(true), flat: true }) +
        dDiv1('0px 10px') + stepper +
        dLabel(t('dlg_cool_mode')) + segRow([t('seg_stufen'), t('seg_auto')], auto ? 1 : 0) +
        '<div style="display:flex;justify-content:center;padding:16px 0 0;">' + dIconSpan('X_Device_230V_0.svg', 64) + '</div>' +
        dLabel(t('dlg_energy_choice')) + ddRow(t('dd_auto')) +
        dcard('<span class="rv-icon rv-icon--tint" style="width:48px;height:48px;">' + dImg('general/X_Icon_Cold.svg') + '</span>', t('fridge_icemaker'), { control: rvSwitch(true), flat: true }) +
        dcard(dIconSpan('X_Device_Fan_0.svg'), t('fridge_fan'), { control: rvSwitch(true), flat: true });
      return { title: title || t('w_fridge_name'), subtitle: t('fridge_sub_both'), body: body };
    }
    function climFan() {
      return '<div style="text-align:center;margin:0 0 2px;"><span style="display:block;font-size:14px;color:var(--text-paragraph);">' + esc(t('dlg_fan_intensity')) + '</span><span style="font-weight:600;color:var(--text-heading);font-size:19px;">' + esc(t('fan_medium')) + '</span></div>' + sliderRow(33);
    }
    function climHeatExtras(o) {
      var s = '';
      if (o.boiler) s += dDiv2() + dLabel(t('dlg_boiler')) + dcard(dIconSpan('temp/X_Temp_Water_0.svg'), '60°C', { control: rvSwitch(true), flat: true }) + segRow([t('seg_eco'), t('seg_hot')], 1);
      s += dDiv2() + dLabel(t('dlg_energy_src')) + ddRow(o.energy || 'Diesel');
      s += '<div style="height:12px;"></div>' + dLabel(t('dlg_powerlimit')) + segRow(['900W', '1800W'], 0);
      return s;
    }
    function climCoolExtras(o) {
      var s = dDiv2() + dcard('', t('dlg_klima_auto'), { control: rvSwitch(true), flat: true });
      s += dDiv2() + climFan();
      if (o.light) s += dDiv2() + dLabel(t('dlg_lighting')) + dcard(dIconSpan('lights/C_Light_Inside_0.svg'), t('dlg_interior_light'), { control: rvSwitch(false), flat: true }) + sliderRow(78);
      return s;
    }
    /* Dialog-Stage mit Dial↔Fan-Umschaltung (Popup). big=true (großer Dial/Fan). */
    function climDialogStage(o) {
      return climStage(climDialInner(o.p, o.temp, o.ist), o.fan, o.initView, { big: true, dialStyle: 'margin-bottom:-22px;' });
    }
    /* Alde-Dialogkörper (DS reg.alde): Zone-Dial + Wasserboiler + Energie
       (Gas-Schalter, Gas/Elektro, Strombegrenzung). withHead=false → ohne Kopf/Dial
       (für den Alde-Block innerhalb des kombinierten Aventa-Dialogs). */
    /* Maximalkonfiguration wie DS reg.alde (Jasper, 13.10.2026): zwei Heizzonen mit
       „Heizzone:“-Leiste + Ist der gewählten Zone, Warmwasser im Boost („30 Min Prio“),
       Energie Gas + Elektro mit 3 kW Strombegrenzung. Timer hängt buildClimateDialog an. */
    function aldeBody(o, withHead) {
      var zone1 = t('alde_zone_n', { n: 1 });
      var bigVal = function (v, cap) {
        return '<div style="text-align:center;margin:10px 0 2px;">' +
          '<span style="font-weight:600;color:var(--text-heading);font-size:20px;">' + esc(v) + '</span>' +
          '<span style="display:block;font-size:12px;color:var(--text-paragraph);margin-top:1px;">' + esc(cap) + '</span></div>';
      };
      var s = withHead === false ? '' : (climateHead(o.title, o.caption) + climateDial(o.p, o.temp, o.ist));
      s += dDiv2() + dLabel(t('dlg_zone')) +
        segRow([zone1, t('zone_both'), t('alde_zone_n', { n: 2 })], 0) +
        bigVal((o.ist != null ? o.ist : 21) + '°', t('alde_ist_zone', { zone: zone1 })) +
        dDiv2() + dLabel(t('dlg_boiler')) +
        dcard(dIconSpan('temp/X_Temp_Water_0.svg'), t('dlg_warmwater'), { sub: esc(t('alde_boost_prio')), control: rvSwitch(true), flat: true }) +
        segRow([t('boiler_normal'), t('boiler_boost'), t('boiler_auto')], 1) +
        dDiv2() + dLabel(t('dlg_energy_src')) +
        dcard(dIconSpan('utility/X_Utility_Gas_0.svg'), t('alde_gas_switch'), { control: rvSwitch(true), flat: true }) +
        '<div style="margin-top:8px;">' + segRow([t('energy_gas'), t('energy_elektro')], 1) + '</div>' +
        bigVal('3 kW', t('alde_limit_cap')) + sliderRow(100, 'on');
      return s;
    }
    /* Aventa-Klimablock (DS reg.truma_cpplus Aventa-Teil): Dial mit Ist,
       Klima-Automatik, Lüfter-Intensität, Innenlicht. */
    function aventaBody(withHead) {
      var head = withHead === false ? '' : (climateHead('Aventa Comfort', t('w_klima_running')) + climateDial(0.667, 26, 15));
      return head +
        dDiv2() + dcard('', t('dlg_klima_auto'), { control: rvSwitch(true), flat: true }) +
        dDiv2() + climFan() +
        dDiv2() + dLabel(t('dlg_lighting')) +
        dcard(dIconSpan('lights/C_Light_Inside_0.svg'), t('dlg_interior_light'), { control: rvSwitch(false), flat: true }) + sliderRow(78);
    }
    function buildClimateDialog(o) {
      var body;
      if (o.mode === 'eber') {
        // Eberspächer Airtronic 3 (DS reg.heater_eberspaecher): Heizen/Lüften-Heizung.
        // Modus-Segment über dem Dial, Statuszeile im Kopf, Energie = NUR Eco-Modus.
        // KEIN Kühlen, KEIN Boiler/Warmwasser, KEINE Energiequelle/Strombegrenzung.
        body = '<div class="rv-clim-unit">' +
          climateHead(o.title, o.caption) +
          dDiv2() + dLabel(t('dlg_mode')) +
          '<div style="padding:0 4px;">' + climSegHtml(o.segViews, o.active || 0) + '</div>' +
          climDialogStage(o) +
          '</div>' +
          dDiv2() + dLabel(t('dlg_energy')) +
          dcard(dIconSpan('climate/X_Klima_Eco.svg'), t('dlg_eco_mode'), { control: rvSwitch(true), flat: true });
      } else if (o.mode === 'freshjet') {
        // Dometic FreshJet (DS reg.dometic_freshjet.Dialog): Dial + Modus-Dropdown
        // (5 Modi), Lüfter-Automatik + Intensität, Außen-/Innenlicht + Helligkeit,
        // Nacht-Modus. KEINE generische „Klima-Automatik".
        body = '<div class="rv-clim-unit">' +
          climateHead(o.title, o.caption) + climDialogStage(o) + '</div>' +
          dDiv2() + dLabel(t('dlg_mode')) +
          '<div style="display:flex;align-items:center;gap:12px;margin-bottom:10px;padding:0 4px;">' +
          dIconSpan('devices/X_Device_AirConditioning-1_0.svg', 34) +
          '<span style="flex:1 1 0%;font-size:18px;font-weight:600;color:var(--text-heading);text-align:center;">' + esc(t('dlg_climate_mode')) + '</span></div>' +
          ddRow(t('seg_cool')) +
          dDiv2() + dLabel(t('dlg_fan')) +
          dcard(dIconSpan('devices/X_Device_Fan_0.svg'), t('dlg_fan_auto'), { sub: esc(t('fan_medium')), control: rvSwitch(false), flat: true }) +
          sliderRow(33, 'on') +
          dDiv2() + dLabel(t('dlg_lighting')) +
          dcard(dIconSpan('lights/C_Light_Outside_0.svg'), t('dlg_exterior_light'), { control: rvSwitch(false), flat: true }) +
          dcard(dIconSpan('lights/C_Light_Inside_0.svg'), t('dlg_interior_light'), { control: rvSwitch(true), flat: true }) +
          sliderRow(50, 'on') +
          dDiv2() +
          dcard(dIconSpan('utility/X_Utility_Moon_0.svg'), t('dlg_night_mode'), { control: rvSwitch(false), flat: true });
      } else if (o.mode === 'alde') {
        body = aldeBody(o, true);
      } else if (o.mode === 'combined') {
        var trumaLogo = '<div style="display:flex;justify-content:center;padding:14px 0 8px;">' +
          '<span class="rv-icon rv-icon--raw" style="height:38px;width:auto;display:inline-flex;">' + dImg('utility/X_Logo_Truma.svg', 'height:38px;width:auto;') + '</span></div>';
        if (o.host === 'alde') {
          // Alde + Truma Aventa (DS reg.alde mit aventa): Alde-Block + Klima-Automatik.
          body = aldeBody(o, true) +
            dDiv2() + dLabel(t('dlg_klima_auto') + ':') +
            dcard(dIconSpan('devices/X_Device_AirConditioning-2_0.svg'), t('dlg_klima_auto'), { control: rvSwitch(true), flat: true });
        } else {
          // Truma CP+ mit Combi + Aventa (DS reg.truma_cpplus, devices='beide'):
          // ZWEI Geräteblöcke — je Name/Schalter/Status + eigener Regler, getrennt
          // durch das Truma-Logo. Combi (Heizung, Diesel + Boiler + Strombegrenzung),
          // Aventa (Klima, Klima-Automatik + Lüfter + Innenlicht).
          var combiBlock = climateHead('Combi Gas D 6 E', t('w_heating_running')) + climateDial(0.68, 22, null) +
            dDiv2() + dLabel(t('dlg_boiler')) +
            dcard(dIconSpan('temp/X_Temp_Water_0.svg'), '60°C', { control: rvSwitch(true), flat: true }) +
            segRow([t('seg_eco'), t('seg_hot')], 1) +
            dDiv2() + dLabel(t('dlg_energy_src')) + ddRow(o.energy || 'Diesel') +
            '<div style="height:12px;"></div>' + dLabel(t('dlg_powerlimit')) + segRow(['900W', '1800W'], 0);
          body = combiBlock + trumaLogo + aventaBody(true);
        }
      } else if (o.mode === 'cool') {
        body = climateHead(o.title, o.caption) + climateDial(o.p, o.temp, o.ist) + climCoolExtras(o);
      } else {
        body = climateHead(o.title, o.caption) + climateDial(o.p, o.temp, o.ist) + climHeatExtras(o);
      }
      body += dDiv2() + dTimerBlock();
      // Alde: Logo statt Titel in der Kopfzeile (DS reg.alde dialogLogo)
      var aldeLogo = (o.mode === 'alde' || (o.mode === 'combined' && o.host === 'alde'))
        ? '<img src="' + esc(appdsIcon('utility/X_Logo_Alde.svg')) + '" alt="Alde" style="height:30px;width:auto;">' : null;
      return { title: o.title, logo: aldeLogo || undefined, body: body };
    }
    function ecNodeBatteryBody() {
      var stats = [
        ['9,37 A', t('stat_current')], ['12,6 V', t('stat_voltage')],
        ['118,1 W', t('w_power')], ['2 ' + t('unit_h') + ' 0 ' + t('unit_min'), t('w_resttime')]
      ];
      var statCol = function (a, b) {
        return '<div style="display:flex;flex-direction:column;gap:12px;">' +
          '<div style="text-align:center;"><div style="font-size:16px;font-weight:600;color:var(--text);">' + esc(a[0]) + '</div><div style="font-size:13px;color:var(--text-paragraph);">' + esc(a[1]) + '</div></div>' +
          '<div style="text-align:center;"><div style="font-size:16px;font-weight:600;color:var(--text);">' + esc(b[0]) + '</div><div style="font-size:13px;color:var(--text-paragraph);">' + esc(b[1]) + '</div></div></div>';
      };
      var body = '<div class="rv-dcard" style="padding:8px 12px 16px;margin:0 4px 12px;"><div style="text-align:center;font-size:16px;font-weight:500;color:var(--text-heading);padding:12px 0;">' + esc(t('dlg_house_battery')) + '</div>' +
        dLottieBattery(51, 200, 84, 34, '51 %') +
        '<p style="font-size:14px;color:var(--text-paragraph);text-align:center;margin:6px 0 10px;">' + esc(t('w_batdata')) + '</p>' +
        '<div style="display:flex;justify-content:space-evenly;">' + statCol(stats[0], stats[1]) + statCol(stats[2], stats[3]) + '</div>' +
        dDiv1('14px 0') + '<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:center;"><span class="rv-chip muted">' + esc(t('dlg_chip_house')) + ' 9,4 A</span><span class="rv-chip muted">' + esc(t('ch_solar')) + ' 4,1 A</span><span class="rv-chip muted">' + esc(t('ch_mains')) + ' 3,8 A</span></div>' +
        dDiv1() +
        '<div style="display:flex;justify-content:space-between;padding:8px 2px;font-size:13px;color:var(--text-paragraph);"><span>' + esc(t('node_temp')) + '</span><span style="color:var(--text);">24 °C</span></div>' +
        '<div style="display:flex;justify-content:space-between;padding:8px 2px;font-size:13px;color:var(--text-paragraph);"><span>' + esc(t('charge_cycles')) + '</span><span style="color:var(--text);">142</span></div>' +
        '<div style="display:flex;justify-content:space-between;padding:8px 2px;font-size:13px;color:var(--text-paragraph);"><span>' + esc(t('energy_total')) + '</span><span style="color:var(--text);">318 kWh</span></div>' + '</div>';
      return body;
    }
    function buildEnergyDialog(chs) { return buildEnergyOverview(); }
    function ecEcoflowBody(title) {
      var consumer = function (onState, label) {
        return '<div style="display:flex;flex-direction:column;gap:4px;"><div style="display:flex;align-items:center;gap:12px;">' + dIconSpan('battery/X_Energy_Flash_0.svg') + rvSwitch(onState) + '</div>' +
          '<span style="font-size:22px;font-weight:700;color:var(--mid-grey);line-height:1;">' + esc(label) + '</span></div>';
      };
      var stat = function (v, l) {
        return '<div style="text-align:center;"><div style="font-size:18px;font-weight:700;color:var(--text-heading);white-space:nowrap;">' + esc(v) + '</div><div style="font-size:13px;color:var(--text-paragraph);">' + esc(l) + '</div></div>';
      };
      var body = '<div class="rv-dcard" style="padding:12px 14px 16px;margin:0 4px 12px;">' +
        '<div style="text-align:center;font-size:17px;font-weight:500;color:var(--text-heading);padding:2px 0 8px;">' + esc(title || 'EcoFlow') + '</div>' +
        dLottieBattery(76, 220, 92, 40, '76%') +
        dLabel(t('w_batdata')) +
        '<div style="display:flex;justify-content:space-evenly;width:100%;">' + stat('1 T 4 Std', t('w_resttime')) + stat('412 W', t('w_power')) + '</div>' +
        dLabel(t('w_consumers')) +
        '<div style="display:flex;justify-content:space-evenly;width:100%;">' + consumer(true, '12V') + consumer(false, '230V') + '</div>' +
        '</div>';
      return body;
    }

    /* ═══ GEMEINSAMER ENERGIE-DIALOG (Jasper 02.09.2026) ═══════════════════
       Egal welches Energie-Widget der Kunde antippt — NODE Battery, CAN-BMS-
       Batterie, EcoFlow, ein Victron-Gerät oder der Energiefluss — es öffnet
       sich EIN Popup „Energie": oben W⇄A-Umschalter + Energiefluss des Systems,
       darunter die weißen Karten ALLER gewählten Quellen untereinander — erst
       „Batterien" (NODE Battery, CAN-BMS, EcoFlow, SmartShunt/BMV), dann
       „Geräte" (MPPT, Orion, Charger, Inverter). Die alten build*Dialog-
       Funktionen sind dünne Wrapper hierauf, damit kein regDlg-Aufrufer
       angefasst werden musste; ihre Karten liegen in ec*Body() / ecVeParts().
       Fluss-Regel: Systemfluss (energyChannels), sobald er Kanäle hat. Hat er
       keine und EcoFlow ist aktiv, zeigt der Kopf EcoFlows eigene Seed-Kanäle
       — ohne W⇄A, die kennen keine Ampere. */
    function ecActiveSources() {
      var plan = { kind: null, bms: null };
      try { plan = E.batteryPlan(CAT, state); } catch (e) {}
      var s = vedSel();
      var anyVed = !!(s.ved_shunt || s.ved_mppt || s.ved_orion || s.ved_charger || s.ved_inverter);
      var canbms = (plan.kind === 'bms' && plan.bms && plan.bms.cap === 'canbms') ? plan.bms : null;
      /* EcoFlow: als Integration ODER als BMS-Batterie (PowerKit) — nie doppelt,
         dieselbe Regel wie in der Kachel-Komposition (1 System / Fahrzeug). */
      var eco = null;
      byBereich('integration').forEach(function (i) { if (!eco && i.cap === 'ecoflow' && on(i.id)) eco = i.label; });
      if (!eco && plan.kind === 'bms' && plan.bms && plan.bms.cap !== 'canbms') eco = plan.bms.label;
      return { nodeBattery: plan.kind === 'battery' || plan.kind === 'hc', canbms: canbms, eco: eco, anyVed: anyVed };
    }
    function ecUnitToggle() {
      return '<div style="display:flex;justify-content:center;padding:0 0 10px;">' +
        '<div id="rvk-ved-unit" style="display:inline-flex;gap:2px;padding:2px;border-radius:999px;border:2px solid var(--light-grey);">' +
        '<span data-vedunit="W" style="font-size:12.5px;font-weight:700;color:var(--brand);padding:3px 14px;border-radius:999px;background:color-mix(in srgb, var(--brand) 16%, transparent);cursor:pointer;">W</span>' +
        '<span data-vedunit="A" style="font-size:12.5px;font-weight:400;color:var(--mid-grey);padding:3px 14px;border-radius:999px;background:transparent;cursor:pointer;">A</span>' +
        '</div></div>';
    }
    function buildEnergyOverview() {
      var src = ecActiveSources();
      var flow = energyChannels('W');
      var systemFlow = flow.chs.length > 0;
      var flowChs = systemFlow ? flow.chs : (src.eco ? efEcoChannels() : []);
      var body = '';
      if (flowChs.length) {
        body += (systemFlow ? ecUnitToggle() : '') +
          '<div id="rvk-ved-flow">' + efInner(flowChs, 'dialog', 'W', (systemFlow && flow.total != null) ? flow.total : undefined) + '</div>';
      }
      var ve = src.anyVed ? ecVeParts() : { battery: '', devices: '' };
      var batteries = '';
      if (src.nodeBattery) batteries += ecNodeBatteryBody();
      if (src.canbms) batteries += ecCanBmsBody(src.canbms);
      if (src.eco) batteries += ecEcoflowBody(src.eco);
      batteries += ve.battery;
      if (batteries) body += (body ? dDiv2() : '') + dLabel(t('dlg_batteries')) + batteries;
      if (ve.devices) body += dDiv2() + dLabel(t('ved_sec_devices')) + ve.devices;
      return {
        title: t('dlg_energy'), body: body,
        onMount: function (ov) {
          initEnergyFlows(ov);
          mountDialogLotties(ov);
          /* W⇄A: Systemfluss mit umgerechneten Kanälen neu aufbauen (DS: Ampere
             roh mit 1 Nachkommastelle, Watt ganzzahlig; nur der Dialog schaltet um) */
          var wrap = ov.querySelector('#rvk-ved-unit');
          if (!wrap) return;
          wrap.addEventListener('click', function (e3) {
            var u = e3.target.closest('[data-vedunit]');
            if (!u) return;
            e3.stopPropagation();
            var unit = u.getAttribute('data-vedunit');
            wrap.querySelectorAll('[data-vedunit]').forEach(function (sp) {
              var a = sp === u;
              sp.style.fontWeight = a ? '700' : '400';
              sp.style.color = a ? 'var(--brand)' : 'var(--mid-grey)';
              sp.style.background = a ? 'color-mix(in srgb, var(--brand) 16%, transparent)' : 'transparent';
            });
            var f2 = energyChannels(unit);
            var slot = ov.querySelector('#rvk-ved-flow');
            if (slot) { slot.innerHTML = efInner(f2.chs, 'dialog', unit, f2.total == null ? undefined : f2.total); initEnergyFlows(slot); }
          });
        }
      };
    }
    /* Wrapper — jede Energie-Kachel landet im selben Popup */
    function buildBatteryDialog() { return buildEnergyOverview(); }
    function buildEcoflowDialog(chs, title) { return buildEnergyOverview(); }
    function buildCanBmsDialog(bmsItem) { return buildEnergyOverview(); }
    function buildVeDialog() { return buildEnergyOverview(); }
    function buildLightDialog(zones) {
      var vslider = function (pct, label, cls) {
        return '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;flex:0 0 auto;width:50px;"><div style="position:relative;width:50px;height:180px;"><div style="position:absolute;top:50%;left:50%;width:180px;transform:translate(-50%,-50%) rotate(-90deg);"><div class="rv-slider ' + (cls || 'interactive') + '" role="slider" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100"><div class="fill" style="width:' + pct + '%;"></div><div class="thumb" style="left:' + pct + '%;"></div></div></div></div><div style="font-size:12px;color:var(--text-paragraph);text-align:center;">' + esc(label) + '</div></div>';
      };
      var wheel = function (on, hue) {
        var glow = on ? 'rgb(110,245,252) 0px 0px 10px 4px' : '0 0 10px 4px var(--light-grey)';
        return '<div style="flex:1 1 0%;display:flex;flex-direction:column;align-items:center;gap:10px;justify-content:center;"><div class="rv-colorwheel ' + (on ? 'on' : 'off') + '" role="slider" aria-label="Farbton" aria-valuenow="' + hue + '" aria-valuemin="0" aria-valuemax="360" style="--s:150px;"><div class="cw-glow"></div><div class="cw-ring"></div><div class="cw-thumbrot" style="transform:rotate(' + (hue + 90) + 'deg);"><div class="cw-thumb" style="background:#fff;box-shadow:' + glow + ';"></div></div></div><div style="font-size:13px;color:var(--text-paragraph);">' + esc(t('cw_color')) + '</div></div>';
      };
      var body = '<div class="rv-section-head" style="padding-left:8px;">' + esc(t('dlg_lights')) + '</div>';
      zones.forEach(function (z) {
        var head = '<div class="rv-dcard-row">' + dIconSpan(z.icon) + '<div style="flex:1 1 0%;text-align:center;overflow:hidden;"><div class="rv-dcard-name">' + esc(z.label) + '</div></div>' + rvSwitch(z.on !== false) + '</div>';
        var inner;
        if (z.type === 'rgbw') {
          inner = '<div style="display:flex;align-items:center;gap:8px;justify-content:space-between;padding:14px 4px 4px;">' + vslider(82, t('w_brightness')) + wheel(z.on !== false, 210) + vslider(60, t('cw_white')) + '</div>';
        } else if (z.type === 'rgb') {
          inner = '<div style="display:flex;align-items:center;gap:8px;justify-content:space-between;padding:14px 4px 4px;">' + vslider(82, t('w_brightness')) + wheel(z.on !== false, 300) + '</div>';
        } else if (z.type === 'cw') {
          inner = '<div style="padding:8px 4px 4px;"><div class="rv-tempslider ' + (z.on !== false ? 'on' : 'off') + '"><div class="ts-track"></div><div class="ts-thumb" style="left:22%;"></div><input type="range" class="ts-input" min="0" max="100" step="1" value="22"></div>' +
            '<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--text-paragraph);padding:4px 2px 0;"><span>' + esc(t('ts_cold')) + '</span><span>' + esc(t('ts_warm')) + '</span></div>' +
            '<div style="font-size:12px;color:var(--text-paragraph);text-align:center;margin:10px 0 4px;">' + esc(t('w_brightness')) + '</div>' + '<div class="rv-slider" role="slider" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"><div class="fill" style="width:60%;"></div><div class="thumb" style="left:60%;"></div></div></div>';
        } else {
          inner = '<div style="padding:8px 4px 4px;"><div style="font-size:12px;color:var(--text-paragraph);text-align:center;margin-bottom:6px;">' + esc(t('w_brightness')) + ' 70%</div><div class="rv-slider" role="slider" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"><div class="fill" style="width:70%;"></div><div class="thumb" style="left:70%;"></div></div></div>';
        }
        body += '<div class="rv-dcard ">' + head + inner + '</div>';
      });
      return { title: t('dlg_lights'), body: body };
    }
    function buildLocateDialog() {
      var body = '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;padding:12px 0 4px;">' + dIconSpan('X_Utility_Map', 72) +
        '<div style="font-size:19px;font-weight:600;color:var(--text-heading);">' + esc(t('w_locate_active')) + '</div>' +
        '<div style="font-size:13px;font-weight:600;color:var(--brand);">' + esc(t('w_gps')) + '</div></div>' +
        dDiv1() +
        dcard(dIconSpan('X_Energy_Voltage', 44), t('dlg_locate_pos'), { value: '<span style="font-size:13px;color:var(--text);">51.96, 7.62</span>' }) +
        dcard(dIconSpan('X_Energy_ElectricRange', 44), t('dlg_locate_speed'), { value: '<span>0 km/h</span>' });
      return { title: t('dlg_locate'), body: body };
    }

    /* ── Sheet-Overlay öffnen/schließen ── */
    function ensureSheetHost() {
      var screen = el('rvk-phone-screen');
      if (!screen) return null;
      var hst = document.getElementById('rvk-sheet');
      if (!hst) { hst = document.createElement('div'); hst.id = 'rvk-sheet'; screen.appendChild(hst); }
      return hst;
    }
    function onSheetKey(e) { if (e.key === 'Escape' || e.keyCode === 27) closeSheet(); }
    function closeSheet() {
      var hst = document.getElementById('rvk-sheet');
      if (!hst) return;
      var ov = hst.querySelector('.rv-sheet-overlay');
      if (ov) ov.classList.remove('open');
      document.removeEventListener('keydown', onSheetKey);
      setTimeout(function () { if (hst) hst.innerHTML = ''; }, 440);
    }
    function openSheet(spec) {
      if (!spec) return;
      var hst = ensureSheetHost();
      if (!hst) return;
      var center = spec.logo
        ? '<div class="sheet-center"><div class="sheet-logo">' + spec.logo + '</div></div>'
        : '<div class="sheet-center"><div class="title">' + esc(spec.title || '') + '</div>' + (spec.subtitle ? '<div class="subtitle">' + esc(spec.subtitle) + '</div>' : '') + '</div>';
      var action = spec.action ? '<div class="action">' + spec.action + '</div>' : '';
      hst.innerHTML =
        '<div class="rv-sheet-overlay">' +
          '<div class="rv-sheet-backdrop"></div>' +
          '<div class="rv-sheet-wrap"><div class="rv-sheet">' +
            '<div class="rv-sheet-handle"></div>' +
            '<div class="rv-sheet-appbar">' +
              '<div class="action left" role="button" tabindex="0" aria-label="' + esc(t('close')) + '" data-sheet-close>' + CLOSE_X_SVG + '</div>' +
              center + action +
            '</div>' +
            '<div class="rv-sheet-body">' + spec.body + '</div>' +
          '</div></div>' +
        '</div>';
      var ov = hst.querySelector('.rv-sheet-overlay');
      ov.querySelector('.rv-sheet-backdrop').addEventListener('click', closeSheet);
      ov.querySelector('[data-sheet-close]').addEventListener('click', function (e) { e.stopPropagation(); closeSheet(); });
      bindSheetControls(ov);
      /* Reflow erzwingen, dann Slide-up (setTimeout robuster als rAF, das im
         Hintergrund-Tab gedrosselt wird) — Muster wie CfgOpenDialog im Prototyp. */
      void ov.offsetWidth;
      setTimeout(function () { ov.classList.add('open'); if (spec.onMount) { try { spec.onMount(ov); } catch (e) {} } }, 20);
      document.addEventListener('keydown', onSheetKey);
    }
    function bindSheetControls(ov) {
      ov.addEventListener('click', function (e) {
        var sw = e.target.closest('.rv-switch[role="switch"]');
        if (sw && ov.contains(sw)) {
          var onN = sw.classList.toggle('on');
          sw.setAttribute('aria-checked', onN ? 'true' : 'false');
          e.stopPropagation(); return;
        }
        var tab = e.target.closest('.rv-seg [role="tab"]');
        if (tab && ov.contains(tab)) {
          var seg = tab.parentNode;
          if (seg.classList.contains('disabled')) { e.stopPropagation(); return; }
          Array.prototype.forEach.call(seg.querySelectorAll('[role="tab"]'), function (tb) {
            var a = tb === tab; tb.classList.toggle('active', a); tb.setAttribute('aria-selected', a ? 'true' : 'false');
          });
          // Ansichts-Umschaltung + Statuszeile aktualisieren (Klima-Inseln).
          // Generisch für beliebig viele Stage-Zellen (.cs-dial/.cs-fan/.cs-cool …):
          // sichtbar wird .cs-<view>, alle Geschwister verschwinden. Elemente mit
          // data-showview="<view>" (z. B. Webasto-Energie nur beim Heizen,
          // Autoterm-Laufzeit nur beim Lüften) folgen derselben Auswahl.
          var view = tab.getAttribute('data-view');
          if (view) {
            var unit = tab.closest('.rv-clim-unit');
            if (unit) {
              var stg = unit.querySelector('.rv-clim-stage');
              if (stg) {
                Array.prototype.forEach.call(stg.children, function (cellEl) {
                  var isTarget = cellEl.className.indexOf('cs-' + view) >= 0;
                  cellEl.style.display = isTarget ? '' : 'none';
                });
              }
              Array.prototype.forEach.call(unit.querySelectorAll('[data-showview]'), function (elx) {
                elx.style.display = elx.getAttribute('data-showview') === view ? '' : 'none';
              });
              var cap = tab.getAttribute('data-cap');
              var capEl = unit.querySelector('.cc-caption');
              if (cap != null && capEl) capEl.textContent = cap;
            }
          }
          // Text-Hook: Tab setzt den Inhalt eines Ziel-Elements (Autoterm-Laufzeit-Hinweis)
          var stTarget = tab.getAttribute('data-settext-target');
          if (stTarget) {
            var tgt = ov.querySelector('#' + stTarget);
            if (tgt) tgt.textContent = tab.getAttribute('data-settext') || '';
          }
          // Timberline: Temperaturzone wechselt die Dial-Werte der Unit
          var zIdx = tab.getAttribute('data-tl-zoneseg');
          if (zIdx != null) {
            var zUnit = tab.closest('.rv-clim-unit');
            if (zUnit) tlApplyZone(zUnit, parseInt(zIdx, 10) || 0);
          }
          e.stopPropagation(); return;
        }
        var arr = e.target.closest('.cc-arrow');
        if (arr && ov.contains(arr)) {
          var dial = arr.closest('.rv-climate');
          if (dial) {
            var tEl = dial.querySelector('.cc-temp');
            var cur = parseInt(String(tEl.textContent || '').replace(/[^0-9-]/g, ''), 10) || 20;
            cur += arr.classList.contains('up') ? 1 : -1;
            /* Geräte-Regelbereich aus data-min/-max (neue Heizungs-Widgets);
               Fallback = Truma-Fenster 15–30 mit Klick-Clamp 5–35 (Bestand). */
            var dMin = parseInt(dial.getAttribute('data-min'), 10);
            var dMax = parseInt(dial.getAttribute('data-max'), 10);
            var hasRange = !isNaN(dMin) && !isNaN(dMax) && dMax > dMin;
            cur = Math.max(hasRange ? dMin : 5, Math.min(hasRange ? dMax : 35, cur));
            tEl.innerHTML = cur + '<span class="unit">°</span>';
            var pv = hasRange ? (cur - dMin) / (dMax - dMin) : (cur - 15) / 15;
            dial.style.setProperty('--p', Math.max(0, Math.min(1, pv)));
          }
          e.stopPropagation(); return;
        }
        var twt = e.target.closest('.twt-btn');
        if (twt && ov.contains(twt)) {
          var grp = twt.parentNode;
          Array.prototype.forEach.call(grp.querySelectorAll('.twt-btn'), function (b) { b.setAttribute('aria-pressed', b === twt ? 'true' : 'false'); });
          e.stopPropagation(); return;
        }
        /* Aufklapp-Sektionen (Diagnostik der Heizungs-Dialoge) */
        var col = e.target.closest('[data-collapse]');
        if (col && ov.contains(col)) {
          var target = ov.querySelector('#' + col.getAttribute('data-collapse'));
          if (target) {
            var openNow = target.style.display === 'none';
            target.style.display = openNow ? '' : 'none';
            var chv = col.querySelector('.rvk-collapse-chev');
            if (chv) chv.style.transform = openNow ? 'rotate(180deg)' : '';
          }
          e.stopPropagation(); return;
        }
      });
    }

    /* ── Celebrations ── */
    function celebrate(title, sub) {
      try {
        var toastMount = el('rvk-toast');
        var wrap = document.createElement('div');
        wrap.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:9999;pointer-events:none;display:flex;justify-content:center;';
        var colors = ['#30b6c6', '#fa4856', '#63d583', '#ffd9a8', '#08121b', '#ffffff'];
        var conf = '';
        for (var i = 0; i < 46; i++) {
          var left = 10 + Math.random() * 80;
          var delay = (Math.random() * 0.25).toFixed(2);
          var dur = (1.5 + Math.random() * 1.1).toFixed(2);
          var col = colors[i % colors.length];
          var w = 6 + Math.floor(Math.random() * 7);
          var h = 9 + Math.floor(Math.random() * 9);
          var rad = Math.random() < 0.5 ? '2px' : '50%';
          conf += '<span style="position:absolute;top:70px;left:' + left + '%;width:' + w + 'px;height:' + h + 'px;background:' + col + ';border-radius:' + rad + ';opacity:0;animation:rvkConfetti ' + dur + 's cubic-bezier(.22,.61,.36,1) ' + delay + 's forwards;"></span>';
        }
        wrap.innerHTML = conf +
          '<div style="pointer-events:auto;margin-top:24px;background:#fff;border-radius:22px;padding:15px 18px 15px 15px;display:flex;align-items:center;gap:14px;box-shadow:var(--shadow-widget-lg);animation:rvkToastIn .42s cubic-bezier(.22,.61,.36,1);max-width:430px;">' +
          '<span style="flex:none;display:inline-flex;align-items:center;gap:7px;background:var(--color-cyan);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:13px;padding:9px 14px;border-radius:9999px;animation:rvkGlow 1.8s ease-in-out infinite;white-space:nowrap;">' + esc(t('celebrate_chip')) + '</span>' +
          '<span style="min-width:0;"><span style="display:block;font-family:var(--font-heading);font-weight:600;font-size:14px;color:var(--color-text);">' + esc(title) + '</span>' +
          '<span style="display:block;font-size:12.5px;color:var(--color-muted);line-height:1.45;margin-top:2px;">' + esc(sub) + '</span></span></div>';
        toastMount.appendChild(wrap);
        var card = wrap.lastElementChild;
        setTimeout(function () { if (card) { card.style.transition = 'opacity .4s, transform .4s'; card.style.opacity = '0'; card.style.transform = 'translateY(-12px)'; } }, 3200);
        setTimeout(function () { wrap.remove(); }, 3800);
      } catch (e) {}
    }

    /* ── Modal (Info + Lite-Warnung) ── */
    function renderModal(totalN) {
      var mount = el('rvk-modal');
      var html = '';
      if (ui.info) {
        var title = '', paras = [];
        if (ui.info.type === 'key') {
          title = t('info_' + ui.info.key + '_title');
          paras = String(t('info_' + ui.info.key + '_body')).split(/\n\s*\n/);
        } else {
          var it = itemById(ui.info.id);
          if (it) { title = it.info_titel || it.label; paras = String(it.info_text || '').split(/\n\s*\n/); }
        }
        html += '<div class="rvk-overlay" data-act="info-close">' +
          '<div class="rvk-dialog" data-act="noop">' +
          '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:14px;">' +
          '<h3>' + esc(title) + '</h3>' +
          '<button type="button" data-act="info-close" style="width:32px;height:32px;border-radius:50%;border:none;background:var(--color-bg-deep);cursor:pointer;flex:none;display:flex;align-items:center;justify-content:center;padding:0;"><img src="' + uiIcon('close.svg') + '" alt="" style="width:16px;height:16px;"></button></div>' +
          paras.filter(function (p) { return p.trim(); }).map(function (p) { return '<p>' + esc(p.trim()) + '</p>'; }).join('') +
          '</div></div>';
      }
      if (ui.liteWarn && state.brainMode === 'lite' && totalN > E.nodeLimit(state)) {
        html += '<div class="rvk-overlay" style="z-index:210;">' +
          '<div class="rvk-dialog" data-act="noop">' +
          '<div style="width:46px;height:46px;border-radius:14px;background:var(--color-cyan-soft);display:flex;align-items:center;justify-content:center;margin-bottom:14px;"><img src="' + appIcon('X_Utility_Notification') + '" alt="" style="width:26px;height:26px;"></div>' +
          '<h3 style="margin-bottom:8px;">' + esc(t('lite_warn_title')) + '</h3>' +
          '<p style="margin:0;">' + esc(t('lite_warn_text', { count: totalN })) + '</p>' +
          '<div style="display:flex;gap:10px;margin-top:20px;">' +
          '<button type="button" data-act="lite-close" style="flex:none;border:none;border-radius:9999px;padding:13px 18px;background:var(--color-bg-deep);color:var(--color-text);font-family:var(--font-body);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('lite_warn_remove')) + '</button>' +
          '<button type="button" data-act="lite-switch" style="flex:1;border:none;border-radius:9999px;padding:13px;background:var(--color-text);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('lite_warn_switch', { price: euro(productPrice('brain')) })) + '</button>' +
          '</div></div></div>';
      }
      /* Kühlschrank-Automatik-Angebot (Popup) */
      if (ui.fridgeAutoOffer && !on('tfridge')) {
        var frItem = null;
        byBereich('integration').forEach(function (i) { if (i.cap === 'fridge' && on(i.id)) frItem = i; });
        var bodyTxt = (frItem && frItem.info_text) ? String(frItem.info_text) : t('fridge_auto_offer_body');
        var paras = bodyTxt.split(/\n\s*\n/).filter(function (p) { return p.trim(); });
        html += '<div class="rvk-overlay" style="z-index:212;">' +
          '<div class="rvk-dialog" data-act="noop">' +
          '<div style="width:46px;height:46px;border-radius:14px;background:var(--color-cyan-soft);display:flex;align-items:center;justify-content:center;margin-bottom:14px;"><img src="' + appIcon('X_Temp_MiniBar') + '" alt="" style="width:26px;height:26px;"></div>' +
          '<h3 style="margin-bottom:8px;">' + esc(t('fridge_auto_offer_title')) + '</h3>' +
          paras.map(function (p) { return '<p style="margin:0 0 8px;">' + esc(p.trim()) + '</p>'; }).join('') +
          '<div style="display:flex;gap:10px;margin-top:18px;">' +
          '<button type="button" data-act="fridge-auto-later" style="flex:none;border:none;border-radius:9999px;padding:13px 18px;background:var(--color-bg-deep);color:var(--color-text);font-family:var(--font-body);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('fridge_auto_later')) + '</button>' +
          '<button type="button" data-act="fridge-auto-add" style="flex:1;border:none;border-radius:9999px;padding:13px;background:var(--color-text);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">' + esc(t('fridge_auto_add')) + '</button>' +
          '</div></div></div>';
      }
      mount.innerHTML = html;
    }

    /* ── Warenkorb ── */
    function showCartError(detail) {
      var mount = el('rvk-modal');
      mount.innerHTML = '<div class="rvk-overlay" data-act="info-close"><div class="rvk-dialog" data-act="noop">' +
        '<h3 style="margin-bottom:10px;">Oops</h3><p>' + esc(t('cart_error')) + '</p>' +
        (detail ? '<p style="font-size:13px;color:var(--color-muted);">' + esc(detail) + '</p>' : '') +
        '<button type="button" data-act="info-close" style="margin-top:8px;border:none;border-radius:9999px;padding:12px 20px;background:var(--color-text);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">OK</button>' +
        '</div></div>';
    }
    /* Schlichte Hinweis-Box (gleiche Optik wie die Warenkorb-Meldung). */
    function showNotice(msg) {
      var mount = el('rvk-modal');
      if (!mount) return;
      mount.innerHTML = '<div class="rvk-overlay" data-act="info-close"><div class="rvk-dialog" data-act="noop">' +
        '<p>' + esc(msg) + '</p>' +
        '<button type="button" data-act="info-close" style="margin-top:8px;border:none;border-radius:9999px;padding:12px 20px;background:var(--color-text);color:#fff;font-family:var(--font-heading);font-weight:600;font-size:14px;cursor:pointer;">OK</button>' +
        '</div></div>';
    }
    function addToCart() {
      var lines = E.buildLines(CAT, state);
      var code = E.code(state);
      var items = lines.cartItems.map(function (it) {
        var props = { _konfiguration: code };
        // Vorbestellung als SICHTBARE Positionseigenschaft — erscheint im
        // Warenkorb, Checkout, in der Bestellbestätigung und im Auftrag.
        if (it.preorder) props[t('preorder_property')] = it.preorderNote || t('preorder_note');
        return { id: it.id, quantity: it.quantity, properties: props };
      });
      // Nur „Ich habe schon ein BRAIN" und sonst nichts → nichts zu kaufen. Sagen statt still nichts tun.
      if (!items.length) { showNotice(t('cart_empty')); return; }
      // total = effektiv (rabattiert), totalList = Listenpreis — sonst bricht
      // die Zeitreihe im Marketing-Hub, sobald eine Kampagne läuft.
      track('config_add_to_cart', { total: lines.total / 100, totalList: (lines.listTotal || lines.total) / 100, itemCount: lines.itemCount });
      var summary = lines.lines
        .filter(function (l) { return String(l.key).indexOf('integ0:') !== 0; })
        .map(function (l) { return l.qty + '× ' + l.name + (l.preorder ? ' (' + t('preorder_chip') + ')' : ''); })
        .join(' | ');
      if (summary.length > 900) summary = summary.slice(0, 897) + '…';
      var btn = el('rvk-bar-cta');
      if (btn) btn.disabled = true;
      // Erst frühere Konfigurator-Positionen entfernen (erkennbar an der
      // _konfiguration-Property) — sonst dupliziert ein zweiter Klick bzw.
      // eine geänderte Konfiguration alle Zeilen im Warenkorb.
      fetch(ROOT_URL + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._konfiguration) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) return null;
        return fetch(ROOT_URL + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }).catch(function () { /* Aufräumen ist best-effort */ }).then(function () {
        return fetch(ROOT_URL + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // Shopify zeigt zuletzt hinzugefügte Positionen oben → rückwärts senden,
          // damit der Warenkorb BRAIN → … → PANEL liest wie Konfigurator, PDF und CRM (F9).
          body: JSON.stringify({ items: items.slice().reverse() })
        });
      }).then(function (r) {
        if (!r.ok) {
          // Shopify liefert bei 422 die konkrete Ursache (z. B. welches
          // Produkt ausverkauft ist) — dem Kunden zeigen statt nur "Oops".
          return r.json().then(function (err) {
            var e2 = new Error('add ' + r.status);
            e2.userMsg = (err && (err.description || err.message)) || '';
            throw e2;
          }, function () { throw new Error('add ' + r.status); });
        }
        return r.json();
      }).then(function () {
        return fetch(ROOT_URL + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // 'Konfigurations-Code' = gespeicherter Code (leer löscht das Attribut) — damit der
          // Vertrieb jede Bestellung exakt im CRM ziehen kann (S4); das _konfiguration-Property
          // an den Positionen ist nur der Dedup-Hash.
          body: JSON.stringify({ attributes: { 'Konfiguration': summary, 'Konfigurations-Code': savedCode || '' } })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('update ' + r.status);
        window.location.href = CART_URL;
      }).catch(function (e) {
        if (btn) btn.disabled = false;
        showCartError(e && e.userMsg ? e.userMsg : '');
      });
    }

    /* ── PDF-Beleg (Print-Fenster wie im Prototyp) ── */
    function handoverPrint() {
      var groups = E.nodeGroups(CAT, state);
      var sums = E.buildLines(CAT, state);
      var total = sums.total;
      var full = state.brainMode === 'full';
      var brainName = state.brainMode === 'own' ? E.tx('eng_brain_own_name')
        : ((CAT.products[full ? 'brain' : 'brain_lite'] || {}).title || (full ? 'BRAIN®' : 'BRAIN® Lite'));
      var capsHeader = t('pdf_caps');
      var rows = groups.map(function (l) {
        var k = String(l.key);
        var isSub = k.indexOf('acc:') === 0 || k.indexOf('integ0:') === 0 || l.indent;
        // priceHtml liefert fertiges (escaptes) HTML — daher unten kein esc()
        var price = l.onRequest ? esc(t('on_request')) : ((k.indexOf('integ0:') === 0 || k === 'brain_own') ? '—' : priceHtml(l.total, l.listTotal));
        var nodeCell = '<div class="node">' +
          (l.img ? '<img class="nimg' + (l.imgHasBg ? ' hasbg' : '') + '" src="' + esc(lineImg(l.img)) + '" alt="">' : '<span class="nimg"></span>') +
          '<div><div class="nname">' + esc(l.name) + '</div>' + (l.note ? '<div class="nnote">' + esc(l.note) + '</div>' : '') +
          (l.preorder ? '<div class="nnote npre">' + esc(l.preorderNote || t('preorder_note')) + '</div>' : '') + '</div></div>';
        var capCell = (l.caps && l.caps.length)
          ? '<ul class="caps">' + l.caps.map(function (cp) {
              return '<li>' + (cp.icon ? '<img class="cic" src="' + esc(appIcon(cp.icon)) + '" alt="">' : '<span class="cic"></span>') + '<span>' + esc(cp.label) + '</span></li>';
            }).join('') + '</ul>'
          : '<span class="capnone">—</span>';
        return '<tr class="' + (isSub ? 'sub' : 'main') + '"><td class="cnode">' + nodeCell + '</td>' +
          '<td class="ccaps">' + capCell + '</td>' +
          '<td class="cprice">' + price + (l.qty > 1 ? '<div class="qtyn">×' + l.qty + '</div>' : '') + '</td></tr>';
      }).join('');
      var w = window.open('', '_blank', 'width=840,height=1000');
      /* Popup-Blocker: bisher passierte hier gar nichts — der Kunde klickte ins
         Leere. Jetzt sagt ein Hinweis, woran es liegt (Befund Live-Test). */
      if (!w) { showNotice(t('pdf_blocked')); return; }
      track('config_pdf', { total: total / 100, totalList: (sums.listTotal || total) / 100 });
      w.document.write('<!doctype html><html><head><meta charset="utf-8"><title>REVOTION ' + esc(brainName) + '</title>' +
        '<style>body{font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:#08121b;padding:40px;max-width:780px;margin:0 auto;}' +
        '.rvk-logo{height:38px;display:block;margin:0 0 22px;}' +
        'h1{font-size:24px;margin:14px 0 2px;letter-spacing:-.01em;}' +
        '.badge{display:inline-block;background:#30b6c6;color:#fff;border-radius:999px;padding:5px 14px;font-size:12px;font-weight:600;}' +
        '.code{font-size:13px;color:#395f76;margin-top:6px;}' +
        'table{width:100%;border-collapse:collapse;margin-top:22px;}' +
        'th{text-align:left;color:#638197;font-size:11px;text-transform:uppercase;letter-spacing:.08em;padding:0 8px 9px;border-bottom:2px solid #e6eef3;}' +
        'td{padding:13px 8px;border-bottom:1px solid #eef3f7;font-size:14px;vertical-align:middle;}' +
        '.node{display:flex;align-items:center;gap:12px;}' +
        '.nimg{width:48px;height:48px;object-fit:contain;flex:none;}' +
        '.nimg.hasbg{border-radius:8px;object-fit:cover;}' +
        '.nname{font-weight:600;font-size:14px;}' +
        '.nnote{color:#638197;font-size:11px;margin-top:2px;}' +
        '.nnote.npre{color:#30b6c6;font-weight:600;}' +
        'tr.sub .node{padding-left:22px;}' +
        'tr.sub .nname{font-weight:400;color:#395f76;font-size:13px;}' +
        'tr.sub .nimg{width:30px;height:30px;}' +
        '.caps{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:7px;}' +
        '.caps li{display:flex;align-items:center;gap:9px;font-size:13px;}' +
        '.cic{width:22px;height:22px;object-fit:contain;flex:none;display:inline-block;}' +
        '.capnone{color:#c4d2dc;}' +
        '.cprice{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums;font-weight:500;}' +
        '.cprice .rvk-price-was{color:#8aa0b0;font-weight:400;margin-right:4px;}' +
        '.cprice .rvk-price-now{color:#08121b;font-weight:600;}' +
        '.qtyn{color:#638197;font-size:11px;font-weight:400;}' +
        '.tot{display:flex;justify-content:space-between;font-weight:600;font-size:21px;margin-top:20px;}' +
        '.muted{color:#638197;font-size:12px;margin-top:26px;}' +
        '.inst{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-top:14px;padding:12px 14px;border-radius:12px;background:#f3f8fb;font-size:13px;font-weight:600;color:#08121b;}' +
        '.insth{display:block;margin-top:3px;font-weight:400;font-size:12px;color:#3d5c72;}' +
        '.instv{white-space:nowrap;}' +
        'img{max-width:none;}</style></head><body>' +
        '<img class="rvk-logo" src="' + esc(AB + '/revotion-logo-black.svg') + '" alt="REVOTION">' +
        '<span class="badge">' + esc(t('pdf_badge')) + '</span>' +
        '<h1>' + esc(brainName) + '</h1>' +
        (savedCode ? '<div class="code">' + esc(t('pdf_code')) + ': ' + esc(savedCode) + (codeStale() ? ' · ' + esc(t('pdf_code_stale')) : '') + '</div>' : '') +
        '<table><thead><tr><th>' + esc(t('pdf_pos')) + '</th><th>' + esc(capsHeader) + '</th><th style="text-align:right">' + esc(t('pdf_price')) + '</th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>' +
        '<div class="tot"><span>' + esc(t('pdf_total')) + '</span><span class="cprice">' + priceHtml(total, sums.listTotal) + '</span></div>' +
        (function () {
          if (state.install !== 'partner') return '';
          var e = installEstimateNow();
          if (!e) return '';
          /* Jasper, 11.09.2026: Der Beleg soll BEIDES tragen — die veranschlagte
             Werkstattzeit und die Preisspanne. Die Zeit steht links unter der
             Überschrift, die Spanne rechts; darunter der Stundensatz-Bezug. */
          var hoursTxt = e.hours > 0 ? t('inst_hours', { hours: nf1(e.hours) }) : '';
          var baseTxt = instPartnerRateUsed()
            ? t('inst_partner', { name: String(ui.instPartner.name).slice(0, 80) })
            : t('inst_partner_avg');
          return '<div class="inst"><span>' + esc(t('pdf_install')) +
            (hoursTxt ? '<span class="insth">' + esc(hoursTxt) + '</span>' : '') + '</span>' +
            '<span class="instv">' + esc(t('inst_approx')) + esc(t('inst_range', { from: euroInt(e.from), to: euroInt(e.to) })) + '</span></div>' +
            '<p class="muted" style="margin-top:6px;">' + esc(baseTxt) + ' · ' + esc(t('inst_note')) + '</p>';
        })() +
        '<p class="muted">' + esc(t('pdf_footer')) + '</p>' +
        '<scr' + 'ipt>onload=function(){setTimeout(function(){print();},300);}<\/scr' + 'ipt></body></html>');
      w.document.close();
    }

    /* ── Peek-Phone (Mobile) ── */
    function bindPeekDrag() {
      var phone = el('rvk-phone');
      if (!phone) return;
      function mm() { try { return window.matchMedia('(max-width:1023px)').matches; } catch (e) { return false; } }
      var st = { on: false, y0: 0, dy: 0, moved: false };
      function begin(y) { if (!mm() || ui.mobilePreview) return; st.on = true; st.y0 = y; st.dy = 0; st.moved = false; phone.style.transition = 'none'; }
      function move(y) {
        if (!st.on) return;
        st.dy = y - st.y0;
        if (Math.abs(st.dy) > 6) st.moved = true;
        var base = phone.offsetHeight - 158;
        var tr = Math.max(0, Math.min(base, base + st.dy));
        phone.style.transform = 'translateY(' + tr + 'px)';
      }
      function end() {
        if (!st.on) return;
        st.on = false;
        phone.style.transition = '';
        phone.style.transform = '';
        if (st.dy < -70) expandPhone();
      }
      phone.addEventListener('touchstart', function (e) { begin(e.touches[0].clientY); }, { passive: true });
      phone.addEventListener('touchmove', function (e) { if (st.on) { move(e.touches[0].clientY); if (st.moved) e.preventDefault(); } }, { passive: false });
      phone.addEventListener('touchend', end);
      phone.addEventListener('touchcancel', end);
      phone.addEventListener('click', function () { if (mm() && !ui.mobilePreview && !st.moved) expandPhone(); });
    }
    /* Phone-„Vollbild": den GERAHMTEN Phone (Portrait / Panel Mini / Panel Max) als
       Ganzes per transform:scale zentriert über die Seite vergrößern — der Rahmen
       BLEIBT und die interne Skalierung bleibt exakt gleich (nur uniform größer).
       Ersetzt die alte Fullscreen-API (die den Rahmen strippte) und die mobile
       Raw-Fullscreen-Seite. Desktop + Mobile identisch, smoothe Grow/Shrink-Transition. */
    function ensurePhoneOverlay() {
      var bd = el('rvk-phone-backdrop');
      if (!bd) {
        bd = document.createElement('div');
        bd.id = 'rvk-phone-backdrop';
        bd.className = 'rvk-phone-backdrop';
        bd.addEventListener('click', collapsePhone);
        (root || document.body).appendChild(bd);
      }
      return bd;
    }
    function phoneExpandTransform() {
      var ph = el('rvk-phone');
      if (!ph) return '';
      var r = ph.getBoundingClientRect();
      if (!r.width || !r.height) return '';
      var vw = window.innerWidth, vh = window.innerHeight;
      var mob = false; try { mob = window.matchMedia('(max-width:1023px)').matches; } catch (e) {}
      var k = Math.min(vw * (mob ? 0.94 : 0.95) / r.width, vh * (mob ? 0.90 : 0.93) / r.height);
      /* Upscale mobil begrenzen (sonst Popups/Content aufgeblasen + unlesbar) UND
         Landscape-Panels (breiter als der Viewport) dürfen schrumpfen — der frühere
         Clamp k>=1 erzwang Übergröße + horizontales Scrollen. */
      var cap = mob ? 1.06 : 1.6;
      if (k > cap) k = cap;
      if (k < 0.4) k = 0.4;
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var tx = Math.round(vw / 2 - cx), ty = Math.round(vh / 2 - cy);
      return 'translate(' + tx + 'px,' + ty + 'px) scale(' + k.toFixed(4) + ')';
    }
    function expandPhone() {
      var ph = el('rvk-phone');
      if (!ph || ui.expanded) return;
      ui.expanded = true; ui.mobilePreview = true;
      var bd = ensurePhoneOverlay();
      document.documentElement.classList.add('rvk-phone-expanded');
      try { document.body.style.overflow = 'hidden'; } catch (e) {}
      ph.style.transition = 'none';
      ph.style.transform = 'translate(0,0) scale(1)'; // expliziter Startzustand
      void ph.offsetWidth;                             // Reflow → Startzustand committen (robuster als rAF)
      ph.style.transition = 'transform .5s var(--ease-out)';
      ph.style.transform = phoneExpandTransform();      // misst nativen Rect, skaliert+zentriert → Transition animiert
      bd.classList.add('open');
    }
    function collapsePhone() {
      var ph = el('rvk-phone');
      if (!ph || !ui.expanded) return;
      ui.expanded = false; ui.mobilePreview = false;
      var bd = el('rvk-phone-backdrop');
      if (bd) bd.classList.remove('open');
      document.documentElement.classList.remove('rvk-phone-expanded');
      ph.style.transition = 'transform .44s var(--ease-out)';
      ph.style.transform = '';
      try { document.body.style.overflow = ''; } catch (e) {}
      setTimeout(function () { if (!ui.expanded) { if (bd) bd.remove(); ph.style.transition = ''; } }, 520);
    }
    function togglePhone() { if (ui.expanded) collapsePhone(); else expandPhone(); }

    /* ── Header-Offset messen (Vision-Theme) ── */
    function measureHeader() {
      var h = 0;
      var hd = document.querySelector('.header.header-sticky--active') || document.querySelector('header.header') || document.querySelector('.header');
      if (hd) {
        var cs = getComputedStyle(hd);
        if (cs.position === 'sticky' || cs.position === 'fixed') h = hd.getBoundingClientRect().height;
      }
      root.style.setProperty('--rvk-header-h', Math.round(h) + 'px');
    }
    measureHeader();
    window.addEventListener('resize', measureHeader);
    window.addEventListener('resize', sizePanelGrid);
    /* Expanded-Phone bei Resize/Orientierung neu zentrieren (ohne Transition-Ruckeln) */
    window.addEventListener('resize', function () {
      if (!ui.expanded) return;
      var ph = el('rvk-phone');
      if (ph) { ph.style.transition = 'none'; ph.style.transform = phoneExpandTransform(); }
    });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.keyCode === 27) && ui.expanded) collapsePhone(); });
    setTimeout(measureHeader, 800);

    /* ── Render-Zyklus ── */
    function scrollToEinbau() {
      var sec = root.querySelector('[data-sek="einbau"]');
      if (sec) {
        var y = sec.getBoundingClientRect().top + window.scrollY - 18;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    /* PANEL-Mockup: iPhone-Rahmen bei PANEL 4"/8" gegen den echten quadratischen
       SVG-Rahmen (Panel Mini) tauschen — die SVG liegt als Rahmen-Layer (Background),
       der App-Screen sitzt mit overflow:hidden in der weißen Innenfläche.
       „Eigenes Tablet" (panel==='tablet') bleibt der iPhone-Rahmen. */
    var PANEL_FRAME_OVERLAY_URL = (SET.appdsAssets && SET.appdsAssets.panelFrameOverlay) || (AB + '/panel-mini-frame-overlay-v2.svg');
    var PANEL_MAX_FRAME_OVERLAY_URL = (SET.appdsAssets && SET.appdsAssets.panelMaxFrameOverlay) || (AB + '/panel-max-frame-overlay.svg');
    function applyPanelFrame() {
      var ph = el('rvk-phone');
      if (!ph) return;
      ph.classList.remove('rvk-frame-panel', 'rvk-frame-panel4', 'rvk-frame-panel8');
      // 8"-Panel darf auf Desktop mitwachsen (CSS .rvk-root.rvk-p8) — vor sizePanelGrid setzen
      var rootEl = ph.closest('.rvk-root');
      if (rootEl) rootEl.classList.toggle('rvk-p8', state.panel === '8');
      ph.style.backgroundImage = ''; // alter Background-Ansatz entfällt
      var overlay = ph.querySelector('.rvk-panel-frame');
      var isPanel = state.panel === '4' || state.panel === '8';
      if (isPanel) {
        ph.classList.add('rvk-frame-panel', state.panel === '8' ? 'rvk-frame-panel8' : 'rvk-frame-panel4');
        // Rahmen-Fase als Overlay ÜBER dem Screen (transparentes Zentrum), damit
        // die App-Kanten darunter verschwinden und optisch unter dem Rahmen scrollen.
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'rvk-panel-frame';
          var fimg0 = document.createElement('img');
          fimg0.className = 'rvk-panel-frame-img';
          fimg0.alt = '';
          overlay.appendChild(fimg0);
          ph.appendChild(overlay);
        }
        /* Rahmen als <img> (nicht background-image) → rendert die SVG in echter
           Display-Auflösung, bleibt auch beim Vergrößern scharf (iOS Safari rastert
           background-image-SVGs teils nur in 1×, was pixelig wirkt). */
        var frameUrl = state.panel === '8' ? PANEL_MAX_FRAME_OVERLAY_URL : PANEL_FRAME_OVERLAY_URL;
        var fimg = overlay.querySelector('img');
        if (fimg && fimg.getAttribute('src') !== frameUrl) fimg.setAttribute('src', frameUrl);
        sizePanelGrid();
      } else if (overlay) {
        overlay.remove();
      }
    }

    /* Widget-Grid als GANZES auf die Display-Breite schrumpfen: feste 190px-Zellen
       (Widget-Innenproportionen bleiben exakt) + `transform: scale()` auf das ganze
       Grid. transform (NICHT zoom!) rendert in jedem Browser identisch — CSS-`zoom`
       wird u.a. in älteren Firefox ignoriert und würde die Skalierung dort zerschießen.
       Weil ein transformiertes Element seine LAYOUT-Box behält (unskaliert), würde der
       Scroll-Container sonst zu viel Leerraum unten haben → mit negativem margin-bottom
       exakt um die eingesparte Höhe kompensieren. Rechnet nach der ECHTEN Screen-Breite
       → korrekt auf Desktop (Phone fix 404px) UND im Vollbild. */
    function sizePanelGrid() {
      var ph = el('rvk-phone');
      if (!ph) return;
      var p8 = ph.classList.contains('rvk-frame-panel8');
      var p4 = ph.classList.contains('rvk-frame-panel4');
      var grid = ph.querySelector('#rvk-home .rvk-grid');
      if (!grid) return;
      var home = ph.querySelector('#rvk-home');
      if (!p8 && !p4) {
        grid.style.transform = ''; grid.style.width = ''; grid.style.marginBottom = ''; grid.style.marginLeft = '';
        if (home) home.style.paddingTop = '';
        return;
      }
      var screen = el('rvk-phone-screen');
      if (!screen) return;
      /* Feed-padding-top an die ECHTE (kompakte) Header-Höhe koppeln, damit die
         Widgets direkt unter dem Header starten (kein toter Raum, mehr Platz fürs 2×2). */
      var header = ph.querySelector('.rvk-app-header');
      var headerH = header ? Math.round(header.getBoundingClientRect().height) : 40;
      var padTop = headerH + 4;
      if (home) home.style.paddingTop = padTop + 'px';
      var padX = 28, padBottom = 14;
      if (home) { var fcs = getComputedStyle(home); padX = (parseFloat(fcs.paddingLeft) || 0) + (parseFloat(fcs.paddingRight) || 0); padBottom = parseFloat(fcs.paddingBottom) || 14; }
      var cell = 190, gap = 16, span2 = 2 * cell + gap; // 2×2-Widget = 396px
      var cols = p8 ? 5 : 2;
      var natural = cols * cell + (cols - 1) * gap;
      var availW = screen.clientWidth - padX;
      var availH = screen.clientHeight - padTop - padBottom;
      if (availW <= 0 || natural <= 0) return;
      /* Panel 4" (quadratisch): ein 2×2-Widget muss KOMPLETT rein (Breite UND Höhe) —
         sonst unten abgeschnitten. Panel 8" (quer): breitenbasiert (5 Spalten), das 2×2
         passt vertikal ohnehin. */
      var s = p4 ? Math.min(availW / natural, availH / span2) : (availW / natural);
      if (s <= 0) return;
      grid.style.width = natural + 'px';
      grid.style.transform = 'none';
      grid.style.marginBottom = '0';
      var nh = grid.offsetHeight; // Layout-Höhe (unskaliert)
      grid.style.transformOrigin = 'top left';
      grid.style.transform = 'scale(' + s.toFixed(4) + ')';
      grid.style.marginBottom = (-Math.round(nh * (1 - s))) + 'px';
      /* Höhen-begrenztes 2×2 (Panel 4") füllt die Breite nicht ganz → horizontal
         zentrieren, damit es mittig statt links-lastig sitzt. Bei 8" ist der Versatz 0. */
      grid.style.marginLeft = Math.max(0, Math.round((availW - natural * s) / 2)) + 'px';
    }

    /* Dezenter Scroll-Hinweis: wippender Chevron unten im Mockup, sichtbar nur wenn der
       Homescreen scrollbar ist und noch nicht am Ende — signalisiert „hier kann man scrollen". */
    function ensureScrollHint() {
      var scr = el('rvk-phone-screen');
      if (!scr) return null;
      var hint = el('rvk-scroll-hint');
      if (!hint) {
        hint = document.createElement('div');
        hint.id = 'rvk-scroll-hint';
        hint.className = 'rvk-scroll-hint';
        hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
        scr.appendChild(hint);
        var home = el('rvk-home');
        if (home) home.addEventListener('scroll', function () { updateScrollHint(); }, { passive: true });
      }
      return hint;
    }
    function updateScrollHint() {
      var hint = ensureScrollHint();
      var home = el('rvk-home');
      if (!hint || !home) return;
      var scrollable = (home.scrollHeight - home.clientHeight) > 18;
      var atBottom = home.scrollTop >= (home.scrollHeight - home.clientHeight - 18);
      hint.classList.toggle('on', scrollable && !atBottom);
    }

    function update() { saveState(); render(); }

    function render() {
      /* Eingabe im Custom-Formular über Re-Render retten */
      var draftInput = el('rvk-custom-label');
      var draftVal = draftInput ? draftInput.value : null;
      var hadFocus = draftInput && document.activeElement === draftInput;

      var lines = E.buildLines(CAT, state);
      var computed = lines.computed;
      var totalN = E.totalNodes(CAT, state);

      /* Celebrations + Lite-Warnung (wie componentDidUpdate im Prototyp) */
      if (prevMulti != null) {
        if ((computed.req.switch_multi || 0) > prevMulti) { celebrate(t('celebrate_multi_title'), t('celebrate_multi_sub')); track('config_celebration', { kind: 'switch_multi' }); }
        if ((computed.req.ambient_mw || 0) > prevMW) { celebrate(t('celebrate_mw_title'), t('celebrate_mw_sub')); track('config_celebration', { kind: 'ambient_mw' }); }
      }
      prevMulti = computed.req.switch_multi || 0;
      prevMW = computed.req.ambient_mw || 0;
      if (state.brainMode === 'lite' && totalN > E.nodeLimit(state) && !ui.liteWarn && (prevNodes == null || totalN > prevNodes || prevBrain !== 'lite')) {
        ui.liteWarn = true;
      }
      prevNodes = totalN;
      prevBrain = state.brainMode;

      /* Kühlschrank-Automatik-Angebot: erscheint als Popup, sobald ein Dometic-
         Kühlschrank neu gewählt wird und die Automatik (tfridge) noch nicht aktiv ist. */
      var fridgeSelNow = byBereich('integration').some(function (i) { return i.cap === 'fridge' && on(i.id); });
      if (fridgeSelNow && !on('tfridge') && !ui.fridgeAutoDismissed && prevFridge === false) {
        ui.fridgeAutoOffer = true;
      }
      if (!fridgeSelNow) { ui.fridgeAutoOffer = false; ui.fridgeAutoDismissed = false; }
      prevFridge = fridgeSelNow;

      renderBar(lines);
      rBrain();
      rInteg(computed);
      rSchalter(computed);
      rLichter();
      rTank();
      rEnergie(computed);
      rTemp();
      rBewegung();
      rPanel();
      rEinbau(lines);
      renderInstallEstimate();
      renderCodeSlot();   // auch wenn rEinbau sein HTML aus dem Cache nimmt
      renderCodeTop();
      renderHome();
      renderModal(totalN);
      applyPanelFrame();
      updateScrollHint();

      if (state.install === 'partner' && !partnerViewTracked) {
        partnerViewTracked = true;
        track('config_partner_view', {});
      }

      var newInput = el('rvk-custom-label');
      if (newInput && draftVal != null) {
        newInput.value = draftVal;
        if (hadFocus) { try { newInput.focus(); newInput.setSelectionRange(draftVal.length, draftVal.length); } catch (e) {} }
      }
    }

    /* Bild-Fallback-Kette: error-Events bubbeln nicht → Capture-Phase */
    root.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var fb = img.getAttribute('data-fb');
      if (!fb) return;
      var list = fb.split('|').filter(Boolean);
      if (!list.length) { img.removeAttribute('data-fb'); return; }
      var next = list.shift();
      img.setAttribute('data-fb', list.join('|'));
      if (next.indexOf('!hasbg:') === 0) { next = next.slice(7); img.classList.add('has-bg'); }
      img.src = next;
    }, true);

    /* ── Event-Delegation ── */
    root.addEventListener('click', function (e) {
      var elAct = e.target.closest('[data-act]');
      if (!elAct || !root.contains(elAct)) return;
      var act = elAct.getAttribute('data-act');
      var id = elAct.getAttribute('data-id');
      var sektion = elAct.getAttribute('data-sektion') || '';
      switch (act) {
        case 'noop': e.stopPropagation(); break;
        case 'brain-lite':
          markStart(); state.brainMode = 'lite'; track('config_change', { sektion: 'brain', item: 'brain_lite', value: 1 }); update(); break;
        case 'brain-full':
          markStart(); state.brainMode = 'full'; track('config_change', { sektion: 'brain', item: 'brain', value: 1 }); update(); break;
        case 'brain-own': {
          // Umschalter: erneuter Klick hebt „vorhandenes BRAIN" auf → zurück zum Lite (Default)
          var ownOn = state.brainMode !== 'own';
          markStart(); state.brainMode = ownOn ? 'own' : 'lite';
          track('config_change', { sektion: 'brain', item: 'brain_own', value: ownOn ? 1 : 0 });
          update(); break;
        }
        case 'toggle': toggleDev(id, sektion); break;
        case 'counter-inc': {
          var mx = parseInt(elAct.getAttribute('data-max') || '99', 10);
          setSel(id, Math.min(mx, qty(id) + 1), sektion); break;
        }
        case 'counter-dec': setSel(id, Math.max(0, qty(id) - 1), sektion); break;
        case 'led-inc': case 'led-dec': {
          var kind = elAct.getAttribute('data-kind');
          var led = Object.assign({}, state.led);
          led[kind] = Math.max(0, (led[kind] || 0) + (act === 'led-inc' ? 1 : -1));
          state.led = led;
          markStart(); track('config_change', { sektion: 'lichter', item: 'led_' + kind, value: led[kind] });
          update(); break;
        }
        case 'sensor-toggle': {
          e.stopPropagation();
          var so = Object.assign({}, state.sensorOff);
          if (so[id]) delete so[id]; else so[id] = true;
          state.sensorOff = so;
          markStart(); track('config_change', { sektion: 'tank', item: 'sensor_' + id, value: so[id] ? 0 : 1 });
          update(); break;
        }
        case 'gas': {
          e.stopPropagation();
          var tc = Object.assign({}, state.tankCfg);
          tc[id] = Object.assign({}, tc[id], { gasType: elAct.getAttribute('data-type') });
          state.tankCfg = tc;
          markStart(); track('config_change', { sektion: 'tank', item: 'gas_' + elAct.getAttribute('data-type'), value: 1 });
          update(); break;
        }
        case 'bms': {
          var val = elAct.getAttribute('data-val');
          state.batBms = val;
          if (val === 'yes') state.batMode = null; else state.bmsBat = null;
          markStart(); track('config_change', { sektion: 'energie', item: 'bms_' + val, value: 1 });
          update(); break;
        }
        case 'bms-pick':
          state.bmsBat = state.bmsBat === id ? null : id;
          markStart(); track('config_change', { sektion: 'energie', item: id, value: state.bmsBat ? 1 : 0 });
          update(); break;
        case 'profinder': {
          var pv = elAct.getAttribute('data-val');
          state.thitronikProfinder = state.thitronikProfinder === pv ? null : pv;
          markStart(); track('config_change', { sektion: 'integrationen', item: 'profinder_' + pv, value: state.thitronikProfinder ? 1 : 0 });
          update(); break;
        }
        case 'force-single': {
          state.forceSingleSwitch = elAct.getAttribute('data-val') === 'single';
          markStart(); track('config_change', { sektion: 'schalter', item: 'force_single', value: state.forceSingleSwitch ? 1 : 0 });
          update(); break;
        }
        case 'batmode':
          state.batMode = state.batMode === id ? null : id;
          markStart(); track('config_change', { sektion: 'energie', item: 'batmode_' + id, value: state.batMode ? 1 : 0 });
          update(); break;
        case 'tempsens-inc': case 'tempsens-dec': {
          var n = E.tempCapCount(CAT, state);
          var cur = E.tempSensorQty(CAT, state);
          var next = Math.max(0, Math.min(n, cur + (act === 'tempsens-inc' ? 1 : -1)));
          state.tempSensorOv = next;
          markStart(); track('config_change', { sektion: 'temp', item: 'temp_sensor', value: next });
          update(); break;
        }
        case 'panel-pick': {
          var size = elAct.getAttribute('data-size');
          state.panel = state.panel === size ? null : size;
          markStart(); track('config_change', { sektion: 'panel', item: 'panel_' + size, value: state.panel ? 1 : 0 });
          update(); break;
        }
        case 'install-self':
          state.install = 'self';
          markStart(); track('config_change', { sektion: 'einbau', item: 'self', value: 1 });
          update(); break;
        case 'install-partner':
          state.install = 'partner';
          ui.instAnim = null;   // Kostenvoranschlag beim Klick jedes Mal neu „berechnen" (Animation)
          markStart(); track('config_change', { sektion: 'einbau', item: 'partner', value: 1 });
          update(); break;
        case 'inst-how': ui.instHow = !ui.instHow; renderInstallEstimate(true); break;
        case 'line-inc': case 'line-dec': {
          var key = elAct.getAttribute('data-key');
          var req = parseInt(elAct.getAttribute('data-req') || '0', 10);
          var ov = Object.assign({}, state.ov);
          var curQ = E.effQty(state, key, req);
          var nextQ = Math.max(req, curQ + (act === 'line-inc' ? 1 : -1));
          if (nextQ === req) delete ov[key]; else ov[key] = nextQ;
          state.ov = ov;
          markStart(); track('config_change', { sektion: 'details', item: key, value: nextQ });
          update(); break;
        }
        case 'add-open': ui.adding = elAct.getAttribute('data-cat'); ui.draftIcon = 'X_Device_Fan'; render(); break;
        case 'add-cancel': ui.adding = null; render(); break;
        case 'icon-pick': ui.draftIcon = elAct.getAttribute('data-icon'); render(); break;
        case 'add-confirm': {
          var cat = elAct.getAttribute('data-cat');
          var inp = el('rvk-custom-label');
          var label = (inp && inp.value.trim()) || t('custom_form_title_' + cat);
          var cid = 'cust_' + cat + '_' + (++custCounter);
          var custom = Object.assign({}, state.custom);
          custom[cat] = (custom[cat] || []).concat([{ id: cid, label: label, icon: ui.draftIcon }]);
          state.custom = custom;
          var sel = Object.assign({}, state.sel);
          sel[cid] = 1;
          state.sel = sel;
          ui.adding = null;
          markStart(); track('config_change', { sektion: cat, item: 'custom', value: 1 });
          update(); break;
        }
        case 'info': ui.info = { type: 'key', key: elAct.getAttribute('data-key') }; e.stopPropagation(); render(); break;
        case 'item-info': ui.info = { type: 'item', id: id }; e.stopPropagation(); render(); break;
        case 'info-close': ui.info = null; render(); break;
        case 'lite-close': ui.liteWarn = false; render(); break;
        case 'fridge-auto-later': ui.fridgeAutoOffer = false; ui.fridgeAutoDismissed = true; render(); break;
        case 'fridge-auto-add':
          ui.fridgeAutoOffer = false; ui.fridgeAutoDismissed = true;
          setSel('tfridge', 1, 'integrationen');
          break;
        case 'lite-switch':
          ui.liteWarn = false; state.brainMode = 'full';
          track('config_change', { sektion: 'brain', item: 'brain', value: 1 });
          update(); break;
        case 'bar-toggle':
          ui.barOpen = !ui.barOpen;
          if (ui.barOpen && assistS && ++assistS.details >= 2) assistS.weak.price_check = 1;
          render(); break;
        case 'cta':
          if (state.install === 'self') addToCart();
          else scrollToEinbau();
          break;
        case 'cart': addToCart(); break;
        case 'pp-modal': ppShowModal(); break;
        case 'pdf': handoverPrint(); break;
        case 'cfg-save':
        case 'cfg-save-new': {
          if (codeBusy) break;
          var asNew = act === 'cfg-save-new';
          if (!asNew && savedCode && ui.codeRemote) {
            var okR = true;
            try { okR = window.confirm(t('code_remote_confirm')); } catch (err) { okR = true; }
            if (!okR) break;
          }
          ui.codeMsg = 'saving'; ui.codeFlash = null; renderCodeSlot(); renderBarCode();
          saveConfig(function (ok, info) {
            info = info || {};
            ui.codeCopied = false;
            // „Aktualisiert" nur, wenn der Stand seit dem Absenden NICHT schon wieder geändert
            // wurde — sonst stünde „Aktualisiert" neben dem Button „Konfiguration aktualisieren".
            ui.codeMsg = ok ? (info.replaced ? 'replaced' : (info.updated && !codeStale() ? 'updated' : null)) : (info.kind === 'ratelimit' ? 'ratelimit' : 'error');
            renderCodeSlot(); renderBarCode(); renderCodeTop();
            if (ok && info.updated && !info.replaced) setTimeout(function () { if (ui.codeMsg === 'updated') { ui.codeMsg = null; renderCodeSlot(); } }, 5000);
          }, asNew);
          break;
        }
        case 'cfg-load-remote': {
          if (codeBusy || !savedCode) break;
          if (codeStale()) {
            var okL = true;
            try { okL = window.confirm(t('code_load_confirm')); } catch (err) { okL = true; }
            if (!okL) break;
          }
          ui.codeMsg = null; renderCodeSlot();
          loadByCode(savedCode, function (ok2) {
            if (!ok2) { ui.codeMsg = 'error'; renderCodeSlot(); return; }
            ui.codeRemote = null; ui.codeFlash = savedCode; ui.adding = null; ui.info = null; ui.liteWarn = false;
            render();
            var flashedR = savedCode;
            setTimeout(function () { if (ui.codeFlash === flashedR) { ui.codeFlash = null; renderCodeTop(); } }, 7000);
          });
          break;
        }
        case 'cfg-load-open': ui.codeLoad = 'open'; ui.codeFlash = null; renderCodeTop(); break;
        case 'cfg-load-close': ui.codeLoad = null; ui.codeLoadDraft = ''; renderCodeTop(); break;
        case 'cfg-load': codeLoadSubmit(); break;
        case 'cfg-copy':
        case 'cfg-copy-link': {
          if (!savedCode) break;
          var isLink = act === 'cfg-copy-link';
          var text = savedCode;
          if (isLink) {
            try {
              var lu = new URL(window.location.href);
              lu.hash = ''; lu.searchParams.set('code', savedCode);
              text = lu.toString();
            } catch (err2) { text = savedCode; }
          }
          var mark = function () {
            ui.codeCopied = isLink ? 'link' : 'code';
            renderCodeSlot();
            setTimeout(function () { ui.codeCopied = false; renderCodeSlot(); }, 2200);
          };
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(text).then(mark, function () {});
            } else {
              var ta = document.createElement('textarea');
              ta.value = text; ta.style.cssText = 'position:fixed;opacity:0;';
              document.body.appendChild(ta); ta.select();
              document.execCommand('copy'); document.body.removeChild(ta); mark();
            }
          } catch (err) {}
          break;
        }
        case 'reset': {
          var ok = true;
          try { ok = window.confirm(t('reset_confirm')); } catch (err) { ok = true; }
          if (!ok) break;
          state = E.initialState();
          ui.adding = null; ui.info = null; ui.liteWarn = false; ui.barOpen = false;
          try { localStorage.removeItem(STORAGE_KEY); } catch (err) {}
          clearCodeMeta();   // neue Konfiguration = kein aktiver Code (der alte bleibt im Worker gültig)
          ui.codeMsg = null; ui.codeLoad = null; ui.codeFlash = null;
          track('config_reset', {});
          render();
          break;
        }
        case 'preview-open': expandPhone(); break;
        case 'preview-close': collapsePhone(); break;
        case 'fullscreen': togglePhone(); break;
      }
    });

    /* Phone-Widget antippen → DS-Dialog öffnen (Nicht-Steuerelemente öffnen,
       live Steuerelemente behalten ihre eigene Funktion — Muster wie cfg-island). */
    root.addEventListener('click', function (e) {
      if (e.target.closest('.rv-sheet-overlay')) return;
      var home = el('rvk-home');
      if (!home) return;
      var tile = e.target.closest('[data-dlg]');
      if (!tile || !home.contains(tile)) return;
      if (e.target.closest('.toggle, .slider, .dd-trigger, .dd-menu, .dd-option, input, a[href], .rvk-range')) return;
      var dlgKey = tile.getAttribute('data-dlg');
      var fn = dlgData[dlgKey];
      if (fn) { var spec = fn(); if (spec) { openSheet(spec);
        /* Welches Widget-Popup erkundet der Nutzer? Semantischer Typ aus der Tile-Klasse
           (data-dlg ist index-basiert), damit die Auswertung sprechend ist. */
        try {
          var wm = String(tile.className || '').match(/\bw-(switch|level|temp|battery|ambient|light)\b/);
          var wtype = wm ? wm[1] : (/\brvk-ds\b/.test(tile.className) ? 'integration' : dlgKey);
          track('config_dialog', { item: wtype, dlg: dlgKey });
        } catch (e) {}
      } }
    });

    /* Tank-Höhen-Slider (change = Raststufe gesetzt, input = Label live) */
    root.addEventListener('change', function (e) {
      var amp = e.target.closest('input.rvk-amp[data-amp]');
      if (amp) {
        var v = Math.max(0, Math.min(200, parseInt(amp.value, 10) || 0));
        state.boosterAmp = v;
        markStart(); track('config_change', { sektion: 'energie', item: 'booster_amp', value: v });
        update();
        return;
      }
      var inp = e.target.closest('input.rvk-range[data-tank]');
      if (!inp) return;
      var idT = inp.getAttribute('data-tank');
      var tc = Object.assign({}, state.tankCfg);
      tc[idT] = Object.assign({}, tc[idT], { step: Math.max(0, Math.min(2, parseInt(inp.value, 10) || 0)) });
      state.tankCfg = tc;
      markStart(); track('config_change', { sektion: 'tank', item: 'step_' + idT, value: tc[idT].step });
      update();
    });

    /* Dropdowns im Phone: Klick außerhalb schließt */
    document.addEventListener('click', function () {
      root.querySelectorAll('#rvk-home .dd[data-open="true"]').forEach(function (d) { d.setAttribute('data-open', 'false'); });
    });

    /* ── Beratungs-Karte: Zögern erkennen (A/B-Test, siehe ASSIST) ──
       Stark (eines reicht): 45 s ohne jede Eingabe nach dem Start · BRAIN-Wahl ≥ 3× geändert ·
       dasselbe Gerät rein-raus-rein · Einbau erreicht und 30 s kein Weiter · „Einbauen lassen".
       Schwach (zwei nötig): ≥ 3 Popups · Artikelliste ≥ 2× · Auf-und-ab-Scrollen ohne Klick ·
       unklare Option · Wiederkehrer · Maus verlässt das Fenster nach oben · 60 s ohne Start.
       Sperren: frühestens nach 40 s, einmal pro Besuch, nicht bei offenem Dialog/Eingabefeld,
       nicht nach „In den Warenkorb", 14 Tage Ruhe nach „Nein danke", 30 Tage nach Terminklick. */
    function assistSetup() {
      if (!ASSIST) return;
      try { if (sessionStorage.getItem('rvk_assist_done')) return; } catch (e) {}
      var mute = 0;
      try { mute = +localStorage.getItem('rvk_assist_mute') || 0; } catch (e) {}
      if (mute > Date.now()) return;
      var visits = 1;
      try {
        if (!sessionStorage.getItem('rvk_visit_counted')) {
          visits = (+localStorage.getItem('rvk_visits') || 0) + 1;
          localStorage.setItem('rvk_visits', String(visits));
          sessionStorage.setItem('rvk_visit_counted', '1');
        } else visits = +localStorage.getItem('rvk_visits') || 1;
      } catch (e) {}
      assistS = { t0: Date.now(), last: Date.now(), inputs: 0, strong: null, weak: {}, items: {}, brainSw: 0,
        dialogs: 0, details: 0, einbauAt: 0, partnerAt: 0, lastY: window.scrollY || 0, dir: 0, rev: [], done: false };
      if (visits >= 2) assistS.weak.return_visit = 1;
      ['pointerdown', 'keydown'].forEach(function (evn) {
        document.addEventListener(evn, function () {
          if (!assistS) return;
          assistS.inputs++; assistS.rev = []; assistS.last = Date.now();
        }, { passive: true, capture: true });
      });
      window.addEventListener('scroll', function () {
        if (!assistS) return;
        var y = window.scrollY || 0;
        if (Math.abs(y - assistS.lastY) > 40) {   // nur echte Bewegungen, kein Zittern
          var d = y > assistS.lastY ? 1 : -1;
          if (assistS.dir && d !== assistS.dir) {
            var n = Date.now();
            assistS.rev.push(n);
            assistS.rev = assistS.rev.filter(function (x) { return n - x < 30000; });
            if (assistS.rev.length >= 4) assistS.weak.scroll_search = 1;
          }
          assistS.dir = d; assistS.lastY = y;
        }
        assistS.last = Date.now();
      }, { passive: true });
      if (window.matchMedia && window.matchMedia('(pointer:fine)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (!assistS || e.relatedTarget || e.clientY > 0 || assistS.inputs < 2) return;
          assistS.weak.exit_intent = 1;
          assistTick();
        });
      }
      setInterval(assistTick, 5000);
      /* Nur mit ?rvk_assist=…: Zeit vorspulen, um die Karte ohne Warten zu prüfen */
      if (/[?&]rvk_assist=/.test(location.search)) {
        window.__rvkAssistSkip = function (sec) { assistS.t0 -= sec * 1000; assistS.last -= sec * 1000; assistTick(); return assistS.done; };
      }
    }
    function assistObserve(ev, data) {
      if (!assistS || assistS.done) return;
      if (ev === 'config_add_to_cart') { assistS.done = true; return; }
      if (ev === 'config_change') {
        if (data.sektion === 'brain') {
          if (++assistS.brainSw >= 3) assistS.strong = assistS.strong || 'brain_flipflop';
        } else if (data.item != null) {
          var k = (data.sektion || '') + ':' + data.item, on = !!data.value;
          var it = assistS.items[k] || (assistS.items[k] = { on: null, flips: 0 });
          if (it.on !== null && it.on !== on) it.flips++;
          it.on = on;
          if (it.flips >= 2) assistS.strong = assistS.strong || 'flipflop';   // rein, raus, wieder rein
        }
        if (data.sektion === 'einbau' && data.item === 'partner') assistS.partnerAt = Date.now();
        if (data.item === 'bms_canbms' && data.value) assistS.weak.unsure_option = 1;
      } else if (ev === 'config_section' && data.sektion === 'einbau') {
        if (!assistS.einbauAt) assistS.einbauAt = Date.now();
      } else if (ev === 'config_dialog') {
        if (++assistS.dialogs >= 3) assistS.weak.research = 1;
      }
    }
    function assistTick() {
      if (!assistS || assistS.done) return;
      if (convFlags.cart) { assistS.done = true; return; }
      var now = Date.now(), age = now - assistS.t0, idle = now - assistS.last;
      if (!started && age >= 60000) assistS.weak.idle_no_start = 1;
      var trig = assistS.strong;
      if (!trig && started && idle >= 45000) trig = 'idle';
      if (!trig && assistS.einbauAt && now - assistS.einbauAt >= 30000 && idle >= 15000) trig = 'end_hesitation';
      if (!trig && assistS.partnerAt && now - assistS.partnerAt >= 10000) trig = 'install_partner';
      var weak = Object.keys(assistS.weak).sort();
      if (!trig && weak.length >= 2) trig = 'weak';
      if (!trig || age < 40000) return;
      if (document.visibilityState && document.visibilityState !== 'visible') return;
      if (document.querySelector('#rvk-sheet .rv-sheet-overlay.open') || ui.liteWarn || ui.info) return;
      var ae = document.activeElement;
      if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return;
      assistS.done = true;
      try { sessionStorage.setItem('rvk_assist_done', '1'); } catch (e) {}
      var info = { variant: ASSIST, trigger: trig, signals: weak, dwell: Math.round(age / 1000), idle: Math.round(idle / 1000) };
      if (ASSIST === 'card') { assistShow(trig); track('config_assist', Object.assign({ action: 'shown' }, info)); }
      else track('config_assist', Object.assign({ action: 'eligible' }, info));
    }
    function assistShow(trig) {
      var lang = String(SET.locale || 'de').slice(0, 2);
      var base = 'https://meet.revotion.io/?ct=endkunde&kind=beratung&quelle=konfigurator&utm_source=konfigurator' +
        '&utm_medium=assist&utm_campaign=assist-ab-2026-10&utm_content=' + encodeURIComponent(trig) + (lang === 'de' ? '' : '&lang=en');
      var el = document.createElement('div');
      el.className = 'rvk-assist';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', t('assist_title'));
      /* Die Karte hängt am body (kein transformierter Vorfahre) → Schrift/Farben des Konfigurators mitnehmen */
      try {
        var cs = getComputedStyle(root);
        ['--font-heading', '--font-body', '--color-text', '--color-muted'].forEach(function (v) {
          var x = cs.getPropertyValue(v); if (x && x.trim()) el.style.setProperty(v, x.trim());
        });
      } catch (e) {}
      el.innerHTML =
        '<button type="button" class="rvk-assist-x" data-assist="dismiss" aria-label="' + esc(t('assist_no')) + '">&times;</button>' +
        '<img class="rvk-assist-face" src="' + esc(AB + '/assist/sven.jpg') + '" alt="" width="52" height="52">' +
        '<div class="rvk-assist-body">' +
          '<div class="rvk-assist-title">' + esc(t('assist_title')) + '</div>' +
          '<div class="rvk-assist-sub">' + esc(t('assist_sub')) + '</div>' +
          '<div class="rvk-assist-acts">' +
            '<a class="rvk-assist-cta" data-assist="click" href="' + esc(base) + '" target="_blank" rel="noopener">' + esc(t('assist_cta')) + '</a>' +
            '<button type="button" class="rvk-assist-no" data-assist="dismiss">' + esc(t('assist_no')) + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      var hover = false, timer = null, live = true;
      function shut(action) {
        if (!live) return;
        live = false; clearTimeout(timer);
        document.removeEventListener('keydown', onEsc);
        el.classList.remove('in');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
        if (action) track('config_assist', { action: action, variant: ASSIST, trigger: trig });
      }
      function mute(days) { try { localStorage.setItem('rvk_assist_mute', String(Date.now() + days * 864e5)); } catch (e) {} }
      function onEsc(e) { if (e.key === 'Escape' || e.keyCode === 27) { mute(14); shut('dismiss'); } }
      function arm() { clearTimeout(timer); timer = setTimeout(function () { if (hover) arm(); else shut('timeout'); }, 25000); }
      el.addEventListener('pointerenter', function () { hover = true; });
      el.addEventListener('pointerleave', function () { hover = false; });
      el.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-assist]') : null;
        if (!a) return;
        if (a.getAttribute('data-assist') === 'dismiss') { mute(14); shut('dismiss'); return; }
        mute(30);
        /* Konfiguration als Code sichern und mitgeben (landet in der Buchung als utm_term) */
        var has = Object.keys(state.sel || {}).length > 0 || state.brainMode !== 'lite' || state.panel != null;
        if (has && CONFIG_API) {
          e.preventDefault();
          var w = null;
          try { w = window.open('about:blank', '_blank'); } catch (x) {}
          var fired = false;
          var go = function (code) {
            if (fired) return; fired = true;
            var u = base + (code ? '&utm_term=' + encodeURIComponent(code) : '');
            if (w && !w.closed) { try { w.opener = null; } catch (x) {} w.location.href = u; }
            else window.location.href = u;
          };
          setTimeout(function () { go(savedCode || ''); }, 3500);
          saveConfig(function (ok, d) { go(ok && d && d.code ? d.code : (savedCode || '')); });
        }
        shut('click');
      });
      document.addEventListener('keydown', onEsc);
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('in'); }); });
      arm();
    }
    assistSetup();

    /* Sektion erreicht → config_section (einmalig) */
    if ('IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio >= 0.35) {
            var sek = en.target.getAttribute('data-sek');
            if (sek && !seen[sek]) {
              seen[sek] = true;
              track('config_section', { sektion: sek });
            }
          }
        });
      }, { threshold: [0.35] });
      root.querySelectorAll('.rvk-sec[data-sek]').forEach(function (s) { io.observe(s); });
    }

    /* ── Verlassen/Abbruch erfassen ── */
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { flushJourney(); sendExit(); } });
    window.addEventListener('pagehide', function () { flushJourney(); sendExit(); });

    /* ── Start ── */
    var restored = loadState();
    var hadStored = false;
    try { hadStored = !!localStorage.getItem(STORAGE_KEY); } catch (e) {}
    loadCodeMeta();
    // Code-Bindung nur lösen, wenn gar keine lokale Konfiguration existiert. `restored`
    // reicht nicht: „BRAIN Lite + Einbauen lassen" gilt dort als leer (F2).
    if (!hadStored && savedCode) clearCodeMeta();
    bindPeekDrag();
    render();
    if (restored) track('config_restore', {});

    /* Code-Eingabefeld: Enter lädt, Escape schließt; Entwurf bleibt über Re-Renders erhalten. */
    root.addEventListener('keydown', function (e) {
      if (!e.target || e.target.id !== 'rvk-code-input') return;
      if (e.key === 'Enter') { e.preventDefault(); codeLoadSubmit(); }
      else if (e.key === 'Escape') { ui.codeLoad = null; ui.codeLoadDraft = ''; renderCodeTop(); }
    });
    root.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'rvk-code-input') ui.codeLoadDraft = e.target.value;
    });

    /* Konfigurations-Code aus dem Link (?code=R-XXXXX, alt RVT-XXXX-XXXX).
       WICHTIG — das ist KEINE Config aus der URL: die URL trägt nur den streng
       formatgeprüften SCHLÜSSEL, die Konfiguration selbst kommt aus unserem
       Worker und läuft vor der Übernahme durch sanitizeState(). Eine manipulierte
       URL kann damit keine fremden Artikel oder Mengen ins System schreiben.
       Ungültige/unbekannte Codes melden sich oben im Laden-Feld (F5); ein eigener,
       noch nicht gesicherter Stand wird nicht ohne Rückfrage ersetzt (F4). */
    (function () {
      if (!CONFIG_API) return;
      var q;
      try { q = new URLSearchParams(window.location.search).get('code'); } catch (e) { return; }
      if (!q) { checkRemoteUpdate(); return; }
      var stripParam = function () {
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete('code');
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      };
      var wanted = normalizeCode(q);
      if (!wanted) { ui.codeLoad = { error: 'format' }; ui.codeLoadDraft = String(q).slice(0, 14); codeTopSig = null; renderCodeTop(); stripParam(); return; }
      if (wanted !== savedCode && hasSelection() && (!savedCode || codeStale())) {
        var okQ = true;
        try { okQ = window.confirm(t('code_load_confirm')); } catch (e) { okQ = true; }
        if (!okQ) { stripParam(); checkRemoteUpdate(); return; }
      }
      ui.codeLoad = 'busy'; renderCodeTop();
      loadByCode(wanted, function (ok, data, kind) {
        stripParam();
        if (!ok) { ui.codeLoad = { error: kind || 'error' }; ui.codeLoadDraft = wanted; codeTopSig = null; renderCodeTop(); return; }
        ui.codeLoad = null; ui.codeLoadDraft = ''; ui.codeMsg = null; ui.codeFlash = savedCode;
        ui.adding = null; ui.info = null; ui.liteWarn = false;
        render();
        var flashed = savedCode;
        setTimeout(function () { if (ui.codeFlash === flashed) { ui.codeFlash = null; renderCodeTop(); } }, 7000);
      });
    })();
  }
})();
